var _path, _path2, _path3, _path4, _g, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatacenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_2_",
    style: {
      fill: "#FAFAFA"
    },
    cx: 250,
    cy: 350.79,
    rx: 242.03,
    ry: 139.73
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_37_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M128.07,414.33l119.76,69.18c2.77,1.6,7.25,1.6,10.02,0l182.98-105.64 c2.77-1.6,2.77-4.19,0-5.79L321.07,302.9c-2.77-1.6-7.25-1.6-10.02,0L128.07,408.55C125.31,410.14,125.31,412.73,128.07,414.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_18_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M156.56,348.56l-61.17,35.29c-1.47,0.85-3.85,0.85-5.31,0l-61.09-35.29 c-1.47-0.85-1.47-2.22,0-3.07l61.17-35.29c1.47-0.85,3.85-0.85,5.31,0l61.09,35.29C158.03,346.34,158.03,347.72,156.56,348.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_24_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M259.51,289.17l-61.96,35.75c-1.49,0.86-3.89,0.86-5.38,0l-61.88-35.75 c-1.49-0.86-1.49-2.25,0-3.11l61.96-35.75c1.49-0.86,3.89-0.86,5.38,0l61.88,35.75C261,286.93,261,288.32,259.51,289.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4039_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4044_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4045_",
    style: {
      fill: "#BA68C8"
    },
    d: "M328.7,313.01l-6.42-3.71c0,0-3.82-15.89-2.3-30.18 c2.14-20.1,15.37-27.66,20.4-25.93c5.03,1.73,6.49,7.58-1.84,19.55C333.63,279.8,327.6,294.51,328.7,313.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4042_",
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4043_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.7,313.01l-6.42-3.71c0,0-3.82-15.89-2.3-30.18 c2.14-20.1,15.37-27.66,20.4-25.93c5.03,1.73,6.49,7.58-1.84,19.55C333.63,279.8,327.6,294.51,328.7,313.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4040_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4041_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M326.04,305.2c0.02,0,0.04,0,0.06-0.01c0.24-0.05,0.4-0.28,0.35-0.52 c-3.52-18.54,2.95-39.37,10.97-48.03c0.17-0.18,0.16-0.46-0.02-0.63c-0.18-0.17-0.46-0.16-0.63,0.02 c-8.16,8.83-14.77,29.99-11.19,48.8C325.62,305.06,325.82,305.21,326.04,305.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1411_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4037_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4038_",
    style: {
      fill: "#BA68C8"
    },
    d: "M345.81,323.09c0.96,0.49,3.51-1.7,4.22-2.23c1.22-0.91,2.18-2.16,2.79-3.55 c0.71-1.62,0.82-3.32,0.49-5.05c-0.17-0.9-0.47-1.77-0.77-2.63c-0.29-0.85-0.58-1.7-0.87-2.55c-0.29-0.84-0.58-1.71-0.51-2.59 c0.14-1.78,1.64-3.1,3.02-4.24c1.52-1.26,3.08-2.9,2.97-5.03c-0.09-1.64-1.02-3.12-2.1-4.36c-1.08-1.24-2.35-2.32-3.34-3.63 c-0.71-0.95-1.29-2.07-1.24-3.25c0.03-0.73,0.3-1.44,0.62-2.1c0.68-1.42,1.61-2.74,2.05-4.26c0.44-1.52,0.28-3.36-0.94-4.37 c-1-0.83-2.42-0.88-3.71-0.73c-1.19,0.14-2.33,0.74-3.35,1.37c-3.28,2.05-5.01,6.15-8.53,7.78c-1.36,0.63-2.86,0.83-4.29,1.28 c-1.42,0.45-2.86,1.26-3.46,2.63c-1.18,2.7,1.42,5.81,0.64,8.65c-0.69,2.51-3.05,3.58-4.28,5.87c-0.54,1-0.62,2.14-0.47,3.27 c0.26,1.91,0.61,3.31,1.64,5.4c0.85,1.73,3.24,4.99,3.24,4.99S345.67,323.01,345.81,323.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4035_",
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4036_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.81,323.09c0.96,0.49,3.51-1.7,4.22-2.23c1.22-0.91,2.18-2.16,2.79-3.55 c0.71-1.62,0.82-3.32,0.49-5.05c-0.17-0.9-0.47-1.77-0.77-2.63c-0.29-0.85-0.58-1.7-0.87-2.55c-0.29-0.84-0.58-1.71-0.51-2.59 c0.14-1.78,1.64-3.1,3.02-4.24c1.52-1.26,3.08-2.9,2.97-5.03c-0.09-1.64-1.02-3.12-2.1-4.36c-1.08-1.24-2.35-2.32-3.34-3.63 c-0.71-0.95-1.29-2.07-1.24-3.25c0.03-0.73,0.3-1.44,0.62-2.1c0.68-1.42,1.61-2.74,2.05-4.26c0.44-1.52,0.28-3.36-0.94-4.37 c-1-0.83-2.42-0.88-3.71-0.73c-1.19,0.14-2.33,0.74-3.35,1.37c-3.28,2.05-5.01,6.15-8.53,7.78c-1.36,0.63-2.86,0.83-4.29,1.28 c-1.42,0.45-2.86,1.26-3.46,2.63c-1.18,2.7,1.42,5.81,0.64,8.65c-0.69,2.51-3.05,3.58-4.28,5.87c-0.54,1-0.62,2.14-0.47,3.27 c0.26,1.91,0.61,3.31,1.64,5.4c0.85,1.73,3.24,4.99,3.24,4.99S345.67,323.01,345.81,323.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4022_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4023_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M336.52,318.24c0.01,0,0.01,0,0.01,0c0.24-0.02,0.41-0.23,0.39-0.46 c-1.54-16.67,5.4-35.51,10.86-41.16c0.16-0.17,0.16-0.43-0.01-0.6c-0.17-0.16-0.43-0.16-0.6,0.01 c-5.56,5.76-12.65,24.92-11.09,41.82C336.1,318.08,336.29,318.25,336.52,318.24z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4020_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4021_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M338.17,297.68c0.04,0,0.08-0.01,0.12-0.03c5.28-1.93,11.96-2.56,12.03-2.57 c0.23-0.02,0.4-0.23,0.38-0.46c-0.02-0.23-0.21-0.41-0.46-0.38c-0.07,0.01-6.85,0.65-12.24,2.61c-0.22,0.08-0.33,0.32-0.25,0.54 C337.82,297.58,337.99,297.69,338.17,297.68z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Server_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Server_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8066_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M200.63,101.68l49.77,28.74c0.92,0.53,1.66,1.82,1.66,2.88v151.16 c0,1.06-0.75,2.35-1.66,2.88l-53.83,31.08c-0.92,0.53-2.41,0.53-3.33,0l-49.77-28.74c-0.92-0.53-1.66-1.82-1.66-2.88V135.64 c0-1.06,0.75-2.35,1.66-2.88l53.83-31.08C198.22,101.14,199.71,101.14,200.63,101.68z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8063_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M141.81,135.64V286.8c0,1.06,0.75,2.35,1.66,2.88l49.78,28.74 c0.45,0.27,1.06,0.4,1.66,0.4V163.81c-0.6,0-1.2-0.14-1.66-0.4l-49.78-28.74l-0.45-0.38l-0.59-0.49 C142.04,134.38,141.81,135.04,141.81,135.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M143.47,132.76l53.83-31.08c0.92-0.53,2.41-0.53,3.33,0l49.77,28.74 c0.92,0.53,0.92,1.39,0,1.92l-53.83,31.08c-0.92,0.53-2.41,0.53-3.33,0l-49.77-28.74 C142.55,134.15,142.55,133.29,143.47,132.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M198.97,101.28c0.6,0,1.21,0.13,1.66,0.4l49.77,28.74c0.92,0.53,0.92,1.39,0,1.92 l-53.83,31.08c-0.46,0.27-1.06,0.4-1.67,0.4c-0.6,0-1.21-0.13-1.66-0.4l-49.77-28.74c-0.92-0.53-0.92-1.39,0-1.92l53.83-31.08 C197.76,101.41,198.37,101.28,198.97,101.28 M198.97,100.35c-0.79,0-1.55,0.19-2.13,0.52L143,131.95 c-0.73,0.42-1.16,1.07-1.16,1.77c0,0.7,0.42,1.34,1.16,1.77l49.77,28.74c0.58,0.34,1.34,0.52,2.13,0.52 c0.79,0,1.55-0.19,2.13-0.52l53.83-31.08c0.73-0.42,1.16-1.07,1.16-1.77c0-0.7-0.42-1.34-1.15-1.77l-49.77-28.74 C200.51,100.53,199.76,100.35,198.97,100.35L198.97,100.35z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8029_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8057_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M187.1,166.44c-1.73-1-3.12-0.09-3.12,2.03l0,76.33c0,2.12,1.4,4.66,3.12,5.66 c1.73,1,3.12,0.09,3.12-2.03l0-76.33C190.22,169.97,188.82,167.44,187.1,166.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8056_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M187.09,248.63c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56 c0-1.06,0.7-1.52,1.56-1.02c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C188.66,248.67,187.96,249.13,187.09,248.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3598_",
    style: {
      opacity: 0.15
    },
    d: "M187.09,248.63c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56 c0-1.06,0.7-1.52,1.56-1.02c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C188.66,248.67,187.96,249.13,187.09,248.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8055_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M187.09,248.63c-0.86-0.5-1.56-1.76-1.56-2.82l0-37.41l3.12,1.8l0,37.41 C188.66,248.67,187.96,249.13,187.09,248.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8052_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M177.72,161.03c-1.73-1-3.12-0.09-3.12,2.03l0,76.33c0,2.12,1.4,4.66,3.12,5.66 c1.73,1,3.12,0.09,3.12-2.03l0-76.33C180.85,164.56,179.45,162.03,177.72,161.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8051_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M177.72,243.22c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56 c0-1.06,0.7-1.52,1.56-1.02c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C179.29,243.26,178.59,243.72,177.72,243.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8045_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M168.35,155.62c-1.73-1-3.12-0.09-3.12,2.03l0,76.33c0,2.12,1.4,4.66,3.12,5.66 c1.73,1,3.12,0.09,3.12-2.03l0-76.33C171.48,159.15,170.08,156.62,168.35,155.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8044_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M168.35,237.81c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56 c0-1.06,0.7-1.52,1.56-1.02c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C169.91,237.85,169.22,238.31,168.35,237.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3604_",
    style: {
      opacity: 0.15
    },
    d: "M168.35,237.81c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56 c0-1.06,0.7-1.52,1.56-1.02c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C169.91,237.85,169.22,238.31,168.35,237.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8043_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M168.35,237.81c-0.86-0.5-1.56-1.76-1.56-2.82l0-55.59l3.12,1.8l0,55.59 C169.91,237.85,169.22,238.31,168.35,237.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8040_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M158.98,150.21c-1.73-1-3.12-0.09-3.12,2.03l0,76.33c0,2.12,1.4,4.66,3.12,5.66 c1.73,1,3.12,0.09,3.12-2.03l0-76.33C162.11,153.74,160.71,151.21,158.98,150.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8039_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M158.98,232.4c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56c0-1.06,0.7-1.52,1.56-1.02 c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C160.54,232.44,159.84,232.9,158.98,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3605_",
    style: {
      opacity: 0.15
    },
    d: "M158.98,232.4c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56c0-1.06,0.7-1.52,1.56-1.02 c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C160.54,232.44,159.84,232.9,158.98,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8037_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M158.98,232.4c-0.86-0.5-1.56-1.76-1.56-2.82l0-13.96l3.12,1.8l0,13.96 C160.54,232.44,159.84,232.9,158.98,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8034_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M149.61,144.8c-1.73-1-3.12-0.09-3.12,2.03l0,76.33c0,2.12,1.4,4.66,3.12,5.66 c1.73,1,3.12,0.09,3.12-2.03l0-76.33C152.74,148.33,151.34,145.8,149.61,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8033_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M149.61,226.99c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56 c0-1.06,0.7-1.52,1.56-1.02c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C151.17,227.03,150.47,227.49,149.61,226.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3640_",
    style: {
      opacity: 0.15
    },
    d: "M149.61,226.99c-0.86-0.5-1.56-1.76-1.56-2.82l0-76.56 c0-1.06,0.7-1.52,1.56-1.02c0.86,0.5,1.56,1.76,1.56,2.82l0,76.56C151.17,227.03,150.47,227.49,149.61,226.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8032_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M149.61,226.99c-0.86-0.5-1.56-1.76-1.56-2.82l0-41.01l3.12,1.8l0,41.01 C151.17,227.03,150.47,227.49,149.61,226.99z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Server_4_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8028_",
    d: "M153.35,289.86c0.41,0.24,0.74,0.81,0.74,1.28c0,0.47-0.33,0.66-0.74,0.43 c-0.41-0.24-0.74-0.81-0.74-1.28S152.95,289.62,153.35,289.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.49,293.41c0.41,0.23,0.73,0.8,0.73,1.27c0,0.47-0.33,0.66-0.73,0.42c-0.41-0.23-0.73-0.8-0.73-1.27 C158.76,293.36,159.09,293.17,159.49,293.41z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.53,296.89c0.4,0.23,0.73,0.8,0.73,1.27c0,0.47-0.33,0.66-0.73,0.42c-0.4-0.23-0.73-0.8-0.73-1.27 C164.8,296.85,165.12,296.66,165.53,296.89z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8027_",
    d: "M171.61,300.41c0.4,0.23,0.73,0.8,0.73,1.26c0,0.46-0.33,0.65-0.73,0.42c-0.4-0.23-0.73-0.8-0.73-1.26 S171.21,300.18,171.61,300.41z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7982_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8010_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.37,191.95c-0.27,0-0.53-0.07-0.76-0.2c-0.53-0.3-0.82-0.91-0.82-1.69v-3.93 c0-1.42,0.96-3.09,2.19-3.8l28.91-16.69c0.68-0.39,1.35-0.44,1.88-0.14c0.53,0.31,0.82,0.91,0.82,1.69l0,3.93 c0,1.42-0.96,3.09-2.19,3.8l-28.91,16.69C215.1,191.84,214.72,191.95,214.37,191.95z M244.4,166.51l-28.91,16.69 c-0.92,0.53-1.69,1.87-1.69,2.93v3.93c0,0.41,0.12,0.71,0.32,0.82c0.2,0.11,0.52,0.07,0.87-0.14l28.91-16.69 c0.92-0.53,1.69-1.87,1.69-2.93l0-3.93c0-0.41-0.12-0.7-0.32-0.82C245.07,166.26,244.75,166.31,244.4,166.51L244.4,166.51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7983_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7998_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.04,169.41v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C243.86,169.06,244.04,169.16,244.04,169.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7997_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.07,170.54v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C241.9,170.19,242.07,170.29,242.07,170.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7996_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.11,171.67v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C239.94,171.32,240.11,171.42,240.11,171.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7995_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.15,172.8v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C237.97,172.45,238.15,172.55,238.15,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7994_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.19,173.93l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C236.01,173.58,236.19,173.68,236.19,173.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7993_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.22,175.06l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C234.05,174.72,234.22,174.82,234.22,175.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7992_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.26,176.2v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C232.09,175.85,232.26,175.95,232.26,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7991_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.3,177.33l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C230.12,176.98,230.3,177.08,230.3,177.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7990_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.33,178.46v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C228.16,178.11,228.33,178.21,228.33,178.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7989_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,179.59v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C226.2,179.24,226.37,179.34,226.37,179.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7988_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.41,180.72l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C224.23,180.37,224.41,180.47,224.41,180.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7987_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.44,181.85v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C222.27,181.51,222.44,181.61,222.44,181.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7986_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.48,182.98v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C220.31,182.64,220.48,182.74,220.48,182.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7985_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.52,184.12v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C218.34,183.77,218.52,183.87,218.52,184.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7984_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.56,185.25v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C216.38,184.9,216.56,185,216.56,185.25z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7981_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.37,189.07l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L210.37,189.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7980_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.25,189.16c-0.85,0.49-1.54,1.68-1.54,2.66s0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66S210.1,188.66,209.25,189.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6215_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.25,189.16c-0.85,0.49-1.54,1.68-1.54,2.66 s0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66S210.1,188.66,209.25,189.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5650_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5670_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.7,192.92l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L203.7,192.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5669_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.58,193.01c-0.85,0.49-1.54,1.68-1.54,2.66s0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66C204.12,192.91,203.43,192.52,202.58,193.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5658_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.58,193.01c-0.85,0.49-1.54,1.68-1.54,2.66 s0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66C204.12,192.91,203.43,192.52,202.58,193.01z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5645_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5649_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.33,222.48c-0.24,0-0.47-0.06-0.67-0.17c-0.47-0.27-0.73-0.82-0.73-1.5l0-14.19 c0-1.24,0.84-2.69,1.91-3.31l41.34-23.87c0.6-0.34,1.2-0.39,1.67-0.12c0.47,0.27,0.73,0.82,0.73,1.5l0,14.19 c0,1.24-0.84,2.69-1.91,3.31l-41.34,23.87C202.99,222.39,202.65,222.48,202.33,222.48z M244.67,180.29l-41.34,23.87 c-0.77,0.44-1.42,1.57-1.42,2.46l0,14.19c0,0.32,0.09,0.57,0.24,0.65c0.15,0.09,0.4,0.05,0.69-0.12l41.34-23.87 c0.77-0.45,1.42-1.57,1.42-2.46l0-14.19c0-0.33-0.09-0.56-0.24-0.65C245.2,180.09,244.95,180.13,244.67,180.29L244.67,180.29z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5648_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.96,186.12c0,1-0.75,2.23-1.66,2.76l-35.09,20.26 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,184.75,242.96,185.12,242.96,186.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5647_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.96,193.33c0,1-0.75,2.23-1.66,2.76l-35.09,20.26 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,191.96,242.96,192.34,242.96,193.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5646_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.3,192.49l-14.89,8.6l0,3.61l14.89-8.6c0.92-0.53,1.66-1.77,1.66-2.76 C242.96,192.34,242.22,191.96,241.3,192.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5589_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5644_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.37,228.43c-0.27,0-0.53-0.07-0.76-0.2c-0.53-0.31-0.82-0.91-0.82-1.69v-3.93 c0-1.42,0.96-3.09,2.19-3.8l28.91-16.69c0.68-0.39,1.35-0.44,1.88-0.14c0.53,0.31,0.82,0.91,0.82,1.69l0,3.93 c0,1.42-0.96,3.09-2.19,3.8l-28.91,16.69C215.1,228.32,214.72,228.43,214.37,228.43z M244.4,202.99l-28.91,16.69 c-0.92,0.53-1.69,1.87-1.69,2.93v3.93c0,0.41,0.12,0.7,0.32,0.82c0.2,0.12,0.52,0.07,0.87-0.14l28.91-16.69 c0.92-0.53,1.69-1.87,1.69-2.93l0-3.93c0-0.41-0.12-0.71-0.32-0.82C245.06,202.74,244.75,202.79,244.4,202.99L244.4,202.99z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5590_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5605_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.04,205.89v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C243.86,205.54,244.04,205.64,244.04,205.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5604_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.07,207.02v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C241.9,206.67,242.07,206.77,242.07,207.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5603_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.11,208.15v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C239.94,207.8,240.11,207.9,240.11,208.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5602_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.15,209.28v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C237.97,208.93,238.15,209.03,238.15,209.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5601_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.19,210.41l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C236.01,210.06,236.19,210.16,236.19,210.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5600_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.22,211.54l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C234.05,211.2,234.22,211.3,234.22,211.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5599_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.26,212.68v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C232.09,212.33,232.26,212.43,232.26,212.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5598_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.3,213.81l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C230.12,213.46,230.3,213.56,230.3,213.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5597_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.33,214.94v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C228.16,214.59,228.33,214.69,228.33,214.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5596_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,216.07v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C226.2,215.72,226.37,215.82,226.37,216.07z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5595_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.41,217.2l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C224.23,216.85,224.41,216.95,224.41,217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5594_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.44,218.33v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C222.27,217.99,222.44,218.09,222.44,218.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5593_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.48,219.47v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C220.31,219.12,220.48,219.22,220.48,219.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5592_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.52,220.6v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C218.34,220.25,218.52,220.35,218.52,220.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5591_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.56,221.73v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C216.38,221.38,216.56,221.48,216.56,221.73z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5585_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5588_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.37,225.55l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L210.37,225.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5587_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.25,225.64c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.98,0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66S210.1,225.15,209.25,225.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5586_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.25,225.64c-0.85,0.49-1.54,1.68-1.54,2.66 c0,0.98,0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66S210.1,225.15,209.25,225.64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5584_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.7,229.4l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L203.7,229.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5583_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.58,229.49c-0.85,0.49-1.54,1.68-1.54,2.66s0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66C204.12,229.39,203.43,229,202.58,229.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5582_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.58,229.49c-0.85,0.49-1.54,1.68-1.54,2.66 s0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66C204.12,229.39,203.43,229,202.58,229.49z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5576_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5580_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.33,258.97c-0.24,0-0.47-0.06-0.68-0.18c-0.47-0.27-0.73-0.82-0.73-1.5l0-14.19 c0-1.24,0.84-2.69,1.91-3.31l41.34-23.87c0.6-0.34,1.2-0.38,1.67-0.12c0.47,0.27,0.73,0.82,0.73,1.5l0,14.19 c0,1.24-0.84,2.69-1.91,3.31l-41.34,23.87C202.99,258.87,202.65,258.97,202.33,258.97z M244.67,216.77l-41.34,23.87 c-0.77,0.45-1.42,1.57-1.42,2.46l0,14.19c0,0.32,0.09,0.57,0.24,0.65c0.15,0.09,0.4,0.05,0.69-0.12l41.34-23.87 c0.77-0.44,1.42-1.57,1.42-2.46l0-14.19c0-0.33-0.09-0.56-0.24-0.65C245.2,216.57,244.95,216.61,244.67,216.77L244.67,216.77z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5579_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.96,222.6c0,1-0.75,2.23-1.66,2.76l-35.09,20.26 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,221.23,242.96,221.6,242.96,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5578_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.96,229.81c0,1-0.75,2.23-1.66,2.76l-35.09,20.26 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,228.44,242.96,228.82,242.96,229.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5577_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.3,228.97l-14.89,8.6l0,3.61l14.89-8.6c0.92-0.53,1.66-1.77,1.66-2.76 C242.96,228.82,242.22,228.44,241.3,228.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3923_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5575_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.37,264.91c-0.27,0-0.53-0.07-0.76-0.2c-0.53-0.31-0.82-0.91-0.82-1.69v-3.93 c0-1.42,0.96-3.09,2.19-3.8l28.91-16.69c0.68-0.39,1.35-0.44,1.88-0.14c0.53,0.31,0.82,0.91,0.82,1.69l0,3.93 c0,1.42-0.96,3.09-2.19,3.8l-28.91,16.69C215.1,264.8,214.72,264.91,214.37,264.91z M244.4,239.47l-28.91,16.69 c-0.92,0.53-1.69,1.87-1.69,2.93v3.93c0,0.41,0.12,0.7,0.32,0.82c0.2,0.12,0.52,0.07,0.87-0.14l28.91-16.69 c0.92-0.53,1.69-1.87,1.69-2.93l0-3.93c0-0.41-0.12-0.71-0.32-0.82C245.07,239.22,244.75,239.27,244.4,239.47L244.4,239.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3927_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5574_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.04,242.37v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C243.86,242.02,244.04,242.12,244.04,242.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5573_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.07,243.5v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C241.9,243.15,242.07,243.25,242.07,243.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5572_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.11,244.63v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C239.94,244.28,240.11,244.38,240.11,244.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5571_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.15,245.76v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C237.97,245.41,238.15,245.51,238.15,245.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5570_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.19,246.89l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C236.01,246.54,236.19,246.64,236.19,246.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5569_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.22,248.02l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C234.05,247.68,234.22,247.78,234.22,248.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5568_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.26,249.16v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C232.09,248.81,232.26,248.91,232.26,249.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5567_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.3,250.29l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C230.12,249.94,230.3,250.04,230.3,250.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5566_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.33,251.42v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C228.16,251.07,228.33,251.17,228.33,251.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5565_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,252.55v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C226.2,252.2,226.37,252.3,226.37,252.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5564_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.41,253.68l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C224.23,253.33,224.41,253.43,224.41,253.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5563_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.44,254.81v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C222.27,254.47,222.44,254.57,222.44,254.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5562_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.48,255.95v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C220.31,255.6,220.48,255.7,220.48,255.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3929_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.52,257.08v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C218.34,256.73,218.52,256.83,218.52,257.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3928_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.56,258.21v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C216.38,257.86,216.56,257.96,216.56,258.21z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3916_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3922_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.37,262.03l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L210.37,262.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3918_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.25,262.12c-0.85,0.49-1.54,1.68-1.54,2.66s0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66C210.79,262.02,210.1,261.63,209.25,262.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3917_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.25,262.12c-0.85,0.49-1.54,1.68-1.54,2.66 s0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66C210.79,262.02,210.1,261.63,209.25,262.12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3912_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3915_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.7,265.88l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L203.7,265.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3914_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.58,265.97c-0.85,0.49-1.54,1.68-1.54,2.66s0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66C204.12,265.87,203.43,265.48,202.58,265.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3913_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.58,265.97c-0.85,0.49-1.54,1.68-1.54,2.66 s0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66C204.12,265.87,203.43,265.48,202.58,265.97z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3907_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3911_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.33,295.44c-0.24,0-0.47-0.06-0.67-0.17c-0.47-0.27-0.73-0.82-0.73-1.5l0-14.19 c0-1.24,0.84-2.69,1.91-3.31l41.34-23.87c0.6-0.34,1.2-0.38,1.67-0.12c0.47,0.27,0.73,0.82,0.73,1.5l0,14.19 c0,1.24-0.84,2.69-1.91,3.31l-41.34,23.87C202.99,295.35,202.65,295.44,202.33,295.44z M244.67,253.25l-41.34,23.87 c-0.77,0.44-1.42,1.57-1.42,2.46l0,14.19c0,0.32,0.09,0.57,0.24,0.65c0.15,0.09,0.4,0.05,0.69-0.12l41.34-23.87 c0.77-0.45,1.42-1.57,1.42-2.46l0-14.19c0-0.33-0.09-0.56-0.24-0.65C245.2,253.05,244.95,253.09,244.67,253.25L244.67,253.25z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3910_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.96,259.08c0,1-0.75,2.23-1.66,2.76L206.2,282.1 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,257.71,242.96,258.08,242.96,259.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3909_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.96,266.29c0,1-0.75,2.23-1.66,2.76l-35.09,20.26 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,264.92,242.96,265.3,242.96,266.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3908_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.3,265.45l-14.89,8.6l0,3.61l14.89-8.6c0.92-0.53,1.66-1.77,1.66-2.76 C242.96,265.3,242.22,264.92,241.3,265.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3874_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3905_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.37,301.39c-0.27,0-0.53-0.07-0.76-0.2c-0.53-0.31-0.82-0.91-0.82-1.69v-3.93 c0-1.42,0.96-3.09,2.19-3.8l28.91-16.69c0.68-0.39,1.35-0.44,1.88-0.14c0.53,0.31,0.82,0.91,0.82,1.69l0,3.93 c0,1.42-0.96,3.09-2.19,3.8l-28.91,16.69C215.1,301.28,214.72,301.39,214.37,301.39z M244.4,275.95l-28.91,16.69 c-0.92,0.53-1.69,1.87-1.69,2.93v3.93c0,0.41,0.12,0.7,0.32,0.82c0.2,0.12,0.52,0.07,0.87-0.13l28.91-16.69 c0.92-0.53,1.69-1.87,1.69-2.93l0-3.93c0-0.41-0.12-0.7-0.32-0.82C245.07,275.7,244.75,275.75,244.4,275.95L244.4,275.95z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3875_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3904_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M244.04,278.85v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C243.86,278.5,244.04,278.6,244.04,278.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3903_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.07,279.98v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C241.9,279.63,242.07,279.73,242.07,279.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3902_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M240.11,281.11v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C239.94,280.76,240.11,280.86,240.11,281.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3901_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M238.15,282.24v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C237.97,281.89,238.15,281.99,238.15,282.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3900_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M236.19,283.37l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C236.01,283.02,236.19,283.12,236.19,283.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3899_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M234.22,284.5l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C234.05,284.16,234.22,284.26,234.22,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3898_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M232.26,285.64v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C232.09,285.29,232.26,285.39,232.26,285.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3897_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M230.3,286.77l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C230.12,286.42,230.3,286.52,230.3,286.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3896_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M228.33,287.9v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C228.16,287.55,228.33,287.65,228.33,287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3893_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.37,289.03v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C226.2,288.68,226.37,288.78,226.37,289.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3891_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M224.41,290.16l0,1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C224.23,289.81,224.41,289.91,224.41,290.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3885_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M222.44,291.29v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C222.27,290.95,222.44,291.05,222.44,291.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3880_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M220.48,292.43v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C220.31,292.08,220.48,292.18,220.48,292.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3877_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M218.52,293.56v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C218.34,293.21,218.52,293.31,218.52,293.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3876_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M216.56,294.69v1.91c0,0.25-0.17,0.55-0.39,0.67l-0.44,0.25 c-0.21,0.12-0.39,0.02-0.39-0.22v-1.91c0-0.25,0.17-0.55,0.39-0.67l0.44-0.25C216.38,294.34,216.56,294.44,216.56,294.69z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3870_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3873_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M210.37,298.51l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L210.37,298.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3872_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.25,298.6c-0.85,0.49-1.54,1.68-1.54,2.66s0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66C210.79,298.5,210.1,298.11,209.25,298.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3871_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M209.25,298.6c-0.85,0.49-1.54,1.68-1.54,2.66 s0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66C210.79,298.5,210.1,298.11,209.25,298.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3866_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3869_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M203.7,302.36l-0.81-0.47l0,0l-0.01,0l0,0c-0.28-0.16-0.66-0.13-1.08,0.11 c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.49,0.17,0.83,0.45,0.99v0l0,0l0,0l0.75,0.43l0.14-0.23c0.14-0.03,0.29-0.08,0.44-0.17 c0.85-0.49,1.54-1.68,1.54-2.66c0-0.15-0.02-0.27-0.05-0.39L203.7,302.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3868_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.58,302.45c-0.85,0.49-1.54,1.68-1.54,2.66c0,0.98,0.69,1.38,1.54,0.89 c0.85-0.49,1.54-1.68,1.54-2.66C204.12,302.36,203.43,301.96,202.58,302.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3867_",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    d: "M202.58,302.45c-0.85,0.49-1.54,1.68-1.54,2.66 c0,0.98,0.69,1.38,1.54,0.89c0.85-0.49,1.54-1.68,1.54-2.66C204.12,302.36,203.43,301.96,202.58,302.45z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3799_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3814_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.33,186c-0.24,0-0.47-0.06-0.68-0.18c-0.47-0.27-0.73-0.82-0.73-1.5l0-14.19 c0-1.24,0.84-2.69,1.91-3.31l41.34-23.87c0.59-0.34,1.2-0.39,1.67-0.12c0.47,0.27,0.73,0.82,0.73,1.5l0,14.19 c0,1.24-0.84,2.69-1.91,3.31l-41.34,23.87C202.99,185.91,202.65,186,202.33,186z M245.16,143.65c-0.14,0-0.31,0.06-0.5,0.16 l-41.34,23.87c-0.77,0.45-1.42,1.57-1.42,2.46l0,14.19c0,0.32,0.09,0.57,0.24,0.65c0.15,0.09,0.4,0.05,0.69-0.12l41.34-23.87 c0.77-0.44,1.42-1.57,1.42-2.46l0-14.19c0-0.33-0.09-0.56-0.24-0.65C245.3,143.66,245.24,143.65,245.16,143.65z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3813_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M242.96,149.64c0,1-0.75,2.23-1.66,2.76l-35.09,20.26 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,148.26,242.96,148.64,242.96,149.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3804_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.96,156.85c0,1-0.75,2.23-1.66,2.76l-35.09,20.26 c-0.92,0.53-1.67,0.15-1.67-0.84c0-1,0.75-2.23,1.67-2.76l35.09-20.26C242.22,155.48,242.96,155.86,242.96,156.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3803_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.3,156.01l-14.89,8.6l0,3.61l14.89-8.6c0.92-0.53,1.66-1.77,1.66-2.76 C242.96,155.86,242.22,155.48,241.3,156.01z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3761_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3762_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3763_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3781_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.87,275.13l0.81-0.47l0,0l0.01,0l0,0c0.28-0.16,0.66-0.13,1.08,0.11 c0.85,0.49,1.54,1.68,1.54,2.66c0,0.49-0.17,0.83-0.45,0.99v0l0,0l0,0l-0.75,0.43l-0.14-0.23c-0.14-0.03-0.29-0.08-0.44-0.17 c-0.85-0.49-1.54-1.68-1.54-2.66c0-0.15,0.02-0.27,0.05-0.39L147.87,275.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3764_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.99,275.22c0.85,0.49,1.54,1.68,1.54,2.66s-0.69,1.38-1.54,0.89 c-0.85-0.49-1.54-1.68-1.54-2.66C147.45,275.12,148.14,274.73,148.99,275.22z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3786_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3798_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M146.19,271.09l6.24,3.58c0.98,0.56,1.77,1.94,1.77,3.06v3.58 c0,1.13-0.79,1.59-1.77,1.02l-6.24-3.58c-0.98-0.56-1.77-1.94-1.77-3.06v-3.58C144.42,270.99,145.21,270.53,146.19,271.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3597_",
    style: {
      opacity: 0.1
    },
    d: "M146.19,271.09l6.24,3.58c0.98,0.56,1.77,1.94,1.77,3.06v3.58 c0,1.13-0.79,1.59-1.77,1.02l-6.24-3.58c-0.98-0.56-1.77-1.94-1.77-3.06v-3.58C144.42,270.99,145.21,270.53,146.19,271.09z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3787_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3788_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3794_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.87,275.13l0.81-0.47l0,0l0.01,0l0,0c0.28-0.16,0.66-0.13,1.08,0.11 c0.85,0.49,1.54,1.68,1.54,2.66c0,0.49-0.17,0.83-0.45,0.99v0l0,0l0,0l-0.75,0.43l-0.14-0.23c-0.14-0.03-0.29-0.08-0.44-0.17 c-0.85-0.49-1.54-1.68-1.54-2.66c0-0.15,0.02-0.27,0.05-0.39L147.87,275.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3789_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.99,275.22c0.85,0.49,1.54,1.68,1.54,2.66s-0.69,1.38-1.54,0.89 c-0.85-0.49-1.54-1.68-1.54-2.66C147.45,275.12,148.14,274.73,148.99,275.22z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3756_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3760_",
    style: {
      opacity: 0.15
    },
    d: "M159.21,277.21l30.26,17.45c0.54,0.31,0.98,1.07,0.98,1.7l0,8.36 c0,0.63-0.44,0.88-0.98,0.57l-30.26-17.45c-0.54-0.31-0.98-1.07-0.98-1.7l0-8.36C158.23,277.15,158.67,276.9,159.21,277.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3759_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M160.07,280.89c0,0.59,0.44,1.32,0.98,1.63l26.58,15.33 c0.54,0.31,0.98,0.09,0.98-0.5c0-0.59-0.44-1.32-0.98-1.63l-26.58-15.33C160.51,280.09,160.07,280.31,160.07,280.89z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3758_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M160.07,285.14c0,0.59,0.44,1.32,0.98,1.63l26.58,15.33 c0.54,0.31,0.98,0.09,0.98-0.5c0-0.59-0.44-1.32-0.98-1.63l-26.58-15.33C160.51,284.33,160.07,284.56,160.07,285.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3757_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M161.05,284.65l14.68,8.46l0,2.12l-14.68-8.46c-0.54-0.31-0.98-1.04-0.98-1.63 C160.07,284.56,160.51,284.33,161.05,284.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8020_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8026_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M146.19,253.76l6.24,3.58c0.98,0.56,1.77,1.94,1.77,3.06v3.58 c0,1.13-0.79,1.59-1.77,1.02l-6.24-3.58c-0.98-0.56-1.77-1.94-1.77-3.06v-3.58C144.42,253.65,145.21,253.2,146.19,253.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3596_",
    style: {
      opacity: 0.1
    },
    d: "M146.19,253.76l6.24,3.58c0.98,0.56,1.77,1.94,1.77,3.06v3.58 c0,1.13-0.79,1.59-1.77,1.02l-6.24-3.58c-0.98-0.56-1.77-1.94-1.77-3.06v-3.58C144.42,253.65,145.21,253.2,146.19,253.76z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8021_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8022_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8025_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.87,257.8l0.81-0.47l0,0l0.01,0l0,0c0.28-0.16,0.66-0.13,1.08,0.11 c0.85,0.49,1.54,1.68,1.54,2.66c0,0.49-0.17,0.83-0.45,0.99v0l0,0l0,0l-0.75,0.43l-0.14-0.23c-0.14-0.03-0.29-0.08-0.44-0.17 c-0.85-0.49-1.54-1.68-1.54-2.66c0-0.15,0.02-0.27,0.05-0.39L147.87,257.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8023_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.99,257.88c0.85,0.49,1.54,1.68,1.54,2.66c0,0.98-0.69,1.38-1.54,0.89 c-0.85-0.49-1.54-1.68-1.54-2.66S148.14,257.39,148.99,257.88z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8011_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8019_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M146.19,236.52l6.24,3.58c0.98,0.56,1.77,1.94,1.77,3.06v3.58 c0,1.13-0.79,1.59-1.77,1.02l-6.24-3.58c-0.98-0.56-1.77-1.94-1.77-3.06v-3.58C144.42,236.42,145.21,235.96,146.19,236.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1406_",
    style: {
      opacity: 0.1
    },
    d: "M146.19,236.52l6.24,3.58c0.98,0.56,1.77,1.94,1.77,3.06v3.58 c0,1.13-0.79,1.59-1.77,1.02l-6.24-3.58c-0.98-0.56-1.77-1.94-1.77-3.06v-3.58C144.42,236.42,145.21,235.96,146.19,236.52z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8014_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8015_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8018_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M147.87,240.56l0.81-0.47l0,0l0.01,0l0,0c0.28-0.16,0.66-0.13,1.08,0.11 c0.85,0.49,1.54,1.68,1.54,2.66c0,0.49-0.17,0.83-0.45,0.99v0l0,0l0,0l-0.75,0.43l-0.14-0.23c-0.14-0.03-0.29-0.08-0.44-0.17 c-0.85-0.49-1.54-1.68-1.54-2.66c0-0.15,0.02-0.27,0.05-0.39L147.87,240.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8017_",
    style: {
      opacity: 0.2
    },
    d: "M147.87,240.56l0.81-0.47l0,0l0.01,0l0,0c0.28-0.16,0.66-0.13,1.08,0.11 c0.85,0.49,1.54,1.68,1.54,2.66c0,0.49-0.17,0.83-0.45,0.99v0l0,0l0,0l-0.75,0.43l-0.14-0.23c-0.14-0.03-0.29-0.08-0.44-0.17 c-0.85-0.49-1.54-1.68-1.54-2.66c0-0.15,0.02-0.27,0.05-0.39L147.87,240.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8016_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M148.99,240.65c0.85,0.49,1.54,1.68,1.54,2.66s-0.69,1.38-1.54,0.89 c-0.85-0.49-1.54-1.68-1.54-2.66S148.14,240.16,148.99,240.65z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3862_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3865_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M159.21,242.64l30.26,17.45c0.54,0.31,0.98,1.07,0.98,1.7l0,8.36 c0,0.63-0.44,0.88-0.98,0.57l-30.26-17.45c-0.54-0.31-0.98-1.07-0.98-1.7l0-8.36C158.23,242.59,158.67,242.33,159.21,242.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3864_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M160.07,246.33c0,0.59,0.44,1.32,0.98,1.63l26.58,15.33 c0.54,0.31,0.98,0.09,0.98-0.5c0-0.59-0.44-1.32-0.98-1.63l-26.58-15.33C160.51,245.52,160.07,245.74,160.07,246.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3863_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M161.05,250.08l14.68,8.46l0,2.12l-14.68-8.46c-0.54-0.31-0.98-1.04-0.98-1.63 C160.07,249.99,160.51,249.77,161.05,250.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3837_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3845_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3846_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3860_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M147.87,240.56l0.81-0.47l0,0l0.01,0l0,0c0.28-0.16,0.66-0.13,1.08,0.11 c0.85,0.49,1.54,1.68,1.54,2.66c0,0.49-0.17,0.83-0.45,0.99v0l0,0l0,0l-0.75,0.43l-0.14-0.23c-0.14-0.03-0.29-0.08-0.44-0.17 c-0.85-0.49-1.54-1.68-1.54-2.66c0-0.15,0.02-0.27,0.05-0.39L147.87,240.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3850_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M148.99,240.65c0.85,0.49,1.54,1.68,1.54,2.66s-0.69,1.38-1.54,0.89 c-0.85-0.49-1.54-1.68-1.54-2.66S148.14,240.16,148.99,240.65z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3825_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3836_",
    style: {
      opacity: 0.15
    },
    d: "M159.21,242.64l30.26,17.45c0.54,0.31,0.98,1.07,0.98,1.7l0,8.36 c0,0.63-0.44,0.88-0.98,0.57l-30.26-17.45c-0.54-0.31-0.98-1.07-0.98-1.7l0-8.36C158.23,242.59,158.67,242.33,159.21,242.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3833_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M160.07,246.33c0,0.59,0.44,1.32,0.98,1.63l26.58,15.33 c0.54,0.31,0.98,0.09,0.98-0.5c0-0.59-0.44-1.32-0.98-1.63l-26.58-15.33C160.51,245.52,160.07,245.74,160.07,246.33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3831_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M160.07,250.57c0,0.59,0.44,1.32,0.98,1.63l26.58,15.33 c0.54,0.31,0.98,0.09,0.98-0.5c0-0.59-0.44-1.32-0.98-1.63l-26.58-15.33C160.51,249.77,160.07,249.99,160.07,250.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3829_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M161.05,250.08l14.68,8.46l0,2.12l-14.68-8.46c-0.54-0.31-0.98-1.04-0.98-1.63 C160.07,249.99,160.51,249.77,161.05,250.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3815_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3819_",
    style: {
      opacity: 0.15
    },
    d: "M159.21,259.93l30.26,17.45c0.54,0.31,0.98,1.07,0.98,1.7l0,8.36 c0,0.63-0.44,0.88-0.98,0.57l-30.26-17.45c-0.54-0.31-0.98-1.07-0.98-1.7l0-8.36C158.23,259.87,158.67,259.61,159.21,259.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3818_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M160.07,263.61c0,0.59,0.44,1.32,0.98,1.63l26.58,15.33 c0.54,0.31,0.98,0.09,0.98-0.5c0-0.59-0.44-1.32-0.98-1.63l-26.58-15.33C160.51,262.8,160.07,263.02,160.07,263.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3817_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M160.07,267.86c0,0.59,0.44,1.32,0.98,1.63l26.58,15.33 c0.54,0.31,0.98,0.09,0.98-0.5s-0.44-1.32-0.98-1.63l-26.58-15.33C160.51,267.05,160.07,267.27,160.07,267.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3816_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M161.05,267.36l18.36,10.59l0,2.12l-18.36-10.59 c-0.54-0.31-0.98-1.04-0.98-1.63C160.07,267.27,160.51,267.05,161.05,267.36z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Speech_Bubble_8_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M158.71,110.16c-0.84,0-1.56-0.5-1.85-1.29l-2.2-5.95l-10.59,6.11 c-0.57,0.33-1.16,0.37-1.6,0.11c-0.45-0.26-0.71-0.79-0.71-1.45l0-48.68c0-1.2,0.81-2.6,1.85-3.2l53.5-30.89 c0.57-0.33,1.16-0.37,1.61-0.11c0.45,0.26,0.7,0.79,0.7,1.45v48.68c0,1.2-0.81,2.6-1.85,3.2l-33.76,19.49l-3.19,11.1 c-0.24,0.84-0.96,1.4-1.83,1.43C158.77,110.16,158.74,110.16,158.71,110.16z M155.15,101.56l2.58,6.99 c0.19,0.53,0.68,0.7,1.02,0.68c0.37-0.01,0.81-0.22,0.97-0.76l3.29-11.46l34.09-19.68c0.75-0.43,1.38-1.53,1.38-2.39V26.27 c0-0.32-0.09-0.55-0.24-0.64c-0.15-0.09-0.4-0.05-0.68,0.11l-53.5,30.89c-0.75,0.43-1.38,1.53-1.38,2.39l0,48.68 c0,0.32,0.09,0.55,0.24,0.64c0.15,0.09,0.4,0.05,0.67-0.11L155.15,101.56z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chart_10_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M169.44,48.56l0.02,18.35L158.3,84.69c-3.93-5.04-2.79-17.63,3.36-27.59 C164.14,53.09,166.34,50.52,169.44,48.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M184.58,64.74c-2.21,11.16-9.9,21.52-17.48,23.37c-3.05,0.76-5.52,0.14-7.53-1.85l11.22-18.15 L184.58,64.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M184.87,62.81l-13.2,3.24l7.41-19.51C183.8,48.31,186.03,54.56,184.87,62.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M177.68,46.4L170.99,64V47.62C173.49,46.3,175.55,45.92,177.68,46.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Server_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1914_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,324.17 92.8,355.99 37.68,324.17 92.81,292.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2779_",
    style: {
      opacity: 0.1
    },
    points: "147.93,324.17 92.8,355.99 37.68,324.17 92.81,292.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2775_",
    style: {
      opacity: 0.1
    },
    points: "92.81,355.99 92.8,352.02 41.13,322.18 37.68,324.17  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1907_",
    style: {
      fill: "#BA68C8"
    },
    d: "M92.81,355.99v21.78c1.32,0,2.65-0.29,3.67-0.87l0,0l23.88-13.79l25.36-14.65 c1.22-0.7,2.21-2.41,2.21-3.82v-20.48L92.81,355.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2650_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M92.81,355.99v21.78c1.32,0,2.65-0.29,3.67-0.87l0,0l23.88-13.79 l25.36-14.65c1.22-0.7,2.21-2.41,2.21-3.82v-20.48L92.81,355.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1902_",
    style: {
      fill: "#BA68C8"
    },
    d: "M37.68,324.17v20.48c0,1.41,0.99,3.11,2.21,3.82l21.92,12.65l27.34,15.78 c1.02,0.59,2.34,0.87,3.67,0.87v-21.78L37.68,324.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1877_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M37.68,324.17v20.48c0,1.41,0.99,3.11,2.21,3.82l21.92,12.65 l27.34,15.78c1.02,0.59,2.34,0.87,3.67,0.87v-21.78L37.68,324.17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1845_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,300.3 92.8,332.12 37.68,300.3 92.81,268.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1843_",
    style: {
      opacity: 0.1
    },
    points: "147.93,300.3 92.8,332.12 37.68,300.3 92.81,268.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1812_",
    style: {
      opacity: 0.1
    },
    points: "92.8,332.12 92.8,328.15 41.13,298.31 37.68,300.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1811_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,316.21 92.8,348.04 92.8,332.12 147.93,300.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1694_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.93,316.21 92.8,348.04 92.8,332.12 147.93,300.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1693_",
    style: {
      fill: "#BA68C8"
    },
    points: "92.8,348.04 37.68,316.21 37.68,300.3 92.8,332.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1486_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.8,348.04 37.68,316.21 37.68,300.3 92.8,332.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1483_",
    style: {
      fill: "#455A64"
    },
    points: "141.04,324.17 141.04,320.19 92.8,348.04 92.8,352.02  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1470_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1482_",
    style: {
      fill: "#BA68C8"
    },
    points: "41.13,318.2 41.13,322.18 92.8,352.02 92.8,348.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1480_",
    style: {
      fill: "#37474F"
    },
    points: "41.13,318.2 41.13,322.18 92.8,352.02 92.8,348.04  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1431_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,276.43 92.8,308.26 37.68,276.43 92.81,244.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1428_",
    style: {
      opacity: 0.1
    },
    points: "147.93,276.43 92.8,308.26 37.68,276.43 92.81,244.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1426_",
    style: {
      opacity: 0.1
    },
    points: "92.8,308.26 92.8,304.28 41.13,274.44 37.68,276.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1425_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,292.34 92.8,324.17 92.8,308.26 147.93,276.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1423_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.93,292.34 92.8,324.17 92.8,308.26 147.93,276.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1422_",
    style: {
      fill: "#BA68C8"
    },
    points: "92.8,324.17 37.68,292.34 37.68,276.43 92.8,308.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1420_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.8,324.17 37.68,292.34 37.68,276.43 92.8,308.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1419_",
    style: {
      fill: "#455A64"
    },
    points: "141.04,300.3 141.04,296.32 92.8,324.17 92.8,328.15  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1417_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1418_",
    style: {
      fill: "#37474F"
    },
    points: "41.13,294.33 41.13,298.31 92.8,328.15 92.8,324.17  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1416_",
    style: {
      fill: "#455A64"
    },
    points: "141.04,276.43 141.04,272.45 92.8,300.3 92.8,304.28  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1414_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1415_",
    style: {
      fill: "#37474F"
    },
    points: "41.13,270.46 41.13,274.44 92.8,304.28 92.8,300.3  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1413_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,252.56 92.8,284.39 37.68,252.56 92.81,220.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1412_",
    style: {
      opacity: 0.15,
      fill: "#FFFFFF"
    },
    points: "147.93,252.56 92.8,284.39 37.68,252.56 92.81,220.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1410_",
    style: {
      opacity: 0.1
    },
    points: "147.93,252.56 92.8,284.39 37.68,252.56 92.81,220.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1408_",
    style: {
      opacity: 0.1
    },
    points: "92.8,280.41 92.8,284.39 37.68,252.56 41.13,250.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1407_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,268.47 92.8,300.3 92.8,284.39 147.93,252.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1405_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.93,268.47 92.8,300.3 92.8,284.39 147.93,252.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1404_",
    style: {
      fill: "#BA68C8"
    },
    points: "92.8,300.3 37.68,268.47 37.68,252.56 92.8,284.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1401_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.8,300.3 37.68,268.47 37.68,252.56 92.8,284.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1400_",
    style: {
      fill: "#455A64"
    },
    points: "141.04,252.57 141.04,248.59 92.8,276.44 92.8,280.41  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1398_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1399_",
    style: {
      fill: "#37474F"
    },
    points: "41.13,246.6 41.13,250.58 92.8,280.41 92.8,276.44  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5222_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,228.65 92.8,260.47 37.68,228.65 92.81,196.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5220_",
    style: {
      opacity: 0.15,
      fill: "#FFFFFF"
    },
    points: "147.93,228.65 92.8,260.47 37.68,228.65 92.81,196.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5218_",
    style: {
      opacity: 0.1
    },
    points: "147.93,228.65 92.8,260.47 37.68,228.65 92.81,196.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5216_",
    style: {
      opacity: 0.1
    },
    points: "92.8,256.5 92.8,260.47 37.68,228.65 41.13,226.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5215_",
    style: {
      fill: "#BA68C8"
    },
    points: "147.93,244.56 92.8,276.39 92.8,260.47 147.93,228.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5213_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    points: "147.93,244.56 92.8,276.39 92.8,260.47 147.93,228.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5212_",
    style: {
      fill: "#BA68C8"
    },
    points: "92.8,276.39 37.68,244.56 37.68,228.65 92.8,260.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5210_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "92.8,276.39 37.68,244.56 37.68,228.65 92.8,260.47  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5209_",
    style: {
      fill: "#BA68C8"
    },
    d: "M39.88,203.51l50.75-29.28c1.21-0.7,3.2-0.7,4.41,0l50.69,29.28 c1.21,0.7,2.2,2.42,2.2,3.82v13.37l-55.16,31.83l0,0L37.68,220.7v-13.37C37.68,205.93,38.67,204.21,39.88,203.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5207_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M39.88,203.51l50.75-29.28c1.21-0.7,3.2-0.7,4.41,0l50.69,29.28 c1.21,0.7,2.2,2.42,2.2,3.82v13.37l-55.16,31.83l0,0L37.68,220.7v-13.37C37.68,205.93,38.67,204.21,39.88,203.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5189_",
    style: {
      fill: "#BA68C8"
    },
    d: "M92.78,235.86v16.66l55.15-31.82v-13.37c0-1.24-0.78-2.74-1.81-3.54 c0.81,0.7,0.67,1.65-0.4,2.26l-50.75,29.28C94.37,235.68,93.57,235.86,92.78,235.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5187_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M92.78,235.86v16.66l55.15-31.82v-13.37 c0-1.24-0.78-2.74-1.81-3.54c0.81,0.7,0.67,1.65-0.4,2.26l-50.75,29.28C94.37,235.68,93.57,235.86,92.78,235.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5139_",
    style: {
      fill: "#BA68C8"
    },
    d: "M145.73,206.06l-50.75,29.28c-1.22,0.7-3.19,0.7-4.41,0l-50.69-29.28 c-1.22-0.7-1.22-1.84,0-2.54l50.75-29.28c1.22-0.7,3.19-0.7,4.41,0l50.69,29.28C146.94,204.21,146.94,205.35,145.73,206.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5137_",
    style: {
      opacity: 0.85,
      fill: "#FFFFFF"
    },
    d: "M145.73,206.06l-50.75,29.28c-1.22,0.7-3.19,0.7-4.41,0 l-50.69-29.28c-1.22-0.7-1.22-1.84,0-2.54l50.75-29.28c1.22-0.7,3.19-0.7,4.41,0l50.69,29.28 C146.94,204.21,146.94,205.35,145.73,206.06z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5136_",
    style: {
      fill: "#455A64"
    },
    points: "141.04,228.65 141.04,224.67 92.8,252.52 92.8,256.5  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1397_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5114_",
    style: {
      fill: "#37474F"
    },
    points: "41.13,222.69 41.13,226.66 92.8,256.5 92.8,252.52  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1396_",
    style: {
      fill: "#455A64"
    },
    d: "M49.67,349.54c0.42,0.24,0.76,0.84,0.76,1.32c0,0.49-0.34,0.69-0.76,0.44 c-0.42-0.24-0.76-0.84-0.76-1.32S49.25,349.29,49.67,349.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M56.04,353.22c0.42,0.24,0.76,0.83,0.76,1.32c0,0.49-0.34,0.68-0.76,0.44 c-0.42-0.24-0.76-0.83-0.76-1.32C55.28,353.18,55.62,352.98,56.04,353.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M62.31,356.84c0.42,0.24,0.76,0.83,0.76,1.32c0,0.48-0.34,0.68-0.76,0.44 c-0.42-0.24-0.76-0.83-0.76-1.32C61.55,356.79,61.89,356.6,62.31,356.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2039_",
    style: {
      fill: "#455A64"
    },
    d: "M68.63,360.49c0.42,0.24,0.76,0.83,0.76,1.31c0,0.48-0.34,0.68-0.76,0.44 c-0.42-0.24-0.76-0.83-0.76-1.31C67.87,360.44,68.21,360.25,68.63,360.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2030_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1395_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.24,330.75l6.48,3.72c1.01,0.59,1.84,2.01,1.84,3.18v3.72c0,1.17-0.82,1.65-1.84,1.06 l-6.48-3.72c-1.01-0.59-1.84-2.01-1.84-3.18v-3.72C40.4,330.64,41.22,330.17,42.24,330.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2031_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1391_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1394_",
    style: {
      fill: "#BA68C8"
    },
    d: "M43.98,334.94l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,334.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1393_",
    style: {
      opacity: 0.2
    },
    d: "M43.98,334.94l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,334.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1392_",
    style: {
      fill: "#BA68C8"
    },
    d: "M45.14,335.03c0.88,0.51,1.6,1.75,1.6,2.76c0,1.02-0.71,1.43-1.6,0.92 c-0.88-0.51-1.6-1.75-1.6-2.76C43.55,334.94,44.26,334.52,45.14,335.03z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1384_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1390_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.24,306.86l6.48,3.72c1.01,0.59,1.84,2.01,1.84,3.18v3.72c0,1.17-0.82,1.65-1.84,1.06 l-6.48-3.72c-1.01-0.59-1.84-2.01-1.84-3.18v-3.72C40.4,306.75,41.22,306.28,42.24,306.86z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1385_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1386_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1389_",
    style: {
      fill: "#BA68C8"
    },
    d: "M43.98,311.05l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,311.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1388_",
    style: {
      opacity: 0.2
    },
    d: "M43.98,311.05l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,311.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1387_",
    style: {
      fill: "#BA68C8"
    },
    d: "M45.14,311.14c0.88,0.51,1.6,1.75,1.6,2.76c0,1.02-0.71,1.43-1.6,0.92 c-0.88-0.51-1.6-1.75-1.6-2.76C43.55,311.05,44.26,310.64,45.14,311.14z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1377_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1383_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.24,282.99l6.48,3.72c1.01,0.59,1.84,2.01,1.84,3.18v3.72c0,1.17-0.82,1.65-1.84,1.06 l-6.48-3.72c-1.01-0.59-1.84-2.01-1.84-3.18v-3.72C40.4,282.88,41.22,282.41,42.24,282.99z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1378_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1379_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1382_",
    style: {
      fill: "#BA68C8"
    },
    d: "M43.98,287.18l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,287.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1381_",
    style: {
      opacity: 0.2
    },
    d: "M43.98,287.18l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,287.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1380_",
    style: {
      fill: "#BA68C8"
    },
    d: "M45.14,287.27c0.88,0.51,1.6,1.75,1.6,2.76c0,1.02-0.71,1.43-1.6,0.92 c-0.88-0.51-1.6-1.75-1.6-2.76C43.55,287.18,44.26,286.76,45.14,287.27z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1365_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1376_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.24,259.15l6.48,3.72c1.01,0.59,1.84,2.01,1.84,3.18v3.72c0,1.17-0.82,1.65-1.84,1.06 l-6.48-3.72c-1.01-0.59-1.84-2.01-1.84-3.18v-3.72C40.4,259.04,41.22,258.56,42.24,259.15z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1367_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1371_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1375_",
    style: {
      fill: "#BA68C8"
    },
    d: "M43.98,263.34l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,263.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1374_",
    style: {
      opacity: 0.2
    },
    d: "M43.98,263.34l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,263.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1373_",
    style: {
      fill: "#BA68C8"
    },
    d: "M45.14,263.43c0.88,0.51,1.6,1.75,1.6,2.76c0,1.02-0.71,1.43-1.6,0.92 c-0.88-0.51-1.6-1.75-1.6-2.76C43.55,263.33,44.26,262.92,45.14,263.43z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5198_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5205_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.24,235.23l6.48,3.72c1.01,0.59,1.84,2.01,1.84,3.18v3.72c0,1.17-0.82,1.65-1.84,1.06 l-6.48-3.72c-1.01-0.59-1.84-2.01-1.84-3.18v-3.72C40.4,235.12,41.22,234.65,42.24,235.23z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5199_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5200_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5204_",
    style: {
      fill: "#BA68C8"
    },
    d: "M43.98,239.42l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,239.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5203_",
    style: {
      opacity: 0.2
    },
    d: "M43.98,239.42l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,239.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5202_",
    style: {
      fill: "#BA68C8"
    },
    d: "M45.14,239.52c0.88,0.51,1.6,1.75,1.6,2.76s-0.71,1.43-1.6,0.92 c-0.88-0.51-1.6-1.75-1.6-2.76C43.55,239.42,44.26,239.01,45.14,239.52z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5190_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5196_",
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M42.24,211.34l6.48,3.72c1.01,0.59,1.84,2.01,1.84,3.18v3.72c0,1.17-0.82,1.65-1.84,1.06 l-6.48-3.72c-1.01-0.59-1.84-2.01-1.84-3.18v-3.72C40.4,211.23,41.22,210.76,42.24,211.34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5191_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5192_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5195_",
    style: {
      fill: "#BA68C8"
    },
    d: "M43.98,215.54l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,215.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5194_",
    style: {
      opacity: 0.2
    },
    d: "M43.98,215.54l0.84-0.49l0,0l0.01,0l0,0c0.29-0.16,0.68-0.14,1.12,0.11 c0.88,0.51,1.6,1.75,1.6,2.76c0,0.51-0.18,0.87-0.47,1.03v0l0,0l0,0l-0.78,0.45l-0.14-0.24c-0.15-0.03-0.3-0.09-0.46-0.18 c-0.88-0.51-1.6-1.75-1.6-2.76c0-0.15,0.02-0.28,0.05-0.41L43.98,215.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5193_",
    style: {
      fill: "#BA68C8"
    },
    d: "M45.14,215.63c0.88,0.51,1.6,1.75,1.6,2.76s-0.71,1.43-1.6,0.92 c-0.88-0.51-1.6-1.75-1.6-2.76C43.55,215.53,44.26,215.12,45.14,215.63z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1244_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2648_",
    style: {
      fill: "#455A64"
    },
    d: "M142.65,331.2l-27.33,15.78c-1.01,0.59-1.84,2.01-1.84,3.18l0,3.72 c0,1.17,0.82,1.65,1.84,1.06l27.33-15.78c1.01-0.59,1.84-2.01,1.84-3.18v-3.72C144.48,331.09,143.66,330.62,142.65,331.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2145_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2647_",
    style: {
      fill: "#BA68C8"
    },
    d: "M142.55,334.35v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C142.38,334.02,142.55,334.11,142.55,334.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2639_",
    style: {
      fill: "#BA68C8"
    },
    d: "M140.69,335.42v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C140.53,335.09,140.69,335.18,140.69,335.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2638_",
    style: {
      fill: "#BA68C8"
    },
    d: "M138.83,336.49l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C138.67,336.16,138.83,336.25,138.83,336.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2637_",
    style: {
      fill: "#37474F"
    },
    d: "M136.98,337.56v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C136.81,337.23,136.98,337.32,136.98,337.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2636_",
    style: {
      fill: "#37474F"
    },
    d: "M135.12,338.63l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C134.96,338.3,135.12,338.39,135.12,338.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1255_",
    style: {
      fill: "#BA68C8"
    },
    d: "M133.27,339.7l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C133.1,339.37,133.27,339.46,133.27,339.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1254_",
    style: {
      fill: "#BA68C8"
    },
    d: "M131.41,340.77v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C131.24,340.44,131.41,340.53,131.41,340.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1253_",
    style: {
      fill: "#BA68C8"
    },
    d: "M129.55,341.84l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C129.39,341.51,129.55,341.6,129.55,341.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1252_",
    style: {
      fill: "#BA68C8"
    },
    d: "M127.7,342.91v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C127.53,342.58,127.7,342.67,127.7,342.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1251_",
    style: {
      fill: "#BA68C8"
    },
    d: "M125.84,343.98v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C125.68,343.65,125.84,343.74,125.84,343.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1250_",
    style: {
      fill: "#BA68C8"
    },
    d: "M123.98,345.05l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C123.82,344.72,123.98,344.81,123.98,345.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2401_",
    style: {
      fill: "#BA68C8"
    },
    d: "M122.13,346.12v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C121.96,345.79,122.13,345.88,122.13,346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1249_",
    style: {
      fill: "#37474F"
    },
    d: "M120.27,347.19v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C120.11,346.86,120.27,346.95,120.27,347.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1248_",
    style: {
      fill: "#BA68C8"
    },
    d: "M118.42,348.26v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C118.25,347.93,118.42,348.02,118.42,348.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1247_",
    style: {
      fill: "#BA68C8"
    },
    d: "M116.56,349.33v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C116.4,349,116.56,349.09,116.56,349.33z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_929_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1240_",
    style: {
      fill: "#455A64"
    },
    d: "M142.65,307.34l-27.33,15.78c-1.01,0.59-1.84,2.01-1.84,3.18l0,3.72 c0,1.17,0.82,1.65,1.84,1.06l27.33-15.78c1.01-0.59,1.84-2.01,1.84-3.18v-3.72C144.48,307.23,143.66,306.75,142.65,307.34z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_930_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1234_",
    style: {
      fill: "#BA68C8"
    },
    d: "M142.55,310.48v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C142.38,310.16,142.55,310.25,142.55,310.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1232_",
    style: {
      fill: "#37474F"
    },
    d: "M140.69,311.55v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C140.53,311.23,140.69,311.32,140.69,311.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1222_",
    style: {
      fill: "#BA68C8"
    },
    d: "M138.83,312.62l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C138.67,312.3,138.83,312.39,138.83,312.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1215_",
    style: {
      fill: "#37474F"
    },
    d: "M136.98,313.69v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C136.81,313.37,136.98,313.46,136.98,313.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1214_",
    style: {
      fill: "#37474F"
    },
    d: "M135.12,314.76l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C134.96,314.44,135.12,314.53,135.12,314.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1212_",
    style: {
      fill: "#BA68C8"
    },
    d: "M133.27,315.83l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C133.1,315.51,133.27,315.6,133.27,315.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1141_",
    style: {
      fill: "#BA68C8"
    },
    d: "M131.41,316.9v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C131.24,316.58,131.41,316.67,131.41,316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1137_",
    style: {
      fill: "#BA68C8"
    },
    d: "M129.55,317.97l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C129.39,317.64,129.55,317.74,129.55,317.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1246_",
    style: {
      fill: "#37474F"
    },
    d: "M127.7,319.04v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C127.53,318.71,127.7,318.81,127.7,319.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1245_",
    style: {
      fill: "#BA68C8"
    },
    d: "M125.84,320.11v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C125.68,319.79,125.84,319.88,125.84,320.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1135_",
    style: {
      fill: "#37474F"
    },
    d: "M123.98,321.18l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C123.82,320.85,123.98,320.95,123.98,321.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1134_",
    style: {
      fill: "#BA68C8"
    },
    d: "M122.13,322.25v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C121.96,321.92,122.13,322.02,122.13,322.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1133_",
    style: {
      fill: "#37474F"
    },
    d: "M120.27,323.32v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C120.11,322.99,120.27,323.09,120.27,323.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1132_",
    style: {
      fill: "#BA68C8"
    },
    d: "M118.42,324.39v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C118.25,324.06,118.42,324.16,118.42,324.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1131_",
    style: {
      fill: "#BA68C8"
    },
    d: "M116.56,325.46v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C116.4,325.13,116.56,325.23,116.56,325.46z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_865_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_928_",
    style: {
      fill: "#455A64"
    },
    d: "M142.65,283.45l-27.33,15.78c-1.01,0.59-1.84,2.01-1.84,3.18l0,3.72 c0,1.17,0.82,1.65,1.84,1.06l27.33-15.78c1.01-0.59,1.84-2.01,1.84-3.18v-3.72C144.48,283.33,143.66,282.86,142.65,283.45z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_926_",
    style: {
      fill: "#BA68C8"
    },
    d: "M142.55,286.59v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C142.38,286.26,142.55,286.36,142.55,286.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_925_",
    style: {
      fill: "#BA68C8"
    },
    d: "M140.69,287.66v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C140.53,287.33,140.69,287.43,140.69,287.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_924_",
    style: {
      fill: "#BA68C8"
    },
    d: "M138.83,288.73l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C138.67,288.4,138.83,288.5,138.83,288.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_920_",
    style: {
      fill: "#BA68C8"
    },
    d: "M136.98,289.8v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C136.81,289.47,136.98,289.57,136.98,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_912_",
    style: {
      fill: "#37474F"
    },
    d: "M135.12,290.87l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C134.96,290.54,135.12,290.64,135.12,290.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_910_",
    style: {
      fill: "#37474F"
    },
    d: "M133.27,291.94l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C133.1,291.61,133.27,291.71,133.27,291.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_909_",
    style: {
      fill: "#BA68C8"
    },
    d: "M131.41,293.01v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C131.24,292.68,131.41,292.78,131.41,293.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_905_",
    style: {
      fill: "#BA68C8"
    },
    d: "M129.55,294.08l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C129.39,293.75,129.55,293.85,129.55,294.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_900_",
    style: {
      fill: "#BA68C8"
    },
    d: "M127.7,295.15v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C127.53,294.82,127.7,294.92,127.7,295.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_899_",
    style: {
      fill: "#37474F"
    },
    d: "M125.84,296.22v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C125.68,295.89,125.84,295.99,125.84,296.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_877_",
    style: {
      fill: "#BA68C8"
    },
    d: "M123.98,297.29l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C123.82,296.96,123.98,297.06,123.98,297.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_875_",
    style: {
      fill: "#BA68C8"
    },
    d: "M122.13,298.36v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C121.96,298.03,122.13,298.13,122.13,298.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_872_",
    style: {
      fill: "#37474F"
    },
    d: "M120.27,299.43v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C120.11,299.1,120.27,299.2,120.27,299.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_871_",
    style: {
      fill: "#BA68C8"
    },
    d: "M118.42,300.5v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C118.25,300.17,118.42,300.27,118.42,300.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_867_",
    style: {
      fill: "#37474F"
    },
    d: "M116.56,301.57v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C116.4,301.24,116.56,301.34,116.56,301.57z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_535_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_864_",
    style: {
      fill: "#455A64"
    },
    d: "M142.65,259.59l-27.33,15.78c-1.01,0.59-1.84,2.01-1.84,3.18l0,3.72 c0,1.17,0.82,1.65,1.84,1.06l27.33-15.78c1.01-0.59,1.84-2.01,1.84-3.18v-3.72C144.48,259.48,143.66,259.01,142.65,259.59z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_536_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_860_",
    style: {
      fill: "#BA68C8"
    },
    d: "M142.55,262.74v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C142.38,262.41,142.55,262.51,142.55,262.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_859_",
    style: {
      fill: "#37474F"
    },
    d: "M140.69,263.81v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C140.53,263.48,140.69,263.58,140.69,263.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_858_",
    style: {
      fill: "#BA68C8"
    },
    d: "M138.83,264.88l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C138.67,264.55,138.83,264.65,138.83,264.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_857_",
    style: {
      fill: "#BA68C8"
    },
    d: "M136.98,265.95v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C136.81,265.62,136.98,265.72,136.98,265.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_854_",
    style: {
      fill: "#BA68C8"
    },
    d: "M135.12,267.02l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C134.96,266.69,135.12,266.79,135.12,267.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_853_",
    style: {
      fill: "#37474F"
    },
    d: "M133.27,268.09l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C133.1,267.76,133.27,267.86,133.27,268.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_852_",
    style: {
      fill: "#37474F"
    },
    d: "M131.41,269.16v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C131.24,268.83,131.41,268.93,131.41,269.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_851_",
    style: {
      fill: "#BA68C8"
    },
    d: "M129.55,270.23l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C129.39,269.9,129.55,270,129.55,270.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_744_",
    style: {
      fill: "#37474F"
    },
    d: "M127.7,271.3v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C127.53,270.97,127.7,271.07,127.7,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_737_",
    style: {
      fill: "#BA68C8"
    },
    d: "M125.84,272.37v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C125.68,272.04,125.84,272.14,125.84,272.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_668_",
    style: {
      fill: "#BA68C8"
    },
    d: "M123.98,273.44l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C123.82,273.11,123.98,273.21,123.98,273.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_539_",
    style: {
      fill: "#BA68C8"
    },
    d: "M122.13,274.51v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C121.96,274.18,122.13,274.28,122.13,274.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_538_",
    style: {
      fill: "#37474F"
    },
    d: "M120.27,275.58v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C120.11,275.25,120.27,275.35,120.27,275.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_881_",
    style: {
      fill: "#BA68C8"
    },
    d: "M118.42,276.65v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C118.25,276.32,118.42,276.42,118.42,276.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_537_",
    style: {
      fill: "#BA68C8"
    },
    d: "M116.56,277.72v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C116.4,277.39,116.56,277.49,116.56,277.72z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5186_",
    style: {
      fill: "#455A64"
    },
    d: "M142.65,235.68l-27.33,15.78c-1.01,0.59-1.84,2.01-1.84,3.18l0,3.72 c0,1.17,0.82,1.65,1.84,1.06l27.33-15.78c1.01-0.59,1.84-2.01,1.84-3.18v-3.72C144.48,235.57,143.66,235.1,142.65,235.68z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5170_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5185_",
    style: {
      fill: "#BA68C8"
    },
    d: "M142.55,238.83v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C142.38,238.5,142.55,238.59,142.55,238.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5184_",
    style: {
      fill: "#37474F"
    },
    d: "M140.69,239.9v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C140.53,239.57,140.69,239.66,140.69,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5183_",
    style: {
      fill: "#BA68C8"
    },
    d: "M138.83,240.97l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C138.67,240.64,138.83,240.73,138.83,240.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5182_",
    style: {
      fill: "#BA68C8"
    },
    d: "M136.98,242.04v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C136.81,241.71,136.98,241.8,136.98,242.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5181_",
    style: {
      fill: "#BA68C8"
    },
    d: "M135.12,243.11l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C134.96,242.78,135.12,242.87,135.12,243.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5180_",
    style: {
      fill: "#37474F"
    },
    d: "M133.27,244.18l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C133.1,243.85,133.27,243.94,133.27,244.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5179_",
    style: {
      fill: "#37474F"
    },
    d: "M131.41,245.25v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C131.24,244.92,131.41,245.01,131.41,245.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5178_",
    style: {
      fill: "#BA68C8"
    },
    d: "M129.55,246.32l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C129.39,245.99,129.55,246.08,129.55,246.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5177_",
    style: {
      fill: "#37474F"
    },
    d: "M127.7,247.39v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C127.53,247.06,127.7,247.15,127.7,247.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5176_",
    style: {
      fill: "#BA68C8"
    },
    d: "M125.84,248.46v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C125.68,248.13,125.84,248.22,125.84,248.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5175_",
    style: {
      fill: "#BA68C8"
    },
    d: "M123.98,249.53l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C123.82,249.2,123.98,249.29,123.98,249.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5174_",
    style: {
      fill: "#BA68C8"
    },
    d: "M122.13,250.6v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C121.96,250.27,122.13,250.36,122.13,250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5173_",
    style: {
      fill: "#37474F"
    },
    d: "M120.27,251.67v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C120.11,251.34,120.27,251.43,120.27,251.67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5172_",
    style: {
      fill: "#BA68C8"
    },
    d: "M118.42,252.74v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C118.25,252.41,118.42,252.5,118.42,252.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5171_",
    style: {
      fill: "#BA68C8"
    },
    d: "M116.56,253.81v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C116.4,253.48,116.56,253.57,116.56,253.81z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_520_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5168_",
    style: {
      fill: "#455A64"
    },
    d: "M142.65,211.81l-27.33,15.78c-1.01,0.59-1.84,2.01-1.84,3.18l0,3.72 c0,1.17,0.82,1.65,1.84,1.06l27.33-15.78c1.01-0.59,1.84-2.01,1.84-3.18v-3.72C144.48,211.7,143.66,211.22,142.65,211.81z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_522_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5167_",
    style: {
      fill: "#37474F"
    },
    d: "M142.55,214.96v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C142.38,214.63,142.55,214.72,142.55,214.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5166_",
    style: {
      fill: "#BA68C8"
    },
    d: "M140.69,216.03v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C140.53,215.7,140.69,215.79,140.69,216.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5164_",
    style: {
      fill: "#37474F"
    },
    d: "M138.83,217.1l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C138.67,216.77,138.83,216.86,138.83,217.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5163_",
    style: {
      fill: "#37474F"
    },
    d: "M136.98,218.17v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C136.81,217.84,136.98,217.93,136.98,218.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5161_",
    style: {
      fill: "#37474F"
    },
    d: "M135.12,219.24l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C134.96,218.91,135.12,219,135.12,219.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5160_",
    style: {
      fill: "#BA68C8"
    },
    d: "M133.27,220.31l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C133.1,219.98,133.27,220.07,133.27,220.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_534_",
    style: {
      fill: "#BA68C8"
    },
    d: "M131.41,221.38v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C131.24,221.05,131.41,221.14,131.41,221.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5157_",
    style: {
      fill: "#37474F"
    },
    d: "M129.55,222.45l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C129.39,222.12,129.55,222.21,129.55,222.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5156_",
    style: {
      fill: "#BA68C8"
    },
    d: "M127.7,223.52v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C127.53,223.19,127.7,223.28,127.7,223.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5154_",
    style: {
      fill: "#37474F"
    },
    d: "M125.84,224.59v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C125.68,224.26,125.84,224.35,125.84,224.59z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5153_",
    style: {
      fill: "#37474F"
    },
    d: "M123.98,225.66l0,1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C123.82,225.33,123.98,225.42,123.98,225.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5151_",
    style: {
      fill: "#37474F"
    },
    d: "M122.13,226.73v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C121.96,226.4,122.13,226.49,122.13,226.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5149_",
    style: {
      fill: "#BA68C8"
    },
    d: "M120.27,227.8v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C120.11,227.47,120.27,227.56,120.27,227.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_525_",
    style: {
      fill: "#37474F"
    },
    d: "M118.42,228.87v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C118.25,228.54,118.42,228.63,118.42,228.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_524_",
    style: {
      fill: "#37474F"
    },
    d: "M116.56,229.94v1.8c0,0.23-0.16,0.52-0.37,0.64l-0.41,0.24 c-0.2,0.12-0.37,0.02-0.37-0.21v-1.8c0-0.23,0.16-0.52,0.37-0.64l0.41-0.24C116.4,229.61,116.56,229.7,116.56,229.94z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_514_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1990_",
    style: {
      fill: "#BA68C8"
    },
    d: "M108.59,353.78l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,353.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1874_",
    style: {
      opacity: 0.4
    },
    d: "M108.59,353.78l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,353.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1463_",
    style: {
      fill: "#BA68C8"
    },
    d: "M107.43,353.87c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,353.78,108.31,353.36,107.43,353.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_515_",
    style: {
      opacity: 0.2
    },
    d: "M107.43,353.87c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,353.78,108.31,353.36,107.43,353.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_495_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_513_",
    style: {
      fill: "#BA68C8"
    },
    d: "M101.66,357.78l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,357.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_511_",
    style: {
      opacity: 0.4
    },
    d: "M101.66,357.78l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,357.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_506_",
    style: {
      fill: "#BA68C8"
    },
    d: "M100.5,357.87c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,357.78,101.38,357.36,100.5,357.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_503_",
    style: {
      opacity: 0.2
    },
    d: "M100.5,357.87c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,357.78,101.38,357.36,100.5,357.87z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_488_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_492_",
    style: {
      fill: "#BA68C8"
    },
    d: "M108.59,329.91l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,329.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_491_",
    style: {
      opacity: 0.4
    },
    d: "M108.59,329.91l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,329.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_490_",
    style: {
      fill: "#BA68C8"
    },
    d: "M107.43,330.01c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,329.91,108.31,329.5,107.43,330.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_489_",
    style: {
      opacity: 0.2
    },
    d: "M107.43,330.01c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,329.91,108.31,329.5,107.43,330.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_479_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_483_",
    style: {
      fill: "#BA68C8"
    },
    d: "M101.66,333.91l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,333.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_482_",
    style: {
      opacity: 0.4
    },
    d: "M101.66,333.91l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,333.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_481_",
    style: {
      fill: "#BA68C8"
    },
    d: "M100.5,334c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,333.91,101.38,333.49,100.5,334z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_480_",
    style: {
      opacity: 0.2
    },
    d: "M100.5,334c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,333.91,101.38,333.49,100.5,334z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_470_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_477_",
    style: {
      fill: "#BA68C8"
    },
    d: "M108.59,306.05l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,306.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_473_",
    style: {
      opacity: 0.4
    },
    d: "M108.59,306.05l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,306.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_472_",
    style: {
      fill: "#BA68C8"
    },
    d: "M107.43,306.14c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,306.04,108.31,305.63,107.43,306.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_471_",
    style: {
      opacity: 0.2
    },
    d: "M107.43,306.14c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,306.04,108.31,305.63,107.43,306.14z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_447_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    style: {
      fill: "#BA68C8"
    },
    d: "M101.66,310.04l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,310.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_466_",
    style: {
      opacity: 0.4
    },
    d: "M101.66,310.04l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,310.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_465_",
    style: {
      fill: "#BA68C8"
    },
    d: "M100.5,310.13c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,310.04,101.38,309.63,100.5,310.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_464_",
    style: {
      opacity: 0.2
    },
    d: "M100.5,310.13c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,310.04,101.38,309.63,100.5,310.13z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_843_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    style: {
      fill: "#BA68C8"
    },
    d: "M108.59,282.18l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,282.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    style: {
      opacity: 0.4
    },
    d: "M108.59,282.18l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,282.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    style: {
      fill: "#BA68C8"
    },
    d: "M107.43,282.27c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,282.17,108.31,281.76,107.43,282.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    style: {
      opacity: 0.2
    },
    d: "M107.43,282.27c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,282.17,108.31,281.76,107.43,282.27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_400_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_412_",
    style: {
      fill: "#BA68C8"
    },
    d: "M101.66,286.17l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,286.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_409_",
    style: {
      opacity: 0.4
    },
    d: "M101.66,286.17l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,286.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_407_",
    style: {
      fill: "#BA68C8"
    },
    d: "M100.5,286.27c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,286.17,101.38,285.76,100.5,286.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_406_",
    style: {
      opacity: 0.2
    },
    d: "M100.5,286.27c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,286.17,101.38,285.76,100.5,286.27z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5104_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5111_",
    style: {
      fill: "#BA68C8"
    },
    d: "M108.59,258.26l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,258.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5109_",
    style: {
      opacity: 0.4
    },
    d: "M108.59,258.26l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,258.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5107_",
    style: {
      fill: "#BA68C8"
    },
    d: "M107.43,258.35c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,258.26,108.31,257.84,107.43,258.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5105_",
    style: {
      opacity: 0.2
    },
    d: "M107.43,258.35c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C109.02,258.26,108.31,257.84,107.43,258.35z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5092_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5103_",
    style: {
      fill: "#BA68C8"
    },
    d: "M101.66,262.26l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,262.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5100_",
    style: {
      opacity: 0.4
    },
    d: "M101.66,262.26l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,262.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5098_",
    style: {
      fill: "#BA68C8"
    },
    d: "M100.5,262.35c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,262.26,101.38,261.84,100.5,262.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5093_",
    style: {
      opacity: 0.2
    },
    d: "M100.5,262.35c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,262.26,101.38,261.84,100.5,262.35z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5062_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5090_",
    style: {
      fill: "#BA68C8"
    },
    d: "M108.59,234.4l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5089_",
    style: {
      opacity: 0.4
    },
    d: "M108.59,234.4l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0l0,0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L108.59,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_292_",
    style: {
      fill: "#BA68C8"
    },
    d: "M107.43,234.49c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76S108.31,233.98,107.43,234.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5071_",
    style: {
      opacity: 0.2
    },
    d: "M107.43,234.49c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76S108.31,233.98,107.43,234.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5042_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5060_",
    style: {
      fill: "#BA68C8"
    },
    d: "M101.66,238.4l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0h0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5056_",
    style: {
      opacity: 0.4
    },
    d: "M101.66,238.4l-0.84-0.49l0,0l-0.01,0l0,0c-0.29-0.16-0.68-0.14-1.12,0.11 c-0.88,0.51-1.6,1.75-1.6,2.76c0,0.51,0.18,0.87,0.47,1.03v0l0,0h0l0.78,0.45l0.14-0.24c0.15-0.03,0.3-0.09,0.46-0.18 c0.88-0.51,1.6-1.75,1.6-2.76c0-0.15-0.02-0.28-0.05-0.41L101.66,238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5046_",
    style: {
      fill: "#BA68C8"
    },
    d: "M100.5,238.49c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,238.39,101.38,237.98,100.5,238.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5045_",
    style: {
      opacity: 0.2
    },
    d: "M100.5,238.49c-0.88,0.51-1.6,1.75-1.6,2.76c0,1.02,0.71,1.43,1.6,0.92 c0.88-0.51,1.6-1.75,1.6-2.76C102.09,238.39,101.38,237.98,100.5,238.49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5121_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5125_",
    style: {
      fill: "#455A64"
    },
    d: "M55.75,289.34l31.41,18.12c0.56,0.32,1.02,1.11,1.02,1.76l0,8.67 c0,0.65-0.46,0.91-1.02,0.59l-31.41-18.12c-0.56-0.32-1.02-1.11-1.02-1.76l0-8.67C54.73,289.28,55.19,289.02,55.75,289.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5124_",
    style: {
      fill: "#BA68C8"
    },
    d: "M56.64,293.17c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,292.33,56.64,292.56,56.64,293.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5123_",
    style: {
      fill: "#263238"
    },
    d: "M56.64,297.58c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,296.74,56.64,296.97,56.64,297.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5122_",
    style: {
      fill: "#BA68C8"
    },
    d: "M57.66,297.06l15.24,8.78l0,2.2l-15.24-8.78c-0.56-0.32-1.02-1.08-1.02-1.69 C56.64,296.97,57.1,296.74,57.66,297.06z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4901_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5120_",
    style: {
      fill: "#455A64"
    },
    d: "M55.75,313.27l31.41,18.12c0.56,0.32,1.02,1.11,1.02,1.76l0,8.67 c0,0.65-0.46,0.91-1.02,0.59l-31.41-18.12c-0.56-0.32-1.02-1.11-1.02-1.76l0-8.67C54.73,313.2,55.19,312.94,55.75,313.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5119_",
    style: {
      fill: "#BA68C8"
    },
    d: "M56.64,317.09c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,316.25,56.64,316.48,56.64,317.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5118_",
    style: {
      fill: "#263238"
    },
    d: "M56.64,321.5c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,320.66,56.64,320.89,56.64,321.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5117_",
    style: {
      fill: "#BA68C8"
    },
    d: "M57.66,320.98l19.06,10.99l0,2.2l-19.06-10.99c-0.56-0.32-1.02-1.08-1.02-1.69 S57.1,320.66,57.66,320.98z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_286_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2890_",
    style: {
      fill: "#455A64"
    },
    d: "M55.75,337.01l31.41,18.12c0.56,0.32,1.02,1.11,1.02,1.76l0,8.67 c0,0.65-0.46,0.91-1.02,0.59l-31.41-18.12c-0.56-0.32-1.02-1.11-1.02-1.76l0-8.67C54.73,336.95,55.19,336.69,55.75,337.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2855_",
    style: {
      fill: "#BA68C8"
    },
    d: "M56.64,340.84c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,340,56.64,340.23,56.64,340.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_288_",
    style: {
      fill: "#263238"
    },
    d: "M56.64,345.25c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,344.41,56.64,344.64,56.64,345.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    style: {
      fill: "#BA68C8"
    },
    d: "M57.66,344.73l22.88,13.19l0,2.2l-22.88-13.19c-0.56-0.32-1.02-1.08-1.02-1.69 S57.1,344.41,57.66,344.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5126_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5130_",
    style: {
      fill: "#455A64"
    },
    d: "M55.75,265.65l31.41,18.12c0.56,0.32,1.02,1.11,1.02,1.76l0,8.67 c0,0.65-0.46,0.91-1.02,0.59l-31.41-18.12c-0.56-0.32-1.02-1.11-1.02-1.76l0-8.67C54.73,265.59,55.19,265.33,55.75,265.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5129_",
    style: {
      fill: "#BA68C8"
    },
    d: "M56.64,269.48c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,268.64,56.64,268.87,56.64,269.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5128_",
    style: {
      fill: "#263238"
    },
    d: "M56.64,273.88c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,273.05,56.64,273.28,56.64,273.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5127_",
    style: {
      fill: "#BA68C8"
    },
    d: "M57.66,273.37l24.79,14.3v2.2l-24.79-14.3c-0.56-0.32-1.02-1.08-1.02-1.69 S57.1,273.05,57.66,273.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4988_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5025_",
    style: {
      fill: "#455A64"
    },
    d: "M55.75,217.86l31.41,18.12c0.56,0.32,1.02,1.11,1.02,1.76l0,8.67 c0,0.65-0.46,0.91-1.02,0.59l-31.41-18.12c-0.56-0.32-1.02-1.11-1.02-1.76l0-8.67C54.73,217.8,55.19,217.54,55.75,217.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5024_",
    style: {
      fill: "#BA68C8"
    },
    d: "M56.64,221.68c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,220.84,56.64,221.07,56.64,221.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4994_",
    style: {
      fill: "#263238"
    },
    d: "M56.64,226.09c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,225.25,56.64,225.48,56.64,226.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4991_",
    style: {
      fill: "#BA68C8"
    },
    d: "M57.66,225.58l19.06,10.99l0,2.2l-19.06-10.99c-0.56-0.32-1.02-1.08-1.02-1.69 C56.64,225.48,57.1,225.25,57.66,225.58z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_281_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4979_",
    style: {
      fill: "#455A64"
    },
    d: "M55.75,241.74l31.41,18.12c0.56,0.32,1.02,1.11,1.02,1.76l0,8.67 c0,0.65-0.46,0.91-1.02,0.59l-31.41-18.12c-0.56-0.32-1.02-1.11-1.02-1.76l0-8.67C54.73,241.68,55.19,241.42,55.75,241.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4978_",
    style: {
      fill: "#BA68C8"
    },
    d: "M56.64,245.56c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,244.72,56.64,244.95,56.64,245.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    style: {
      fill: "#263238"
    },
    d: "M56.64,249.97c0,0.61,0.46,1.37,1.02,1.69l27.59,15.91 c0.56,0.32,1.02,0.09,1.02-0.51c0-0.61-0.46-1.37-1.02-1.69l-27.59-15.91C57.1,249.13,56.64,249.36,56.64,249.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    style: {
      fill: "#BA68C8"
    },
    d: "M57.66,249.46l24.79,14.3v2.2l-24.79-14.3c-0.56-0.32-1.02-1.08-1.02-1.69 S57.1,249.13,57.66,249.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4865_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4900_",
    style: {
      fill: "#BA68C8"
    },
    d: "M94.1,226.27L131,204.96c0.53-0.3,0.95-1.04,0.95-1.65v-1.24 c0-0.61-0.43-1.35-0.95-1.65L94.1,179.1c-0.53-0.3-1.38-0.3-1.91,0l-36.91,21.31c-0.53,0.3-0.95,1.04-0.95,1.65v1.24 c0,0.61,0.43,1.35,0.95,1.65l36.91,21.31C92.71,226.57,93.57,226.57,94.1,226.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_280_",
    style: {
      opacity: 0.35
    },
    d: "M94.1,226.27L131,204.96c0.53-0.3,0.95-1.04,0.95-1.65v-1.24 c0-0.61-0.43-1.35-0.95-1.65L94.1,179.1c-0.53-0.3-1.38-0.3-1.91,0l-36.91,21.31c-0.53,0.3-0.95,1.04-0.95,1.65v1.24 c0,0.61,0.43,1.35,0.95,1.65l36.91,21.31C92.71,226.57,93.57,226.57,94.1,226.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4899_",
    style: {
      fill: "#BA68C8"
    },
    d: "M131,201.51L94.1,222.82c-0.53,0.3-1.38,0.3-1.91,0l-36.91-21.31 c-0.53-0.3-0.53-0.8,0-1.1l36.91-21.31c0.53-0.3,1.38-0.3,1.91,0L131,200.41C131.53,200.72,131.53,201.21,131,201.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4882_",
    style: {
      fill: "#BA68C8"
    },
    d: "M93.14,223.05v3.45c0.35,0,0.69-0.07,0.96-0.23L131,204.96 c0.53-0.3,0.96-1.04,0.96-1.65v-1.24c0-0.54-0.33-1.18-0.78-1.53c0.35,0.3,0.29,0.71-0.18,0.98L94.1,222.82 C93.83,222.98,93.49,223.05,93.14,223.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    style: {
      opacity: 0.2
    },
    d: "M93.14,223.05v3.45c0.35,0,0.69-0.07,0.96-0.23L131,204.96 c0.53-0.3,0.96-1.04,0.96-1.65v-1.24c0-0.54-0.33-1.18-0.78-1.53c0.35,0.3,0.29,0.71-0.18,0.98L94.1,222.82 C93.83,222.98,93.49,223.05,93.14,223.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2905_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4535_",
    style: {
      fill: "#263238"
    },
    d: "M94.1,215.93l24.96-14.41c0.53-0.3,0.95-1.04,0.95-1.65v-1.24 c0-0.61-0.43-1.35-0.95-1.65l-16-9.24c-0.53-0.3-1.25-0.95-1.61-1.44l-7.64-10.3c-0.36-0.49-1.08-0.64-1.61-0.33l-24.96,14.41 c-0.53,0.3-0.95,1.04-0.95,1.65l0,8.14c0,0.61,0.43,1.35,0.95,1.65l24.96,14.41C92.71,216.23,93.57,216.23,94.1,215.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4532_",
    style: {
      fill: "#455A64"
    },
    d: "M92.19,212.48l-16-9.24c-0.25-0.15-0.55-0.37-0.84-0.62 c-0.3-0.27-0.59-0.56-0.78-0.82l-7.64-10.3c-0.36-0.49-0.23-1.13,0.3-1.44l24.96-14.41c0.53-0.3,1.25-0.15,1.61,0.33l7.64,10.3 c0.36,0.49,0.95,1.19,1.48,1.49l16.14,9.18c0.53,0.3,0.53,0.8,0,1.1L94.1,212.48C93.57,212.78,92.71,212.78,92.19,212.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4531_",
    style: {
      fill: "#37474F"
    },
    d: "M67.22,190.07l24.96-14.41c0.53-0.3,1.25-0.15,1.61,0.33l7.64,10.3 c0.19,0.25,0.48,0.55,0.78,0.81c0,0-26.87,15.52-26.87,15.51c-0.3-0.27-0.59-0.56-0.78-0.81l-7.64-10.3 C66.56,191.02,66.7,190.37,67.22,190.07z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3665_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4168_",
    style: {
      fill: "#BA68C8"
    },
    d: "M113,197.22c-0.62-0.36-1.62-0.36-2.24,0s-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C113.62,198.15,113.62,197.57,113,197.22z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_275_",
    style: {
      fill: "#BA68C8"
    },
    cx: 107.4,
    cy: 200.45,
    rx: 1.58,
    ry: 0.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_274_",
    style: {
      fill: "#263238"
    },
    cx: 102.93,
    cy: 203.03,
    rx: 1.58,
    ry: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_273_",
    style: {
      fill: "#263238"
    },
    d: "M99.57,204.97c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C100.19,205.91,100.19,205.33,99.57,204.97z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3921_",
    style: {
      fill: "#BA68C8"
    },
    cx: 108.52,
    cy: 195.92,
    rx: 1.58,
    ry: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3920_",
    style: {
      fill: "#263238"
    },
    d: "M105.17,197.86c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C105.78,198.8,105.78,198.22,105.17,197.86z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3919_",
    style: {
      fill: "#BA68C8"
    },
    cx: 99.57,
    cy: 201.1,
    rx: 1.58,
    ry: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3726_",
    style: {
      fill: "#263238"
    },
    d: "M96.21,203.03c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 s1.62,0.36,2.24,0C96.83,203.97,96.83,203.39,96.21,203.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3725_",
    style: {
      fill: "#263238"
    },
    d: "M106.28,193.34c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 s1.62,0.36,2.24,0C106.9,194.27,106.9,193.7,106.28,193.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3724_",
    style: {
      fill: "#BA68C8"
    },
    d: "M101.81,195.92c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C102.42,196.86,102.42,196.28,101.81,195.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3723_",
    style: {
      fill: "#263238"
    },
    d: "M97.33,198.51c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C97.95,199.45,97.95,198.87,97.33,198.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3721_",
    style: {
      fill: "#BA68C8"
    },
    d: "M95.06,207.51c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C95.68,208.44,95.68,207.87,95.06,207.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3720_",
    style: {
      fill: "#263238"
    },
    d: "M91.7,205.57c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C92.32,206.5,92.32,205.93,91.7,205.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3719_",
    style: {
      fill: "#263238"
    },
    d: "M92.85,201.1c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C93.47,202.03,93.47,201.45,92.85,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3718_",
    style: {
      fill: "#BA68C8"
    },
    d: "M102.93,191.4c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C103.54,192.34,103.54,191.76,102.93,191.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3717_",
    style: {
      fill: "#263238"
    },
    d: "M98.45,193.99c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C99.07,194.92,99.07,194.34,98.45,193.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3669_",
    style: {
      fill: "#BA68C8"
    },
    d: "M93.97,196.57c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C94.59,197.51,94.59,196.93,93.97,196.57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3668_",
    style: {
      fill: "#263238"
    },
    d: "M89.49,199.16c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C90.11,200.09,90.11,199.52,89.49,199.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3667_",
    style: {
      fill: "#BA68C8"
    },
    d: "M88.35,203.63c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C88.96,204.57,88.96,203.99,88.35,203.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3666_",
    style: {
      fill: "#263238"
    },
    d: "M84.99,201.69c-0.62-0.36-1.62-0.36-2.24,0c-0.62,0.36-0.62,0.94,0,1.29 c0.62,0.36,1.62,0.36,2.24,0C85.61,202.63,85.61,202.05,84.99,201.69z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3498_",
    style: {
      fill: "#37474F"
    },
    d: "M93.09,212.71v3.44c0.36,0.01,0.73-0.06,1.01-0.22l24.96-14.41 c0.53-0.3,0.96-1.04,0.96-1.65v-1.24c0-0.54-0.33-1.18-0.78-1.53c0.35,0.3,0.29,0.71-0.18,0.98L94.1,212.48 C93.82,212.64,93.45,212.71,93.09,212.71z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2916_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3480_",
    style: {
      fill: "#263238"
    },
    d: "M98.14,185.86l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-21.72,12.54 c-0.35,0.2-0.44,0.63-0.2,0.96l0.02,0.03c0.24,0.33,0.72,0.42,1.08,0.22l21.72-12.54C98.29,186.61,98.38,186.18,98.14,185.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3044_",
    style: {
      fill: "#BA68C8"
    },
    d: "M98.14,185.86l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-16.15,9.32 l0.9,1.21l16.14-9.32C98.29,186.61,98.38,186.18,98.14,185.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3036_",
    style: {
      fill: "#263238"
    },
    d: "M96.35,183.45l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-21.72,12.54 c-0.35,0.2-0.44,0.63-0.2,0.96l0.02,0.03c0.24,0.33,0.72,0.42,1.08,0.22l21.72-12.54C96.5,184.2,96.59,183.77,96.35,183.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3027_",
    style: {
      fill: "#BA68C8"
    },
    d: "M96.35,183.45l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-5.4,3.12l0.9,1.21 l5.39-3.11C96.5,184.2,96.59,183.77,96.35,183.45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3011_",
    style: {
      fill: "#263238"
    },
    d: "M94.55,181.04l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-21.72,12.54 c-0.35,0.2-0.44,0.63-0.2,0.96l0.02,0.03c0.24,0.33,0.72,0.42,1.08,0.22L94.35,182C94.7,181.79,94.79,181.36,94.55,181.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3010_",
    style: {
      fill: "#BA68C8"
    },
    d: "M94.55,181.04l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-11.31,6.51 l0.9,1.21l11.31-6.51C94.7,181.79,94.79,181.36,94.55,181.04z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3009_",
    style: {
      fill: "#263238"
    },
    d: "M92.75,178.63l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-21.72,12.54 c-0.35,0.2-0.44,0.63-0.2,0.96l0.02,0.03c0.24,0.33,0.72,0.42,1.08,0.22l21.72-12.54C92.91,179.38,93,178.95,92.75,178.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2971_",
    style: {
      fill: "#BA68C8"
    },
    d: "M92.75,178.63l-0.02-0.03c-0.24-0.33-0.72-0.43-1.07-0.22l-19.72,11.38 l0.9,1.21l19.71-11.38C92.91,179.38,93,178.95,92.75,178.63z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Cable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M166.69,384.77l-10.96-6.32c-1.05-0.61-2.7-0.61-3.76,0l-59.82,34.54c-0.81,0.46-2.17,0.46-2.98,0 l-72.46-41.83c-0.32-0.19-0.5-0.42-0.5-0.64c0-0.22,0.18-0.45,0.5-0.63l33.08-19.1c0.02-0.01,0.02-0.02,0.04-0.02 c0.02-0.01,0.04-0.02,0.06-0.04c0.02-0.04,0.04-0.09,0.04-0.15c0-0.17-0.12-0.39-0.28-0.47c-0.07-0.04-0.13-0.05-0.18-0.02 c-0.02,0-0.05,0.02-0.06,0.03l-33.09,19.1c-0.57,0.33-0.89,0.79-0.89,1.31c0,0.51,0.32,0.98,0.89,1.31l72.46,41.83 c0.53,0.3,1.21,0.46,1.88,0.46c0.68,0,1.35-0.16,1.87-0.46l59.82-34.53c0.81-0.47,2.18-0.47,2.98,0l10.96,6.32 c0.19,0.11,0.42,0.04,0.53-0.15C166.94,385.12,166.88,384.88,166.69,384.77z M173.01,381.13l-17.27-9.97 c-1.05-0.61-2.7-0.61-3.76,0l-59.82,34.53c-0.81,0.47-2.17,0.47-2.98,0l-59.82-34.53c-0.32-0.19-0.5-0.42-0.5-0.64 c0-0.22,0.18-0.44,0.5-0.63l26.86-15.45c0.01,0,0.01,0,0.02-0.01c0.05-0.02,0.08-0.09,0.08-0.17c0-0.18-0.12-0.39-0.28-0.48 c-0.06-0.04-0.12-0.05-0.16-0.03c-0.03,0.01-0.05,0.02-0.07,0.05l-26.82,15.41c-0.58,0.33-0.89,0.8-0.89,1.31 c0,0.51,0.31,0.98,0.89,1.31l59.82,34.53c0.53,0.3,1.21,0.46,1.88,0.46c0.68,0,1.35-0.16,1.87-0.46l59.82-34.53 c0.81-0.47,2.18-0.47,2.98,0l17.27,9.97c0.19,0.11,0.43,0.04,0.53-0.15C173.26,381.47,173.2,381.23,173.01,381.13z M185.65,373.83 l-29.91-17.27c-1.05-0.61-2.7-0.61-3.76,0L92.16,391.1c-0.81,0.47-2.17,0.47-2.98,0l-34.54-19.94c-0.32-0.19-0.51-0.42-0.51-0.64 c0-0.22,0.19-0.45,0.51-0.63l14.11-8.15c0.02-0.01,0.03-0.02,0.05-0.03c0.02-0.01,0.04-0.02,0.05-0.04 c0.03-0.03,0.05-0.09,0.05-0.15c0-0.17-0.12-0.39-0.28-0.47c-0.07-0.04-0.13-0.05-0.18-0.02l-14.19,8.19 c-0.58,0.33-0.89,0.79-0.89,1.31c0,0.51,0.32,0.98,0.89,1.31l34.54,19.94c0.53,0.3,1.21,0.45,1.88,0.45 c0.68,0,1.35-0.15,1.87-0.45l59.82-34.54c0.81-0.46,2.17-0.46,2.98,0l29.91,17.27c0.19,0.11,0.43,0.04,0.53-0.15 C185.9,374.17,185.83,373.94,185.65,373.83z M179.33,377.48l-23.6-13.62c-1.05-0.61-2.7-0.61-3.76,0l-59.82,34.53 c-0.81,0.47-2.17,0.47-2.98,0L42,371.16c-0.32-0.19-0.51-0.42-0.51-0.64c0-0.22,0.19-0.45,0.51-0.63l20.49-11.83 c0,0,0.01-0.01,0.02-0.01c0.04-0.03,0.07-0.09,0.07-0.18c0-0.17-0.12-0.39-0.27-0.47c-0.07-0.04-0.14-0.05-0.19-0.02 c0,0,0,0-0.01,0l-20.5,11.84c-0.58,0.33-0.89,0.79-0.89,1.31c0,0.51,0.32,0.98,0.89,1.31l47.18,27.24 c0.53,0.3,1.21,0.46,1.88,0.46c0.68,0,1.35-0.16,1.87-0.46l59.82-34.54c0.81-0.46,2.18-0.46,2.98,0l23.6,13.63 c0.19,0.1,0.42,0.04,0.53-0.15C179.58,377.82,179.52,377.59,179.33,377.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M166.69,384.77l-10.96-6.32c-1.05-0.61-2.7-0.61-3.76,0l-59.82,34.54 c-0.81,0.46-2.17,0.46-2.98,0l-72.46-41.83c-0.32-0.19-0.5-0.42-0.5-0.64c0-0.22,0.18-0.45,0.5-0.63l33.08-19.1 c0.02-0.01,0.02-0.02,0.04-0.02c0.02-0.01,0.04-0.02,0.06-0.04c0.02-0.04,0.04-0.09,0.04-0.15c0-0.17-0.12-0.39-0.28-0.47 c-0.07-0.04-0.13-0.05-0.18-0.02c-0.02,0-0.05,0.02-0.06,0.03l-33.09,19.1c-0.57,0.33-0.89,0.79-0.89,1.31 c0,0.51,0.32,0.98,0.89,1.31l72.46,41.83c0.53,0.3,1.21,0.46,1.88,0.46c0.68,0,1.35-0.16,1.87-0.46l59.82-34.53 c0.81-0.47,2.18-0.47,2.98,0l10.96,6.32c0.19,0.11,0.42,0.04,0.53-0.15C166.94,385.12,166.88,384.88,166.69,384.77z  M173.01,381.13l-17.27-9.97c-1.05-0.61-2.7-0.61-3.76,0l-59.82,34.53c-0.81,0.47-2.17,0.47-2.98,0l-59.82-34.53 c-0.32-0.19-0.5-0.42-0.5-0.64c0-0.22,0.18-0.44,0.5-0.63l26.86-15.45c0.01,0,0.01,0,0.02-0.01c0.05-0.02,0.08-0.09,0.08-0.17 c0-0.18-0.12-0.39-0.28-0.48c-0.06-0.04-0.12-0.05-0.16-0.03c-0.03,0.01-0.05,0.02-0.07,0.05l-26.82,15.41 c-0.58,0.33-0.89,0.8-0.89,1.31c0,0.51,0.31,0.98,0.89,1.31l59.82,34.53c0.53,0.3,1.21,0.46,1.88,0.46c0.68,0,1.35-0.16,1.87-0.46 l59.82-34.53c0.81-0.47,2.18-0.47,2.98,0l17.27,9.97c0.19,0.11,0.43,0.04,0.53-0.15C173.26,381.47,173.2,381.23,173.01,381.13z  M179.33,377.48l-23.6-13.62c-1.05-0.61-2.7-0.61-3.76,0l-59.82,34.53c-0.81,0.47-2.17,0.47-2.98,0L42,371.16 c-0.32-0.19-0.51-0.42-0.51-0.64c0-0.22,0.19-0.45,0.51-0.63l20.49-11.83c0,0,0.01-0.01,0.02-0.01c0.04-0.03,0.07-0.09,0.07-0.18 c0-0.17-0.12-0.39-0.27-0.47c-0.07-0.04-0.14-0.05-0.19-0.02c0,0,0,0-0.01,0l-20.5,11.84c-0.58,0.33-0.89,0.79-0.89,1.31 c0,0.51,0.32,0.98,0.89,1.31l47.18,27.24c0.53,0.3,1.21,0.46,1.88,0.46c0.68,0,1.35-0.16,1.87-0.46l59.82-34.54 c0.81-0.46,2.18-0.46,2.98,0l23.6,13.63c0.19,0.1,0.42,0.04,0.53-0.15C179.58,377.82,179.52,377.59,179.33,377.48z M185.65,373.83 l-29.91-17.27c-1.05-0.61-2.7-0.61-3.76,0L92.16,391.1c-0.81,0.47-2.17,0.47-2.98,0l-34.54-19.94c-0.32-0.19-0.51-0.42-0.51-0.64 c0-0.22,0.19-0.45,0.51-0.63l14.11-8.15c0.02-0.01,0.03-0.02,0.05-0.03c0.02-0.01,0.04-0.02,0.05-0.04 c0.03-0.03,0.05-0.09,0.05-0.15c0-0.17-0.12-0.39-0.28-0.47c-0.07-0.04-0.13-0.05-0.18-0.02l-14.19,8.19 c-0.58,0.33-0.89,0.79-0.89,1.31c0,0.51,0.32,0.98,0.89,1.31l34.54,19.94c0.53,0.3,1.21,0.45,1.88,0.45 c0.68,0,1.35-0.15,1.87-0.45l59.82-34.54c0.81-0.46,2.17-0.46,2.98,0l29.91,17.27c0.19,0.11,0.43,0.04,0.53-0.15 C185.9,374.17,185.83,373.94,185.65,373.83z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M70.33,130.34c-0.26,0-0.47,0.21-0.47,0.47v42.92c0,0.26,0.21,0.47,0.47,0.47s0.47-0.21,0.47-0.47 V130.8C70.8,130.54,70.59,130.34,70.33,130.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M70.33,130.34c-0.26,0-0.47,0.21-0.47,0.47v42.92c0,0.26,0.21,0.47,0.47,0.47 s0.47-0.21,0.47-0.47V130.8C70.8,130.54,70.59,130.34,70.33,130.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M68.3,133.53c0-1.3,0.91-2.87,2.03-3.52c1.12-0.65,2.03-0.12,2.03,1.17c0,1.3-0.91,2.87-2.03,3.52 C69.21,135.35,68.3,134.83,68.3,133.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Folder_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M95.79,105.07l-1.36-0.79c-0.67-0.39-1.29-1.32-1.39-2.08l-5.93-44.5 c-0.2-1.53-1.45-2.14-2.79-1.37L54.04,73.8c-1.34,0.77-3.04,0.31-3.82-1.02l-0.99-1.71c-0.77-1.34-2.48-1.79-3.82-1.02 l-14.07,8.12c-1.34,0.77-2.25,2.64-2.05,4.16l7.01,52.61c0.1,0.76,0.73,1.7,1.39,2.08l1.36,0.79c0.33,0.19,0.64,0.21,0.85,0.09 l56.73-32.75C96.43,105.28,96.13,105.26,95.79,105.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25
    },
    d: "M95.79,105.07l-1.36-0.79c-0.67-0.39-1.29-1.32-1.39-2.08l-5.93-44.5 c-0.2-1.53-1.45-2.14-2.79-1.37L54.04,73.8c-1.34,0.77-3.04,0.31-3.82-1.02l-0.99-1.71c-0.77-1.34-2.48-1.79-3.82-1.02 l-14.07,8.12c-1.34,0.77-2.25,2.64-2.05,4.16l7.01,52.61c0.1,0.76,0.73,1.7,1.39,2.08l1.36,0.79c0.33,0.19,0.64,0.21,0.85,0.09 l56.73-32.75C96.43,105.28,96.13,105.26,95.79,105.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25
    },
    d: "M37.71,137.03l1.36,0.79c0.33,0.19,0.64,0.21,0.85,0.09l56.73-32.75 c-0.22,0.13-0.52,0.11-0.86-0.08l-1.36-0.79c-0.33-0.19-0.64-0.51-0.89-0.88l-56.72,32.75 C37.06,136.52,37.38,136.84,37.71,137.03z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M38.04,132.28V87.98c0-1.03,0.72-2.28,1.61-2.79l49.72-28.7c0.89-0.51,1.61-0.1,1.61,0.93v44.31 c0,1.03-0.72,2.28-1.61,2.79l-49.72,28.7C38.76,133.73,38.04,133.31,38.04,132.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M39.92,137.9c0.22-0.13,0.35-0.4,0.35-0.78V93.27c0-1.54,1.08-3.42,2.42-4.19l51.89-29.96 c1.34-0.77,2.42-0.15,2.42,1.4l0,43.84c0,0.38-0.13,0.66-0.35,0.78L39.92,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#FFFFFF"
    },
    d: "M39.92,137.9c0.22-0.13,0.35-0.4,0.35-0.78V93.27c0-1.54,1.08-3.42,2.42-4.19 l51.89-29.96c1.34-0.77,2.42-0.15,2.42,1.4l0,43.84c0,0.38-0.13,0.66-0.35,0.78L39.92,137.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Device_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laptop_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3579_",
    style: {
      fill: "#37474F"
    },
    d: "M142.82,407.96c0,2.74,2.05,4.5,4.59,5.96l103.8,59.93 c2.53,1.46,6.64,1.46,9.17,0l167.45-96.68c2.53-1.46,4.59-3.34,4.59-6.09c0-2.74-2.05-4.44-4.59-5.9l-103.8-59.93 c-2.53-1.46-6.64-1.46-9.17,0l-167.46,96.68C144.87,403.4,142.82,405.22,142.82,407.96z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3578_",
    style: {
      fill: "#455A64"
    },
    d: "M147.41,407.23l103.8,59.93c2.53,1.46,6.64,1.46,9.17,0l167.45-96.68 c2.53-1.46,2.53-3.83,0-5.3l-103.8-59.93c-2.53-1.46-6.64-1.46-9.17,0l-167.46,96.68C144.87,403.4,144.87,405.77,147.41,407.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3575_",
    style: {
      fill: "#263238"
    },
    d: "M255.8,468.27v6.68c-1.66,0-3.33-0.36-4.59-1.09l-103.8-59.93 c-2.53-1.46-4.58-3.22-4.58-5.96c0-2.57,1.85-4.37,4.23-5.82c-1.97,1.39-2,3.73,0.36,5.09l103.8,59.93 C252.47,467.89,254.14,468.27,255.8,468.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3574_",
    style: {
      fill: "#37474F"
    },
    d: "M140.83,402.64c-2.01-0.93-2.56-2.52-2.75-5.34l-9-131.65 c-0.19-2.81,1.71-6.28,4.24-7.74l167.45-96.68c2.53-1.46,4.39-2.26,6.73-0.66c2.45,1.67,2.39,2.48,2.58,5.3l9,131.65 c0.19,2.81-1.71,6.28-4.24,7.74l-167.46,96.68C144.86,403.41,143.42,403.84,140.83,402.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3573_",
    style: {
      fill: "#455A64"
    },
    d: "M310.09,165.87c-0.19-2.81-2.4-3.9-4.93-2.45l-167.46,96.68 c-1.27,0.73-2.38,1.97-3.14,3.37l-4.37-2.2l-0.01,0c0.77-1.4,1.88-2.64,3.15-3.37l167.45-96.68c2.53-1.46,4.4-2.27,6.73-0.66 C309.96,162.28,309.89,163.07,310.09,165.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3571_",
    style: {
      fill: "#263238"
    },
    d: "M147.05,402.14c-2.31,1.36-3.77,1.53-6.22,0.5c-1.88-0.79-2.55-2.52-2.75-5.33 l-9-131.65c-0.1-1.41,0.33-2.98,1.1-4.37l4.37,2.18l0,0.01c-0.76,1.4-1.2,2.96-1.1,4.37l9,131.65 C142.63,402.11,144.88,403.42,147.05,402.14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3568_",
    d: "M140.6,265.14l161.15-93.01c1.52-0.88,2.85-0.22,2.96,1.47l8.4,122.81c0.12,1.69-1.02,3.77-2.54,4.65 l-161.15,93.01c-1.52,0.88-2.84,0.22-2.96-1.47l-8.4-122.81C137.94,268.1,139.08,266.02,140.6,265.14z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M140.6,265.14c-1.52,0.88-2.66,2.96-2.54,4.65l8.26,120.77l159.31-91.95 c1.52-0.88,2.66-2.96,2.54-4.65l-8.26-120.77L140.6,265.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M140.6,265.14c-1.52,0.88-2.66,2.96-2.54,4.65l8.26,120.77l159.31-91.95 c1.52-0.88,2.66-2.96,2.54-4.65l-8.26-120.77L140.6,265.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3567_",
    style: {
      fill: "#263238"
    },
    d: "M161.57,402.71l153.88-88.84c1.19-0.69,3.13-0.69,4.32,0l5.6,3.14 c1.19,0.69,1.19,1.81,0,2.5l-153.91,88.83c-1.19,0.69-3.13,0.69-4.32,0l-5.58-3.13C160.38,404.52,160.38,403.4,161.57,402.71z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2776_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3566_",
    style: {
      fill: "#263238"
    },
    d: "M176.68,411.63l153.88-88.85c1.19-0.69,2.96-0.79,3.95-0.22l40.05,23.13 c0.99,0.57,0.82,1.59-0.37,2.28l-153.7,88.72c-1.19,0.69-2.97,0.79-3.96,0.22l-40.22-23.02 C175.32,413.34,175.49,412.32,176.68,411.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2782_",
    style: {
      fill: "#455A64"
    },
    d: "M310.02,360.1l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C309.51,360.23,309.82,360.22,310.02,360.1z  M302.99,350.47l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C303.51,350.35,303.19,350.36,302.99,350.47z M287.42,359.46l-8.15,4.71 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l8.15-4.71c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C287.94,359.33,287.63,359.34,287.42,359.46z M295.95,354.54l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.1,0.49,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C296.47,354.41,296.15,354.42,295.95,354.54z  M277.05,365.45l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.49,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C277.56,365.32,277.25,365.33,277.05,365.45z M270,369.52l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.49,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C270.52,369.39,270.21,369.4,270,369.52z M288.07,380.38l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C287.55,380.51,287.87,380.5,288.07,380.38z  M281.03,384.44l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C280.51,384.57,280.83,384.56,281.03,384.44z M273.99,388.51l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 C273.47,388.64,273.78,388.63,273.99,388.51z M266.95,392.57l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.1-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C266.43,392.7,266.74,392.69,266.95,392.57z  M302.98,364.16l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C302.46,364.29,302.78,364.28,302.98,364.16z M295.11,376.31l10.75-6.21 c0.2-0.12,0.22-0.3,0.04-0.4l-11.19-6.46c-0.18-0.11-0.5-0.09-0.7,0.02l-5.56,3.21c-0.2,0.12-0.22,0.3-0.04,0.4l5.93,3.42 c0.18,0.1,0.16,0.29-0.04,0.4l-4.45,2.57c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C294.6,376.44,294.91,376.43,295.11,376.31z  M262.96,373.58l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C263.48,373.45,263.17,373.47,262.96,373.58z M255.92,377.65l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C256.44,377.52,256.13,377.53,255.92,377.65z M216.95,421.06c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L216.95,421.06z M199.59,410.17l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C200.1,410.05,199.79,410.06,199.59,410.17z M208.52,418.33c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L208.52,418.33z M227.94,422.7l4.82-2.78 c0.21-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 C227.43,422.82,227.74,422.81,227.94,422.7z M220.2,426.78c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L220.2,426.78z M206.63,406.11l-4.82,2.78 c-0.21,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C207.15,405.98,206.83,405.99,206.63,406.11z M241.84,385.78l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C242.35,385.65,242.04,385.66,241.84,385.78z  M213.67,402.04l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C214.19,401.91,213.87,401.92,213.67,402.04z M248.88,381.71l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.49,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C249.4,381.59,249.08,381.6,248.88,381.71z M234.8,389.85l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C235.31,389.72,235,389.73,234.8,389.85z  M227.75,393.91l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C228.27,393.78,227.96,393.79,227.75,393.91z M220.71,397.98l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C221.23,397.85,220.92,397.86,220.71,397.98z M252.86,400.71l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C252.34,400.83,252.66,400.82,252.86,400.71z  M318.56,341.49l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C319.07,341.36,318.76,341.37,318.56,341.49z M310.03,346.41l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C310.55,346.28,310.24,346.29,310.03,346.41z M325.6,337.42l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C326.12,337.29,325.8,337.3,325.6,337.42z  M286.68,373.58l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C286.16,373.71,286.47,373.7,286.68,373.58z M333.34,333.33c-0.18-0.1-0.5-0.09-0.7,0.02 l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.49,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 L333.34,333.33z M259.9,396.64l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C259.39,396.77,259.7,396.76,259.9,396.64z M346.26,346.78l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 C345.74,346.91,346.05,346.9,346.26,346.78z M332.63,347.05l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C332.11,347.18,332.43,347.16,332.63,347.05z  M339.92,337.13c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02 l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4L339.92,337.13z M341.41,336.28l11.19,6.46c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-11.19-6.46c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78C341.24,335.99,341.23,336.17,341.41,336.28z  M325.14,345.29l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C325.66,345.16,325.35,345.17,325.14,345.29z M272.14,375.89l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C272.66,375.76,272.35,375.77,272.14,375.89z M338.52,350.87c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L338.52,350.87z M279.18,371.82l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.49,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C279.7,371.69,279.39,371.7,279.18,371.82z M224,416.99c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L224,416.99z M215.81,408.41l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C216.33,408.28,216.01,408.29,215.81,408.41z M231.74,412.9l4.82-2.78c0.21-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C231.22,413.03,231.53,413.02,231.74,412.9z  M238.78,408.84l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C238.26,408.97,238.57,408.95,238.78,408.84z M245.82,404.77l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 C245.3,404.9,245.62,404.89,245.82,404.77z M222.85,404.35l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C223.37,404.22,223.05,404.23,222.85,404.35z  M229.89,400.28l-4.82,2.78c-0.21,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C230.41,400.15,230.1,400.16,229.89,400.28z M258.06,384.02l-4.82,2.78 c-0.21,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C258.58,383.89,258.26,383.9,258.06,384.02z M251.02,388.08l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C251.53,387.96,251.22,387.97,251.02,388.08z  M265.1,379.95l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C265.62,379.82,265.3,379.84,265.1,379.95z M236.93,396.22l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.49,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 C237.45,396.09,237.14,396.1,236.93,396.22z M243.97,392.15l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66C244.49,392.02,244.18,392.03,243.97,392.15z  M234.99,418.63l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C234.47,418.76,234.78,418.75,234.99,418.63z M197.85,416.88l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 C198.02,417.16,198.04,416.98,197.85,416.88z M207.03,419.18l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02l-7.41,4.28 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l7.41-4.28C207.2,419.47,207.21,419.29,207.03,419.18z  M190.97,411.62l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-5.93,3.42c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.1,0.5,0.09,0.7-0.02l5.93-3.42C191.14,411.91,191.16,411.73,190.97,411.62z M195.52,409c0.18,0.11,0.5,0.09,0.7-0.02 l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4 L195.52,409z M215.47,421.91l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-9.27,5.35c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 c0.18,0.1,0.49,0.09,0.7-0.02l9.27-5.35C215.63,422.2,215.65,422.02,215.47,421.91z M218.72,427.64l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-5.93,3.42c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l5.93-3.42 C218.88,427.93,218.9,427.75,218.72,427.64z M247.88,378.77c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L247.88,378.77z M233.79,386.9 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4L233.79,386.9z M202.56,404.93c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L202.56,404.93z M240.83,382.83 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4L240.83,382.83z M226.75,390.97c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L226.75,390.97z M222.18,427.93 c-0.18-0.1-0.5-0.09-0.7,0.02l-7.41,4.28c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.49,0.09,0.7-0.02l7.41-4.28 c0.2-0.12,0.22-0.3,0.04-0.4L222.18,427.93z M216.65,396.8c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L216.65,396.8z M209.6,400.87 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4L209.6,400.87z M352.64,352.6c-0.18-0.1-0.49-0.09-0.7,0.02l-11.86,6.85 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l11.86-6.85c0.2-0.12,0.22-0.3,0.04-0.4L352.64,352.6z  M337.07,361.59c-0.18-0.11-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02 l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4L337.07,361.59z M242.03,414.56l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C241.51,414.69,241.82,414.68,242.03,414.56z  M322.99,369.72c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02 l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4L322.99,369.72z M359.68,348.54c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4L359.68,348.54z  M371.33,347.14l-11.19-6.46c-0.18-0.1-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l11.19,6.46 c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78C371.49,347.42,371.51,347.24,371.33,347.14z M296.67,384.92 c-0.18-0.11-0.5-0.09-0.7,0.02l-5.93,3.42c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l5.93-3.42 c0.2-0.12,0.22-0.3,0.04-0.4L296.67,384.92z M314.46,374.64c-0.18-0.1-0.5-0.09-0.7,0.02l-7.41,4.28 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l7.41-4.28c0.2-0.12,0.22-0.3,0.04-0.4L314.46,374.64z  M280.37,394.33c-0.18-0.1-0.5-0.09-0.7,0.02l-39.66,22.9c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.49,0.09,0.7-0.02 l39.66-22.9c0.2-0.12,0.22-0.3,0.04-0.4L280.37,394.33z M238.49,418.51c-0.18-0.11-0.5-0.09-0.7,0.02l-5.93,3.42 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l5.93-3.42c0.2-0.12,0.22-0.3,0.04-0.4L238.49,418.51z  M288.52,389.62c-0.18-0.11-0.49-0.09-0.7,0.02l-5.93,3.42c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02 l5.93-3.42c0.2-0.12,0.22-0.3,0.04-0.4L288.52,389.62z M230.33,423.22c-0.18-0.11-0.49-0.09-0.7,0.02l-5.93,3.42 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02l5.93-3.42c0.2-0.12,0.22-0.3,0.04-0.4L230.33,423.22z  M304.83,380.21c-0.18-0.11-0.49-0.09-0.7,0.02l-5.93,3.42c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.11,0.5,0.09,0.7-0.02 l5.93-3.42c0.2-0.12,0.22-0.3,0.04-0.4L304.83,380.21z M330.03,365.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.21-0.12,0.22-0.3,0.04-0.4L330.03,365.66z  M345.8,354.65l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C345.28,354.78,345.6,354.77,345.8,354.65z M317.07,356.03l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 C316.55,356.16,316.86,356.15,317.07,356.03z M298.36,382.04l14.08-8.13c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.1-0.49-0.09-0.7,0.02L293.09,379c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C297.85,382.17,298.16,382.16,298.36,382.04z  M338.06,358.74c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.49-0.09-0.7,0.02 l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L338.06,358.74z M332.18,354.91l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C331.66,355.04,331.97,355.03,332.18,354.91z  M291.32,386.11l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C290.8,386.23,291.12,386.22,291.32,386.11z M322.49,367.73c0.18,0.11,0.5,0.09,0.7-0.02 l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4 L322.49,367.73z M256.11,406.43l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C255.59,406.56,255.91,406.55,256.11,406.43z M263.15,402.37l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 C262.64,402.5,262.95,402.49,263.15,402.37z M249.07,410.5l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C248.55,410.63,248.87,410.62,249.07,410.5z  M277.24,394.24l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C276.72,394.37,277.03,394.35,277.24,394.24z M270.2,398.3l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66 C269.68,398.43,269.99,398.42,270.2,398.3z M284.28,390.17l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66 c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C283.76,390.3,284.07,390.29,284.28,390.17z  M322.71,333.61c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-1.23-0.71c-0.18-0.1-0.5-0.09-0.7,0.02 l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L322.71,333.61z M287.71,355.77c0.18,0.1,0.49,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L287.71,355.77z  M301.79,347.64c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02 l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L301.79,347.64z M279.11,360.74c0.18,0.1,0.49,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.1-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L279.11,360.74z  M294.75,351.71c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02 l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L294.75,351.71z M265.02,368.87c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L265.02,368.87z  M272.07,364.8c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02 l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L272.07,364.8z M308.62,341.74c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-1.23-0.71c-0.18-0.1-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L308.62,341.74z  M329.75,329.55c0.18,0.1,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-1.23-0.71c-0.18-0.1-0.49-0.09-0.7,0.02 l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L329.75,329.55z M339.43,335.14c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78 c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.49-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L339.43,335.14z  M352.84,350.58l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4l4.61,2.66C352.33,350.71,352.64,350.7,352.84,350.58z M315.66,337.68 c0.18,0.11,0.49,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4l-1.23-0.71c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78 c-0.2,0.12-0.22,0.3-0.04,0.4L315.66,337.68z M257.98,372.93c0.18,0.11,0.5,0.09,0.7-0.02l4.82-2.78c0.2-0.12,0.22-0.3,0.04-0.4 l-4.61-2.66c-0.18-0.11-0.5-0.09-0.7,0.02l-4.82,2.78c-0.2,0.12-0.22,0.3-0.04,0.4L257.98,372.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1402_",
    style: {
      fill: "#263238"
    },
    points: "278.15,413.01 279.2,413.61 307.02,429.67 356.51,401.1 357.54,400.52  328.67,383.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "355.87,401.47 328.67,385.77 279.83,413.98 307.02,429.67  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_4_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M153.62,273.59c-1.52,0.88-2.66,2.96-2.54,4.65L159.33,399l159.31-91.95 c1.52-0.88,2.66-2.96,2.54-4.65l-8.26-120.77L153.62,273.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M312.93,181.64l-4.07-2.34l-159.31,91.95c-1.52,0.88-2.66,2.96-2.54,4.65l8.26,120.77l4.07,2.34 l159.31-91.95c1.52-0.88,2.66-2.96,2.54-4.65L312.93,181.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M153.62,273.59c-1.52,0.88-2.66,2.96-2.54,4.65L159.33,399l159.31-91.95 c1.52-0.88,2.66-2.96,2.54-4.65l-8.26-120.77L153.62,273.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M312.04,183.3l8.15,119.17c0.09,1.3-0.87,3.03-2.05,3.71l-157.92,91.15l-8.15-119.17 c-0.09-1.3,0.87-3.03,2.05-3.71L312.04,183.3 M312.93,181.64l-159.31,91.95c-1.52,0.88-2.66,2.96-2.54,4.65L159.33,399 l159.31-91.95c1.52-0.88,2.66-2.96,2.54-4.65L312.93,181.64L312.93,181.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M164.28,323.43c-0.19,0-0.37-0.04-0.53-0.13c-0.36-0.19-0.59-0.59-0.63-1.07l-2.54-37.25 c-0.06-0.86,0.5-1.89,1.27-2.34l58.59-33.83c0.45-0.26,0.92-0.29,1.3-0.09c0.37,0.19,0.59,0.59,0.63,1.07l2.54,37.25 c0.06,0.86-0.5,1.89-1.27,2.34l-58.59,33.83C164.79,323.35,164.53,323.43,164.28,323.43z M161.54,284.91l2.54,37.25 c0.01,0.14,0.05,0.26,0.12,0.29c0.05,0.03,0.18,0.03,0.36-0.08l58.59-33.83c0.46-0.26,0.83-0.93,0.79-1.44l-2.54-37.25 c-0.01-0.14-0.05-0.25-0.12-0.29c-0.06-0.03-0.18-0.03-0.36,0.08l-58.59,33.83C161.88,283.74,161.51,284.41,161.54,284.91 L161.54,284.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M167.57,371.63c-0.19,0-0.37-0.04-0.53-0.13c-0.36-0.2-0.59-0.59-0.63-1.08l-2.54-37.25 c-0.06-0.87,0.5-1.89,1.27-2.34l141.47-81.68c0.45-0.26,0.92-0.29,1.3-0.09c0.37,0.19,0.59,0.59,0.63,1.08l2.54,37.25 c0.06,0.87-0.5,1.89-1.27,2.34l-141.47,81.68C168.08,371.56,167.82,371.63,167.57,371.63z M307.38,249.91 c-0.07,0-0.16,0.02-0.28,0.09l-141.47,81.68c-0.46,0.26-0.83,0.93-0.79,1.44l2.54,37.25c0.01,0.14,0.05,0.25,0.12,0.29 c0.06,0.03,0.19,0.03,0.36-0.08l141.47-81.68c0.46-0.26,0.83-0.93,0.79-1.44l-2.54-37.25c-0.01-0.14-0.05-0.25-0.12-0.29 C307.44,249.91,307.41,249.91,307.38,249.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M166.99,292.74l3.61-2.08c0.55-0.32,1.03-0.11,1.06,0.46c0.04,0.57-0.37,1.29-0.92,1.61 l-3.6,2.08c-0.55,0.32-1.03,0.11-1.06-0.46C166.02,293.78,166.44,293.06,166.99,292.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M167.11,285.62l20.72-11.96c0.61-0.35,1.15-0.12,1.19,0.52c0.04,0.64-0.42,1.45-1.03,1.8 l-20.72,11.96c-0.61,0.35-1.15,0.12-1.19-0.52C166.04,286.78,166.5,285.98,167.11,285.62z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M167.41,298.96l3.61-2.08c0.55-0.32,1.03-0.11,1.06,0.46s-0.37,1.29-0.92,1.61l-3.6,2.08 c-0.55,0.32-1.03,0.11-1.06-0.46S166.86,299.28,167.41,298.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M167.83,305.18l3.61-2.08c0.55-0.32,1.03-0.11,1.06,0.46c0.04,0.57-0.37,1.29-0.92,1.61 l-3.6,2.08c-0.55,0.32-1.03,0.11-1.06-0.46S167.29,305.5,167.83,305.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M168.26,311.38l3.61-2.08c0.55-0.32,1.03-0.11,1.06,0.46c0.04,0.57-0.37,1.29-0.92,1.61 l-3.6,2.08c-0.55,0.32-1.03,0.11-1.06-0.46S167.71,311.69,168.26,311.38z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M174.88,309.94c-0.08,0-0.17-0.04-0.21-0.11c-0.07-0.1-0.04-0.24,0.07-0.3l44.98-25.98 c0.11-0.06,0.26-0.03,0.33,0.07c0.07,0.1,0.04,0.24-0.07,0.3l-44.98,25.98C174.96,309.93,174.92,309.94,174.88,309.94z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M174.45,303.73c-0.08,0-0.17-0.04-0.21-0.11c-0.07-0.1-0.04-0.24,0.07-0.3l44.98-25.98 c0.11-0.06,0.26-0.03,0.33,0.07c0.07,0.1,0.04,0.24-0.07,0.3l-44.98,25.98C174.54,303.72,174.49,303.73,174.45,303.73z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M174.03,297.54c-0.08,0-0.17-0.04-0.21-0.11c-0.07-0.1-0.04-0.24,0.07-0.3l44.98-25.98 c0.11-0.06,0.26-0.03,0.33,0.07c0.07,0.1,0.04,0.24-0.07,0.3l-44.98,25.98C174.11,297.52,174.07,297.53,174.03,297.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M173.61,291.34c-0.08,0-0.17-0.04-0.21-0.11c-0.07-0.1-0.04-0.24,0.07-0.3l44.98-25.98 c0.11-0.06,0.26-0.03,0.33,0.07c0.07,0.1,0.04,0.24-0.07,0.3l-44.98,25.98C173.69,291.33,173.65,291.34,173.61,291.34z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "175.71,309.14 175.29,303.02 179.51,299.76 184.66,296.74 187.75,292.59  192.99,289.56 195.98,285.41 206.46,279.36 209.75,274.77 214.11,268.59 218.59,265.4 219.84,283.74  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "175.71,309.14 175.4,304.56 181.03,301.26 185.89,297.3 191.09,294.32 196.33,290.09  201.54,287.05 204.53,282.9 209.9,279.79 212.76,275.73 216.39,271.2 218.89,269.76 219.84,283.74  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M236.96,247.92c0.23,3.32-1.41,7.07-3.65,8.37c-2.24,1.3-4.25-0.35-4.47-3.67 c-0.23-3.32,1.41-7.07,3.65-8.37C234.73,242.95,236.73,244.6,236.96,247.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232.58,253.6c-0.14,0-0.28-0.05-0.39-0.14l-1.58-1.3c-0.26-0.21-0.3-0.6-0.08-0.86 c0.21-0.26,0.6-0.3,0.86-0.08l0.91,0.75l1.95-5.57c0.11-0.32,0.46-0.48,0.78-0.37c0.32,0.11,0.48,0.46,0.37,0.78l-2.24,6.39 c-0.07,0.19-0.22,0.33-0.41,0.38C232.69,253.6,232.64,253.6,232.58,253.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M238.51,270.64c0.23,3.32-1.41,7.07-3.65,8.37c-2.24,1.3-4.25-0.35-4.47-3.67 s1.41-7.07,3.65-8.37C236.28,265.67,238.28,267.31,238.51,270.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M233.18,276.49c-0.08,0-0.16-0.02-0.24-0.05c-0.31-0.13-0.45-0.49-0.31-0.8l2.53-5.8 c0.13-0.31,0.49-0.45,0.8-0.31c0.31,0.13,0.45,0.49,0.31,0.8l-2.53,5.8C233.63,276.36,233.41,276.49,233.18,276.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M236,274.86c-0.14,0-0.27-0.05-0.39-0.14l-3.1-2.55c-0.26-0.21-0.3-0.6-0.08-0.86 c0.21-0.26,0.6-0.3,0.86-0.08l3.1,2.55c0.26,0.21,0.3,0.6,0.08,0.86C236.35,274.79,236.17,274.86,236,274.86z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.39,228.83l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12C264,228.1,263.74,228.63,263.39,228.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.7,233.4l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12C264.31,232.66,264.05,233.19,263.7,233.4z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M264.01,237.96l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C264.62,237.22,264.36,237.76,264.01,237.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M264.94,251.55l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C265.55,250.81,265.29,251.34,264.94,251.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M265.25,256.11l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12C265.86,255.38,265.6,255.91,265.25,256.11 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M265.56,260.67l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C266.17,259.94,265.91,260.47,265.56,260.67z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M277.93,224.26c0.23,3.32-1.41,7.07-3.65,8.37s-4.25-0.35-4.47-3.67 c-0.23-3.32,1.41-7.07,3.65-8.37S277.7,220.94,277.93,224.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.55,229.95c-0.14,0-0.28-0.05-0.39-0.14l-1.58-1.3c-0.26-0.21-0.3-0.6-0.08-0.86 c0.21-0.26,0.6-0.3,0.86-0.08l0.91,0.75l1.95-5.57c0.11-0.32,0.46-0.48,0.78-0.37c0.32,0.11,0.48,0.46,0.37,0.78l-2.24,6.39 c-0.07,0.19-0.22,0.33-0.41,0.38C273.67,229.94,273.61,229.95,273.55,229.95z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M279.48,246.98c0.23,3.32-1.41,7.07-3.65,8.37c-2.24,1.3-4.25-0.35-4.47-3.67 c-0.23-3.32,1.41-7.07,3.65-8.37C277.25,242.01,279.25,243.66,279.48,246.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.15,252.84c-0.08,0-0.16-0.02-0.24-0.05c-0.31-0.13-0.45-0.49-0.31-0.8l2.54-5.8 c0.13-0.31,0.49-0.45,0.8-0.31c0.31,0.13,0.45,0.49,0.31,0.8l-2.54,5.8C274.61,252.7,274.38,252.84,274.15,252.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.97,251.21c-0.14,0-0.27-0.05-0.39-0.14l-3.1-2.55c-0.26-0.21-0.3-0.6-0.08-0.86 c0.21-0.26,0.6-0.3,0.86-0.08l3.1,2.55c0.26,0.21,0.3,0.6,0.08,0.86C277.32,251.13,277.14,251.21,276.97,251.21z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.36,205.18l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C304.97,204.44,304.71,204.97,304.36,205.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.67,209.74l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C305.29,209.01,305.02,209.54,304.67,209.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M304.98,214.3l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12C305.6,213.57,305.34,214.1,304.98,214.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M305.91,227.89l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C306.52,227.16,306.26,227.69,305.91,227.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M306.22,232.46l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C306.83,231.72,306.57,232.25,306.22,232.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M306.53,237.02l-21.79,12.58c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l21.79-12.58c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12 C307.15,236.28,306.89,236.82,306.53,237.02z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4013_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M287.35,279.23c0-0.04,0.01-0.08,0.03-0.12c0.02-0.04,0.05-0.07,0.08-0.09l1.63-0.94 c0.03-0.02,0.06-0.02,0.09,0c0.02,0.02,0.04,0.04,0.04,0.09l0.03,0.4c0,0.04-0.01,0.08-0.03,0.13 c-0.02,0.04-0.05,0.07-0.08,0.09l-1.22,0.7l0,0.74c0.07-0.09,0.15-0.15,0.23-0.21c0.08-0.05,0.14-0.09,0.19-0.12 c0.16-0.09,0.31-0.15,0.46-0.18c0.14-0.02,0.27-0.01,0.38,0.04c0.11,0.05,0.2,0.14,0.27,0.27c0.07,0.13,0.11,0.29,0.12,0.5 c0.02,0.24,0,0.46-0.05,0.66c-0.05,0.2-0.12,0.39-0.22,0.56c-0.1,0.17-0.21,0.32-0.35,0.45c-0.14,0.13-0.28,0.24-0.44,0.33 c-0.2,0.12-0.37,0.18-0.52,0.21c-0.15,0.02-0.27,0.01-0.37-0.04c-0.1-0.05-0.18-0.12-0.24-0.23 c-0.06-0.1-0.09-0.23-0.11-0.37c-0.01-0.04,0-0.08,0.03-0.13c0.02-0.04,0.05-0.07,0.08-0.09l0.35-0.2 c0.03-0.02,0.06-0.02,0.08-0.01c0.02,0.01,0.04,0.03,0.05,0.07c0.02,0.08,0.06,0.13,0.1,0.16c0.04,0.03,0.09,0.05,0.14,0.05 c0.05,0,0.11-0.01,0.17-0.03c0.06-0.02,0.13-0.06,0.19-0.09c0.17-0.1,0.29-0.23,0.39-0.4c0.09-0.17,0.13-0.36,0.12-0.56 c-0.01-0.17-0.07-0.28-0.18-0.33c-0.11-0.05-0.25-0.03-0.41,0.06c-0.09,0.05-0.15,0.1-0.2,0.15 c-0.05,0.05-0.09,0.09-0.12,0.13c-0.03,0.04-0.06,0.08-0.08,0.11c-0.02,0.03-0.06,0.06-0.1,0.08l-0.4,0.23 c-0.03,0.02-0.06,0.02-0.09,0c-0.03-0.02-0.04-0.04-0.04-0.09L287.35,279.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M292.23,277.77c0.01,0.07,0.01,0.15,0.02,0.23s0.01,0.17,0.02,0.26 c0.01,0.09,0.01,0.18,0.02,0.26c0.01,0.09,0.01,0.16,0.01,0.24c0.01,0.22-0.01,0.43-0.04,0.64 c-0.03,0.21-0.08,0.41-0.17,0.59c-0.08,0.19-0.19,0.36-0.33,0.52c-0.14,0.16-0.32,0.3-0.53,0.42 c-0.21,0.12-0.4,0.19-0.55,0.2c-0.15,0.01-0.27-0.03-0.38-0.11c-0.1-0.08-0.18-0.2-0.23-0.36 c-0.05-0.16-0.09-0.34-0.12-0.56c-0.02-0.14-0.03-0.3-0.04-0.48c-0.01-0.18-0.02-0.34-0.02-0.49 c-0.01-0.22,0.01-0.44,0.03-0.65c0.03-0.21,0.09-0.41,0.17-0.6c0.08-0.19,0.19-0.37,0.33-0.53 c0.14-0.16,0.32-0.31,0.53-0.43c0.21-0.12,0.39-0.19,0.54-0.19c0.15-0.01,0.28,0.03,0.38,0.11c0.1,0.08,0.18,0.2,0.23,0.36 C292.17,277.37,292.21,277.56,292.23,277.77z M290.55,279.74c0.03,0.26,0.1,0.44,0.19,0.53c0.1,0.1,0.24,0.09,0.45-0.03 c0.2-0.12,0.34-0.27,0.42-0.47c0.07-0.2,0.11-0.43,0.11-0.71c0-0.14-0.01-0.3-0.02-0.47c-0.01-0.17-0.02-0.32-0.04-0.46 c-0.03-0.26-0.1-0.44-0.19-0.53c-0.1-0.1-0.24-0.09-0.45,0.03c-0.2,0.12-0.34,0.27-0.42,0.47c-0.08,0.2-0.11,0.43-0.11,0.71 c0,0.14,0.01,0.3,0.02,0.47C290.52,279.45,290.54,279.6,290.55,279.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M293.21,275.67c0.11-0.06,0.2-0.1,0.28-0.1c0.08,0,0.15,0.01,0.21,0.05 c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.22c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31 c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22 c-0.11,0.06-0.2,0.1-0.28,0.1c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15 c-0.03-0.07-0.06-0.14-0.07-0.22c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28 c0.02-0.1,0.06-0.2,0.11-0.29c0.05-0.1,0.11-0.19,0.19-0.27C293.01,275.8,293.1,275.73,293.21,275.67z M294.95,274.8 c0.02-0.04,0.04-0.08,0.06-0.11c0.02-0.03,0.05-0.06,0.09-0.08l0.26-0.15c0.03-0.02,0.06-0.02,0.08-0.01 c0.02,0.01,0.03,0.03,0.03,0.06c0,0.01,0,0.02,0,0.03c0,0.01-0.01,0.03-0.01,0.04l-1.9,4.85c-0.02,0.04-0.04,0.08-0.06,0.11 c-0.02,0.03-0.05,0.06-0.09,0.08l-0.26,0.15c-0.03,0.02-0.06,0.02-0.08,0.01c-0.02-0.01-0.03-0.03-0.03-0.06 c0-0.01,0-0.02,0-0.03c0-0.01,0.01-0.03,0.01-0.04L294.95,274.8z M293.52,276.79c0-0.02,0-0.06,0-0.11s-0.01-0.1-0.01-0.15 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16c-0.04-0.03-0.09-0.03-0.18,0.02 c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.14-0.04,0.22c0,0.02,0,0.06,0,0.11c0,0.05,0,0.1,0.01,0.15 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16c0.04,0.03,0.09,0.03,0.18-0.02 c0.08-0.05,0.14-0.11,0.17-0.18C293.51,276.94,293.52,276.87,293.52,276.79z M295.22,276.54c0.11-0.06,0.2-0.1,0.28-0.1 c0.08,0,0.15,0.01,0.21,0.05c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.22c0.01,0.09,0.02,0.19,0.03,0.3 c0.01,0.11,0.01,0.21,0.01,0.31c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29c-0.05,0.1-0.11,0.19-0.19,0.27 c-0.08,0.08-0.17,0.16-0.27,0.22c-0.11,0.06-0.2,0.1-0.28,0.1c-0.08,0.01-0.15-0.01-0.21-0.04 c-0.06-0.03-0.1-0.08-0.14-0.15c-0.03-0.07-0.06-0.14-0.07-0.22c-0.01-0.09-0.02-0.19-0.03-0.3 c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28c0.02-0.1,0.06-0.2,0.11-0.29c0.05-0.1,0.11-0.19,0.19-0.27 C295.02,276.67,295.11,276.6,295.22,276.54z M295.53,277.66c0-0.02,0-0.06,0-0.11s-0.01-0.1-0.01-0.15 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16c-0.04-0.03-0.09-0.03-0.18,0.02 c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.14-0.04,0.22c0,0.02,0,0.06,0,0.11c0,0.05,0,0.1,0.01,0.15 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16c0.04,0.03,0.1,0.03,0.18-0.02 c0.08-0.05,0.14-0.11,0.17-0.18C295.52,277.81,295.53,277.74,295.53,277.66z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4014_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M284.75,279.41c0.36-1.83,1.04-3.64,1.97-5.25c0.17-0.29,0.35-0.58,0.53-0.86 c0.99-1.49,2.2-2.75,3.52-3.6l-0.25-3.61c-1.94,1.21-3.7,3.05-5.13,5.25c-0.18,0.28-0.36,0.57-0.53,0.86 c-1.37,2.33-2.38,4.97-2.88,7.64c-0.06,0.33-0.11,0.65-0.16,0.98c-0.18,1.28-0.23,2.55-0.15,3.79 c0.08,1.23,0.3,2.35,0.63,3.33c0.08,0.25,0.17,0.5,0.27,0.73c0.81,1.91,2.09,3.24,3.66,3.87c0.2,0.08,0.4,0.15,0.6,0.21 c1.61,0.44,3.47,0.19,5.43-0.85l-0.25-3.61c-1.34,0.69-2.62,0.87-3.73,0.59c-0.21-0.05-0.41-0.12-0.6-0.2 c-1.07-0.45-1.94-1.37-2.51-2.67c-0.1-0.23-0.19-0.47-0.28-0.73c-0.22-0.69-0.37-1.45-0.43-2.29 c-0.06-0.85-0.02-1.72,0.1-2.6C284.64,280.06,284.69,279.73,284.75,279.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4017_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M301.76,269.07c-0.08-0.25-0.17-0.5-0.27-0.73c-0.86-2.05-2.23-3.47-3.91-4.13 c-0.2-0.08-0.4-0.15-0.6-0.21c-1.71-0.47-3.71-0.21-5.8,0.91l0.05,0.78l0.25,3.61l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53 c0.21,0.05,0.41,0.11,0.6,0.2c0.96,0.41,1.74,1.24,2.25,2.4c0.1,0.23,0.19,0.47,0.27,0.73c0.19,0.62,0.33,1.3,0.38,2.06 c0.05,0.76,0.02,1.54-0.08,2.33c-0.04,0.33-0.09,0.65-0.16,0.98c-0.32,1.64-0.94,3.27-1.77,4.72 c-0.17,0.29-0.35,0.58-0.53,0.85c-0.89,1.34-1.97,2.46-3.16,3.23l0.06,0.81l0.25,3.61l0.05,0.78 c2.08-1.29,3.96-3.26,5.48-5.6c0.18-0.28,0.36-0.57,0.53-0.86c1.47-2.48,2.54-5.31,3.07-8.16c0.06-0.33,0.11-0.65,0.16-0.98 c0.19-1.36,0.25-2.72,0.16-4.04C302.35,271.31,302.11,270.12,301.76,269.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4015_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.76,269.07c-0.08-0.25-0.17-0.5-0.27-0.73c-0.86-2.05-2.23-3.47-3.91-4.13 c-0.2-0.08-0.4-0.15-0.6-0.21c-1.71-0.47-3.71-0.21-5.8,0.91l0.05,0.78l0.25,3.61l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53 c0.21,0.05,0.41,0.11,0.6,0.2c0.96,0.41,1.74,1.24,2.25,2.4c0.1,0.23,0.19,0.47,0.27,0.73c0.19,0.62,0.33,1.3,0.38,2.06 c0.05,0.76,0.02,1.54-0.08,2.33c-0.04,0.33-0.09,0.65-0.16,0.98c-0.32,1.64-0.94,3.27-1.77,4.72 c-0.17,0.29-0.35,0.58-0.53,0.85c-0.89,1.34-1.97,2.46-3.16,3.23l0.06,0.81l0.25,3.61l0.05,0.78 c2.08-1.29,3.96-3.26,5.48-5.6c0.18-0.28,0.36-0.57,0.53-0.86c1.47-2.48,2.54-5.31,3.07-8.16c0.06-0.33,0.11-0.65,0.16-0.98 c0.19-1.36,0.25-2.72,0.16-4.04C302.35,271.31,302.11,270.12,301.76,269.07z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4008_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M261.29,298.59c-0.03,0.02-0.06,0.02-0.09,0c-0.03-0.02-0.04-0.04-0.04-0.09l-0.05-0.67 l-1.34,0.78c-0.03,0.02-0.06,0.02-0.09,0c-0.03-0.02-0.04-0.05-0.04-0.09l-0.03-0.39c0-0.05,0-0.1,0.02-0.15 c0.02-0.05,0.03-0.1,0.06-0.16l1.18-2.89c0.05-0.13,0.11-0.21,0.17-0.24l0.33-0.19c0.03-0.02,0.06-0.02,0.09,0 c0.02,0.02,0.04,0.04,0.04,0.09l0.15,2.22l0.37-0.21c0.03-0.02,0.06-0.02,0.09,0c0.02,0.02,0.04,0.04,0.04,0.09l0.03,0.39 c0,0.04-0.01,0.08-0.03,0.13c-0.02,0.04-0.05,0.07-0.08,0.09l-0.37,0.21l0.05,0.67c0,0.04-0.01,0.08-0.03,0.13 c-0.02,0.04-0.05,0.07-0.08,0.09L261.29,298.59z M261.07,297.14l-0.08-1.19l-0.66,1.62L261.07,297.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M264.8,294.03c0.01,0.07,0.01,0.15,0.02,0.23c0.01,0.09,0.01,0.17,0.02,0.26 c0.01,0.09,0.01,0.18,0.02,0.26c0.01,0.09,0.01,0.16,0.01,0.24c0.01,0.22-0.01,0.43-0.04,0.64 c-0.03,0.21-0.08,0.41-0.17,0.59c-0.08,0.19-0.19,0.36-0.33,0.52c-0.14,0.16-0.32,0.3-0.53,0.42 c-0.21,0.12-0.4,0.19-0.55,0.2c-0.15,0.01-0.28-0.03-0.38-0.11c-0.1-0.08-0.18-0.2-0.23-0.36 c-0.05-0.16-0.09-0.34-0.12-0.55c-0.02-0.14-0.03-0.3-0.04-0.48c-0.01-0.18-0.02-0.34-0.02-0.49 c-0.01-0.22,0.01-0.44,0.03-0.65c0.03-0.21,0.08-0.41,0.17-0.6c0.08-0.19,0.19-0.37,0.33-0.53 c0.14-0.16,0.31-0.31,0.53-0.43c0.21-0.12,0.39-0.19,0.54-0.19c0.15-0.01,0.28,0.03,0.38,0.11c0.1,0.08,0.18,0.2,0.23,0.36 C264.74,293.63,264.78,293.82,264.8,294.03z M263.12,296c0.03,0.26,0.1,0.44,0.19,0.54c0.1,0.1,0.24,0.09,0.45-0.03 c0.2-0.12,0.34-0.27,0.42-0.47c0.08-0.2,0.11-0.43,0.11-0.71c0-0.14-0.01-0.3-0.02-0.47c-0.01-0.17-0.02-0.32-0.04-0.46 c-0.03-0.26-0.1-0.44-0.19-0.53c-0.1-0.1-0.24-0.09-0.45,0.03c-0.2,0.12-0.34,0.27-0.42,0.47c-0.07,0.2-0.11,0.43-0.11,0.71 c0,0.14,0.01,0.3,0.02,0.47C263.09,295.71,263.1,295.86,263.12,296z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M265.78,291.93c0.11-0.06,0.2-0.1,0.28-0.1c0.08,0,0.15,0.01,0.21,0.05 c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.22c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31 c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22 c-0.11,0.06-0.2,0.1-0.28,0.1c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15 c-0.03-0.07-0.05-0.14-0.07-0.22c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28 c0.02-0.1,0.06-0.2,0.11-0.29c0.05-0.1,0.11-0.19,0.19-0.27C265.58,292.06,265.67,291.99,265.78,291.93z M267.53,291.06 c0.02-0.04,0.04-0.08,0.06-0.11c0.02-0.03,0.05-0.06,0.09-0.08l0.26-0.15c0.03-0.02,0.06-0.02,0.08-0.01 c0.02,0.01,0.03,0.03,0.03,0.06c0,0.01,0,0.02,0,0.03c0,0.01-0.01,0.03-0.01,0.04l-1.9,4.85c-0.02,0.04-0.04,0.08-0.06,0.11 c-0.02,0.03-0.05,0.06-0.09,0.08l-0.26,0.15c-0.03,0.02-0.06,0.02-0.08,0.01c-0.02-0.01-0.03-0.03-0.03-0.06 c0-0.01,0-0.02,0-0.03c0-0.01,0-0.03,0.01-0.04L267.53,291.06z M266.09,293.05c0-0.02,0-0.06,0-0.11s-0.01-0.1-0.01-0.15 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16c-0.04-0.03-0.09-0.03-0.18,0.02 s-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.14-0.04,0.22c0,0.02,0,0.06,0,0.11c0,0.05,0.01,0.1,0.01,0.15 c0,0.05,0.01,0.1,0.01,0.15c0.01,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.04,0.12,0.07,0.16c0.04,0.03,0.1,0.03,0.18-0.02 c0.08-0.05,0.14-0.11,0.17-0.18C266.08,293.2,266.09,293.13,266.09,293.05z M267.79,292.8c0.11-0.06,0.2-0.1,0.28-0.1 c0.08,0,0.15,0.01,0.21,0.05c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.22c0.01,0.09,0.02,0.19,0.03,0.3 c0.01,0.11,0.01,0.21,0.01,0.31c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29c-0.05,0.1-0.11,0.19-0.19,0.27 c-0.08,0.08-0.17,0.16-0.27,0.22c-0.11,0.06-0.2,0.1-0.28,0.1c-0.08,0.01-0.15-0.01-0.21-0.04 c-0.06-0.03-0.1-0.08-0.14-0.15c-0.03-0.07-0.05-0.14-0.07-0.22c-0.01-0.09-0.02-0.19-0.03-0.3 c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28c0.02-0.1,0.06-0.2,0.11-0.29c0.05-0.1,0.11-0.19,0.19-0.27 C267.59,292.93,267.68,292.86,267.79,292.8z M268.1,293.92c0-0.02,0-0.06,0-0.11c0-0.05-0.01-0.1-0.01-0.15 c0-0.05-0.01-0.1-0.01-0.15s-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16c-0.04-0.03-0.09-0.03-0.18,0.02 s-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.14-0.04,0.22c0,0.02,0,0.06,0,0.11c0,0.05,0.01,0.1,0.01,0.15 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.04,0.12,0.07,0.16c0.04,0.03,0.1,0.03,0.18-0.02 c0.08-0.05,0.14-0.11,0.17-0.18C268.09,294.07,268.1,294,268.1,293.92z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4011_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M268.58,301.07c-0.99,1.49-2.2,2.75-3.53,3.6c-0.12,0.07-0.23,0.16-0.35,0.23 c-0.12,0.07-0.23,0.12-0.35,0.18c-1.34,0.69-2.62,0.87-3.73,0.59c-0.21-0.05-0.41-0.12-0.6-0.2 c-1.07-0.45-1.94-1.37-2.51-2.67c-0.1-0.23-0.19-0.47-0.28-0.73c-0.22-0.69-0.37-1.45-0.43-2.29 c-0.06-0.85-0.02-1.72,0.1-2.6c0.04-0.33,0.09-0.65,0.16-0.98c0.36-1.83,1.04-3.64,1.97-5.25c0.17-0.29,0.35-0.58,0.53-0.86 c0.99-1.49,2.2-2.75,3.52-3.6l-0.25-3.61c-1.94,1.21-3.7,3.05-5.13,5.25c-0.18,0.28-0.36,0.57-0.53,0.86 c-1.37,2.33-2.38,4.97-2.88,7.64c-0.06,0.33-0.11,0.65-0.16,0.98c-0.18,1.28-0.23,2.55-0.15,3.79 c0.08,1.23,0.3,2.35,0.64,3.33c0.08,0.25,0.17,0.5,0.27,0.73c0.81,1.91,2.09,3.24,3.66,3.87c0.2,0.08,0.4,0.15,0.6,0.21 c1.61,0.44,3.47,0.19,5.43-0.85c0.12-0.06,0.23-0.12,0.35-0.19c0.12-0.07,0.23-0.14,0.35-0.21c1.94-1.21,3.7-3.05,5.13-5.25 L268.58,301.07z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4012_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M274.07,285.85c-0.08-0.25-0.17-0.5-0.27-0.73c-0.86-2.05-2.23-3.47-3.91-4.13 c-0.2-0.08-0.4-0.15-0.6-0.21c-1.71-0.47-3.71-0.21-5.8,0.91l0.05,0.78l0.25,3.61l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53 c0.21,0.05,0.41,0.11,0.6,0.2c0.96,0.41,1.74,1.24,2.25,2.4c0.1,0.23,0.19,0.47,0.27,0.73c0.19,0.62,0.33,1.3,0.38,2.06 c0.05,0.76,0.02,1.54-0.08,2.33c-0.04,0.33-0.09,0.65-0.16,0.98c-0.32,1.64-0.94,3.27-1.77,4.72l0.41,0.44l1.85,1.96 l0.4,0.43c1.47-2.48,2.54-5.31,3.07-8.16c0.06-0.33,0.11-0.65,0.16-0.98c0.19-1.36,0.25-2.72,0.16-4.04 C274.65,288.09,274.42,286.9,274.07,285.85z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4004_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M233.91,310.35c0.03-0.02,0.06-0.02,0.09,0c0.02,0.02,0.04,0.05,0.04,0.09l0.03,0.4 c0,0.04-0.01,0.08-0.02,0.13c-0.02,0.05-0.04,0.09-0.06,0.13l-0.58,1.22c0.13-0.05,0.25-0.08,0.36-0.08 c0.11,0,0.21,0.02,0.29,0.07c0.08,0.05,0.15,0.13,0.2,0.24c0.05,0.11,0.08,0.24,0.09,0.4c0.01,0.19-0.01,0.38-0.06,0.57 c-0.05,0.18-0.12,0.36-0.22,0.52c-0.1,0.16-0.22,0.32-0.36,0.45c-0.14,0.14-0.29,0.26-0.46,0.35 c-0.2,0.12-0.38,0.19-0.53,0.21c-0.15,0.02-0.28,0.02-0.39-0.02c-0.1-0.04-0.19-0.1-0.25-0.2c-0.06-0.09-0.1-0.2-0.12-0.31 c-0.01-0.04,0-0.09,0.02-0.13c0.02-0.04,0.05-0.07,0.08-0.09l0.34-0.2c0.03-0.02,0.05-0.02,0.07,0 c0.02,0.01,0.04,0.04,0.07,0.07c0.02,0.03,0.05,0.06,0.08,0.09c0.03,0.02,0.07,0.04,0.12,0.04c0.05,0,0.11-0.01,0.18-0.03 c0.07-0.02,0.16-0.06,0.27-0.12c0.18-0.1,0.32-0.23,0.42-0.38c0.1-0.15,0.15-0.31,0.14-0.48c-0.01-0.17-0.07-0.25-0.19-0.27 c-0.11-0.01-0.26,0.04-0.43,0.14l-0.36,0.21c-0.03,0.02-0.06,0.02-0.09,0c-0.02-0.02-0.04-0.04-0.04-0.08l-0.03-0.4 c0-0.04,0.01-0.08,0.03-0.13c0.02-0.05,0.04-0.09,0.06-0.13l0.55-1.17l-1.2,0.69c-0.03,0.02-0.06,0.02-0.09,0 c-0.02-0.02-0.04-0.04-0.04-0.09l-0.03-0.4c0-0.04,0.01-0.08,0.03-0.13c0.02-0.04,0.05-0.07,0.08-0.09L233.91,310.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M237.03,310.06c0.01,0.07,0.01,0.15,0.02,0.23c0.01,0.09,0.01,0.17,0.02,0.26 c0.01,0.09,0.01,0.18,0.02,0.26c0.01,0.09,0.01,0.16,0.01,0.24c0.01,0.22-0.01,0.43-0.04,0.64 c-0.03,0.21-0.08,0.41-0.17,0.59c-0.08,0.19-0.19,0.36-0.33,0.52c-0.14,0.16-0.32,0.3-0.53,0.42 c-0.21,0.12-0.4,0.19-0.54,0.2c-0.15,0.01-0.28-0.03-0.38-0.11c-0.1-0.08-0.18-0.2-0.23-0.36 c-0.05-0.16-0.09-0.34-0.12-0.55c-0.02-0.14-0.03-0.3-0.04-0.48c-0.01-0.18-0.02-0.34-0.02-0.49 c-0.01-0.22,0.01-0.44,0.03-0.65c0.03-0.21,0.08-0.41,0.17-0.6c0.08-0.19,0.19-0.37,0.33-0.53 c0.14-0.16,0.31-0.31,0.53-0.43c0.21-0.12,0.39-0.19,0.54-0.19c0.15-0.01,0.28,0.03,0.38,0.11c0.1,0.08,0.18,0.2,0.23,0.36 C236.97,309.66,237.01,309.85,237.03,310.06z M235.35,312.03c0.03,0.26,0.1,0.44,0.19,0.53c0.09,0.1,0.24,0.09,0.45-0.03 c0.2-0.12,0.34-0.27,0.42-0.47c0.08-0.2,0.11-0.43,0.11-0.71c0-0.14-0.01-0.3-0.02-0.47c-0.01-0.17-0.03-0.32-0.04-0.46 c-0.03-0.26-0.1-0.44-0.19-0.53c-0.1-0.1-0.24-0.09-0.45,0.03c-0.2,0.12-0.34,0.27-0.42,0.47c-0.08,0.2-0.11,0.43-0.11,0.71 c0,0.14,0.01,0.3,0.02,0.47C235.32,311.74,235.33,311.89,235.35,312.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M238.01,307.96c0.11-0.06,0.2-0.1,0.28-0.1c0.08,0,0.15,0.01,0.21,0.05 c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.22c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31 c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22 c-0.11,0.06-0.2,0.1-0.28,0.1c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15 c-0.03-0.07-0.05-0.14-0.07-0.22c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28 c0.02-0.1,0.06-0.2,0.11-0.29c0.05-0.1,0.11-0.19,0.19-0.27C237.81,308.09,237.9,308.02,238.01,307.96z M239.75,307.08 c0.02-0.04,0.04-0.08,0.06-0.11c0.02-0.03,0.05-0.06,0.09-0.08l0.26-0.15c0.03-0.02,0.06-0.02,0.08-0.01 c0.02,0.01,0.03,0.03,0.03,0.06c0,0.01,0,0.02,0,0.03c0,0.01,0,0.03-0.01,0.04l-1.9,4.85c-0.02,0.04-0.04,0.08-0.06,0.11 c-0.02,0.03-0.05,0.06-0.09,0.08l-0.26,0.15c-0.03,0.02-0.06,0.02-0.08,0.01c-0.02-0.01-0.03-0.03-0.03-0.06 c0-0.01,0-0.02,0-0.03c0-0.01,0-0.03,0.01-0.04L239.75,307.08z M238.32,309.08c0-0.02,0-0.06,0-0.11 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.1-0.01-0.15s-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16 c-0.04-0.03-0.09-0.03-0.18,0.02c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.14-0.04,0.22c0,0.02,0,0.06,0,0.11 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16 c0.04,0.03,0.1,0.03,0.18-0.02c0.08-0.05,0.14-0.11,0.17-0.18C238.31,309.23,238.32,309.16,238.32,309.08z M240.02,308.82 c0.11-0.06,0.2-0.1,0.28-0.1c0.08,0,0.15,0.01,0.21,0.05c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.22 c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29 c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22c-0.11,0.06-0.2,0.1-0.28,0.1 c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15c-0.03-0.07-0.06-0.14-0.07-0.22 c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28c0.02-0.1,0.06-0.2,0.11-0.29 c0.05-0.1,0.11-0.19,0.19-0.27C239.82,308.96,239.91,308.89,240.02,308.82z M240.33,309.95c0-0.02,0-0.06,0-0.11 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.08-0.01-0.1c-0.01-0.07-0.04-0.12-0.07-0.16 c-0.04-0.03-0.09-0.03-0.18,0.02c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.14-0.04,0.22c0,0.02,0,0.06,0,0.11 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.1,0.01,0.15c0.01,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16 c0.04,0.03,0.1,0.03,0.18-0.02c0.08-0.05,0.14-0.11,0.17-0.18C240.32,310.1,240.33,310.03,240.33,309.95z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4005_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M243.34,310.98c-0.36,1.83-1.04,3.64-1.97,5.25c-0.17,0.29-0.35,0.58-0.53,0.86 c-0.99,1.49-2.2,2.75-3.53,3.6c-0.12,0.07-0.23,0.16-0.35,0.22c-0.12,0.07-0.23,0.12-0.35,0.18 c-1.34,0.69-2.62,0.87-3.73,0.59c-0.21-0.05-0.41-0.12-0.6-0.2c-1.07-0.45-1.94-1.37-2.51-2.67 c-0.1-0.23-0.19-0.47-0.28-0.73c-0.22-0.69-0.37-1.45-0.43-2.29c-0.06-0.85-0.02-1.72,0.1-2.6 c0.04-0.33,0.09-0.65,0.16-0.98c0.36-1.83,1.04-3.64,1.97-5.25c0.17-0.29,0.35-0.58,0.53-0.86c0.99-1.49,2.2-2.75,3.53-3.6 l-0.25-3.61c-1.94,1.21-3.7,3.05-5.13,5.25c-0.18,0.28-0.36,0.57-0.53,0.86c-1.37,2.33-2.38,4.97-2.87,7.64 c-0.06,0.33-0.11,0.65-0.16,0.98c-0.18,1.28-0.23,2.55-0.15,3.79c0.08,1.23,0.3,2.35,0.63,3.33 c0.08,0.25,0.17,0.5,0.27,0.73c0.81,1.91,2.09,3.24,3.66,3.87c0.2,0.08,0.4,0.15,0.6,0.21c1.61,0.44,3.47,0.19,5.43-0.85 c0.12-0.06,0.23-0.12,0.35-0.19c0.12-0.07,0.23-0.14,0.35-0.21c1.94-1.21,3.7-3.05,5.13-5.25c0.18-0.28,0.36-0.57,0.53-0.86 c1.37-2.33,2.38-4.97,2.88-7.64L243.34,310.98z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4007_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M246.32,301.87c-0.08-0.25-0.17-0.5-0.27-0.73c-0.86-2.05-2.23-3.47-3.91-4.13 c-0.2-0.08-0.4-0.15-0.6-0.21c-1.71-0.47-3.71-0.21-5.8,0.91l0.05,0.78l0.25,3.61l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53 c0.21,0.05,0.41,0.11,0.6,0.2c0.96,0.41,1.74,1.24,2.25,2.4c0.1,0.23,0.19,0.47,0.27,0.73c0.19,0.62,0.33,1.3,0.38,2.06 c0.05,0.76,0.02,1.54-0.08,2.33l0.62-0.1l2.75-0.43l0.59-0.09c0.19-1.36,0.25-2.72,0.16-4.04 C246.91,304.11,246.67,302.92,246.32,301.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4006_",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M246.32,301.87c-0.08-0.25-0.17-0.5-0.27-0.73c-0.86-2.05-2.23-3.47-3.91-4.13 c-0.2-0.08-0.4-0.15-0.6-0.21c-1.71-0.47-3.71-0.21-5.8,0.91l0.05,0.78l0.25,3.61l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53 c0.21,0.05,0.41,0.11,0.6,0.2c0.96,0.41,1.74,1.24,2.25,2.4c0.1,0.23,0.19,0.47,0.27,0.73c0.19,0.62,0.33,1.3,0.38,2.06 c0.05,0.76,0.02,1.54-0.08,2.33l0.62-0.1l2.75-0.43l0.59-0.09c0.19-1.36,0.25-2.72,0.16-4.04 C246.91,304.11,246.67,302.92,246.32,301.87z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3987_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M206.23,328.1c0.08-0.14,0.13-0.26,0.15-0.37c0.02-0.11,0.02-0.2,0.02-0.28 c-0.01-0.15-0.05-0.26-0.13-0.32c-0.08-0.06-0.2-0.05-0.37,0.05c-0.16,0.09-0.27,0.21-0.34,0.35 c-0.07,0.14-0.11,0.3-0.13,0.48c-0.01,0.05-0.02,0.1-0.05,0.14c-0.02,0.04-0.05,0.07-0.08,0.08l-0.34,0.2 c-0.03,0.02-0.06,0.02-0.09,0.01c-0.03-0.01-0.04-0.04-0.04-0.09c0-0.17,0.02-0.35,0.07-0.53c0.05-0.18,0.12-0.36,0.21-0.52 c0.09-0.17,0.2-0.32,0.32-0.46c0.13-0.14,0.26-0.25,0.41-0.34c0.18-0.1,0.34-0.16,0.48-0.16c0.14,0,0.26,0.03,0.35,0.1 c0.09,0.07,0.17,0.17,0.22,0.29c0.05,0.12,0.08,0.26,0.09,0.4c0.01,0.09,0.01,0.18,0.01,0.27c0,0.09-0.02,0.18-0.04,0.28 c-0.03,0.1-0.07,0.22-0.12,0.34c-0.06,0.13-0.13,0.27-0.22,0.43l-0.74,1.4l1.21-0.7c0.03-0.02,0.06-0.02,0.09,0 c0.03,0.02,0.04,0.05,0.04,0.09l0.03,0.39c0,0.04-0.01,0.08-0.03,0.13c-0.02,0.04-0.05,0.07-0.08,0.09l-2.03,1.17 c-0.03,0.02-0.06,0.02-0.09,0c-0.03-0.02-0.04-0.05-0.04-0.09l-0.02-0.34c0-0.06,0.01-0.13,0.03-0.19 c0.03-0.06,0.05-0.11,0.07-0.14L206.23,328.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M209.84,325.74c0.01,0.07,0.01,0.15,0.02,0.23c0.01,0.09,0.01,0.17,0.02,0.26 c0.01,0.09,0.01,0.18,0.02,0.26c0.01,0.09,0.01,0.16,0.01,0.24c0.01,0.22-0.01,0.43-0.04,0.64 c-0.03,0.21-0.08,0.41-0.17,0.59c-0.08,0.19-0.19,0.36-0.33,0.52c-0.14,0.16-0.32,0.3-0.53,0.42 c-0.21,0.12-0.4,0.19-0.55,0.2c-0.15,0.01-0.28-0.03-0.38-0.11c-0.1-0.08-0.18-0.2-0.23-0.36 c-0.05-0.16-0.09-0.34-0.12-0.55c-0.02-0.14-0.03-0.3-0.04-0.48c-0.01-0.18-0.02-0.34-0.02-0.49 c-0.01-0.22,0-0.44,0.03-0.65c0.03-0.21,0.09-0.41,0.17-0.6c0.08-0.19,0.19-0.37,0.33-0.53c0.14-0.16,0.32-0.31,0.53-0.43 c0.21-0.12,0.39-0.19,0.54-0.19c0.15-0.01,0.28,0.03,0.38,0.11c0.1,0.08,0.18,0.2,0.23,0.36 C209.78,325.35,209.82,325.53,209.84,325.74z M208.16,327.71c0.03,0.26,0.1,0.44,0.19,0.54c0.09,0.1,0.24,0.09,0.45-0.03 c0.2-0.12,0.34-0.27,0.42-0.47c0.08-0.2,0.11-0.43,0.11-0.71c0-0.14-0.01-0.3-0.02-0.47c-0.01-0.17-0.03-0.32-0.04-0.46 c-0.03-0.26-0.1-0.44-0.19-0.53c-0.09-0.1-0.24-0.09-0.45,0.03c-0.2,0.12-0.34,0.27-0.42,0.47 c-0.08,0.2-0.11,0.43-0.11,0.71c0,0.14,0.01,0.3,0.02,0.47C208.13,327.42,208.14,327.58,208.16,327.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M210.82,323.64c0.11-0.06,0.2-0.09,0.28-0.1c0.08,0,0.15,0.01,0.21,0.05 c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.05,0.14,0.07,0.23c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31 c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22 c-0.11,0.06-0.2,0.1-0.28,0.1c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15 c-0.03-0.07-0.06-0.14-0.07-0.22c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28 c0.02-0.1,0.06-0.2,0.11-0.29c0.05-0.1,0.11-0.19,0.19-0.27C210.62,323.78,210.71,323.7,210.82,323.64z M212.56,322.77 c0.02-0.05,0.04-0.08,0.06-0.11c0.02-0.03,0.05-0.06,0.09-0.08l0.26-0.15c0.03-0.02,0.06-0.02,0.08-0.01 c0.02,0.01,0.03,0.03,0.03,0.06c0,0.01,0,0.02,0,0.03c0,0.01-0.01,0.03-0.01,0.04l-1.9,4.85c-0.02,0.05-0.04,0.08-0.06,0.11 c-0.02,0.03-0.05,0.06-0.09,0.08l-0.26,0.15c-0.03,0.02-0.06,0.02-0.08,0.01c-0.02-0.01-0.03-0.03-0.03-0.06 c0-0.01,0-0.02,0-0.03c0-0.01,0.01-0.03,0.01-0.04L212.56,322.77z M211.13,324.77c0-0.02,0-0.06,0-0.11 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16 c-0.04-0.03-0.09-0.03-0.18,0.02c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.15-0.04,0.22c0,0.02,0,0.06,0,0.11 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16 c0.04,0.03,0.1,0.03,0.18-0.02c0.08-0.05,0.14-0.11,0.17-0.18C211.12,324.92,211.13,324.84,211.13,324.77z M212.83,324.51 c0.11-0.06,0.2-0.09,0.28-0.1s0.15,0.01,0.21,0.05c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.23 c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29 c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22c-0.11,0.06-0.2,0.1-0.28,0.1 c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15c-0.03-0.07-0.05-0.14-0.07-0.22 c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28c0.02-0.1,0.06-0.2,0.11-0.29 c0.05-0.1,0.11-0.19,0.19-0.27C212.63,324.64,212.72,324.57,212.83,324.51z M213.14,325.63c0-0.02,0-0.06,0-0.11 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.1-0.01-0.15s-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16 c-0.04-0.03-0.09-0.03-0.18,0.02c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.15-0.04,0.22c0,0.02,0,0.06,0,0.11 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.1,0.01,0.15c0.01,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16 c0.04,0.03,0.1,0.03,0.18-0.02c0.08-0.05,0.14-0.11,0.17-0.18C213.13,325.79,213.14,325.71,213.14,325.63z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4002_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M218.62,318.11l-2.6,2.66c0.22,0.68,0.37,1.45,0.43,2.29c0.06,0.85,0.02,1.72-0.1,2.6 c-0.04,0.33-0.1,0.65-0.16,0.98c-0.36,1.83-1.04,3.64-1.97,5.25c-0.17,0.29-0.35,0.58-0.53,0.86 c-0.99,1.49-2.2,2.75-3.52,3.6c-0.12,0.07-0.23,0.16-0.35,0.23c-0.12,0.07-0.23,0.12-0.35,0.18 c-1.34,0.69-2.62,0.87-3.73,0.59c-0.21-0.05-0.41-0.12-0.6-0.2c-1.07-0.45-1.94-1.37-2.51-2.67 c-0.1-0.23-0.19-0.47-0.28-0.73c-0.22-0.69-0.37-1.45-0.43-2.29s-0.02-1.72,0.1-2.6c0.04-0.33,0.09-0.65,0.16-0.98 c0.36-1.83,1.04-3.64,1.97-5.25c0.17-0.29,0.35-0.58,0.53-0.86c0.99-1.49,2.2-2.75,3.53-3.6l-0.25-3.61 c-1.94,1.21-3.7,3.05-5.13,5.25c-0.18,0.28-0.36,0.57-0.53,0.86c-1.37,2.33-2.38,4.97-2.87,7.64 c-0.06,0.33-0.11,0.65-0.16,0.98c-0.18,1.28-0.23,2.55-0.15,3.79c0.08,1.23,0.3,2.35,0.63,3.33 c0.08,0.25,0.17,0.5,0.27,0.73c0.81,1.91,2.09,3.24,3.66,3.87c0.2,0.08,0.4,0.15,0.6,0.21c1.61,0.44,3.47,0.19,5.43-0.85 c0.12-0.06,0.23-0.12,0.35-0.19c0.12-0.07,0.23-0.14,0.35-0.21c1.94-1.21,3.7-3.05,5.13-5.25c0.18-0.28,0.36-0.57,0.53-0.86 c1.37-2.33,2.38-4.97,2.88-7.64c0.06-0.33,0.11-0.65,0.16-0.98c0.18-1.28,0.23-2.55,0.15-3.79 C219.17,320.21,218.95,319.1,218.62,318.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4003_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M215,312.67c-0.2-0.08-0.4-0.15-0.6-0.21c-1.71-0.47-3.71-0.21-5.8,0.91l0.05,0.78l0.25,3.61 l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53c0.21,0.05,0.41,0.11,0.6,0.2c0.96,0.41,1.74,1.24,2.25,2.4l0.58-0.6l2.6-2.66 l0.56-0.58C218.05,314.76,216.68,313.34,215,312.67z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3983_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M177.9,343.98c-0.02-0.02-0.03-0.05-0.03-0.1c0-0.04,0.01-0.09,0.04-0.13l0.88-1.5 c0.02-0.03,0.04-0.07,0.07-0.1s0.05-0.06,0.08-0.08l0.34-0.2c0.03-0.02,0.06-0.02,0.09,0c0.03,0.02,0.04,0.05,0.04,0.09 l0.25,3.59c0,0.04-0.01,0.08-0.03,0.13c-0.02,0.04-0.05,0.07-0.08,0.09l-0.35,0.2c-0.03,0.02-0.06,0.02-0.09,0 c-0.02-0.02-0.04-0.05-0.04-0.09l-0.19-2.75l-0.57,0.97c-0.02,0.04-0.05,0.07-0.08,0.08c-0.03,0.01-0.06,0.01-0.08-0.01 L177.9,343.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M182.37,341.6c0.01,0.07,0.01,0.15,0.02,0.23c0.01,0.09,0.01,0.17,0.02,0.26 c0.01,0.09,0.01,0.18,0.02,0.26c0.01,0.09,0.01,0.16,0.01,0.24c0.01,0.22-0.01,0.43-0.04,0.64 c-0.03,0.21-0.08,0.41-0.17,0.59c-0.08,0.19-0.19,0.36-0.33,0.52c-0.14,0.16-0.32,0.3-0.53,0.42 c-0.21,0.12-0.4,0.19-0.55,0.2c-0.15,0.01-0.28-0.03-0.37-0.11c-0.1-0.08-0.18-0.2-0.23-0.36 c-0.05-0.16-0.09-0.34-0.12-0.55c-0.02-0.14-0.03-0.3-0.04-0.48c-0.01-0.18-0.02-0.34-0.02-0.49 c-0.01-0.22,0-0.44,0.03-0.65c0.03-0.21,0.08-0.41,0.17-0.6c0.08-0.19,0.19-0.37,0.33-0.53c0.14-0.16,0.32-0.31,0.53-0.43 c0.21-0.12,0.39-0.19,0.54-0.19c0.15-0.01,0.28,0.03,0.38,0.11c0.1,0.08,0.18,0.2,0.23,0.36 C182.3,341.21,182.34,341.39,182.37,341.6z M180.68,343.58c0.03,0.26,0.1,0.44,0.19,0.54c0.09,0.1,0.24,0.09,0.45-0.03 c0.2-0.12,0.34-0.27,0.42-0.47c0.08-0.2,0.11-0.43,0.11-0.71c0-0.14-0.01-0.3-0.02-0.47c-0.01-0.17-0.03-0.32-0.04-0.46 c-0.03-0.26-0.1-0.44-0.19-0.53c-0.09-0.1-0.24-0.09-0.45,0.03c-0.2,0.12-0.34,0.27-0.42,0.47 c-0.08,0.2-0.11,0.43-0.11,0.71c0,0.14,0.01,0.3,0.02,0.47C180.65,343.28,180.67,343.44,180.68,343.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M183.34,339.5c0.11-0.06,0.2-0.09,0.28-0.1c0.08,0,0.15,0.01,0.21,0.05 c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.05,0.14,0.07,0.23c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31 c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22 c-0.11,0.06-0.2,0.1-0.28,0.1c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15 c-0.03-0.07-0.05-0.14-0.07-0.22c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28 c0.02-0.1,0.06-0.2,0.11-0.29c0.05-0.1,0.11-0.19,0.19-0.27C183.14,339.64,183.23,339.57,183.34,339.5z M185.09,338.63 c0.02-0.05,0.04-0.08,0.06-0.11c0.02-0.03,0.05-0.06,0.09-0.08l0.26-0.15c0.03-0.02,0.06-0.02,0.08-0.01 c0.02,0.01,0.03,0.03,0.03,0.06c0,0.01,0,0.02,0,0.03c0,0.01-0.01,0.03-0.01,0.04l-1.9,4.85c-0.02,0.05-0.04,0.08-0.06,0.11 c-0.02,0.03-0.05,0.06-0.09,0.08l-0.26,0.15c-0.03,0.02-0.06,0.02-0.08,0.01c-0.02-0.01-0.03-0.03-0.03-0.06 c0-0.01,0-0.02,0-0.03c0-0.01,0-0.03,0.01-0.04L185.09,338.63z M183.66,340.63c0-0.02,0-0.06,0-0.11 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16 c-0.04-0.03-0.09-0.03-0.18,0.02c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.15-0.04,0.22c0,0.02,0,0.06,0,0.11 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16 c0.04,0.03,0.1,0.03,0.18-0.02c0.08-0.05,0.14-0.11,0.17-0.18C183.64,340.78,183.65,340.71,183.66,340.63z M185.35,340.37 c0.11-0.06,0.2-0.09,0.28-0.1c0.08,0,0.15,0.01,0.21,0.05c0.06,0.03,0.1,0.08,0.14,0.15c0.03,0.07,0.06,0.14,0.07,0.23 c0.01,0.09,0.02,0.19,0.03,0.3c0.01,0.11,0.01,0.21,0.01,0.31c0,0.09-0.01,0.18-0.03,0.28c-0.02,0.1-0.06,0.2-0.11,0.29 c-0.05,0.1-0.11,0.19-0.19,0.27c-0.08,0.08-0.17,0.16-0.27,0.22c-0.11,0.06-0.2,0.1-0.28,0.1 c-0.08,0.01-0.15-0.01-0.21-0.04c-0.06-0.03-0.1-0.08-0.14-0.15c-0.03-0.07-0.05-0.14-0.07-0.22 c-0.01-0.09-0.02-0.19-0.03-0.3c-0.01-0.11-0.01-0.21-0.01-0.31c0-0.09,0.01-0.18,0.03-0.28c0.02-0.1,0.06-0.2,0.11-0.29 c0.05-0.1,0.11-0.19,0.19-0.27C185.15,340.51,185.24,340.43,185.35,340.37z M185.67,341.5c0-0.02,0-0.06,0-0.11 c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.1-0.01-0.15c0-0.05-0.01-0.08-0.01-0.1c-0.01-0.07-0.03-0.12-0.07-0.16 c-0.04-0.03-0.09-0.03-0.18,0.02c-0.08,0.05-0.14,0.11-0.17,0.18c-0.03,0.07-0.04,0.15-0.04,0.22c0,0.02,0,0.06,0,0.11 c0,0.05,0.01,0.1,0.01,0.15c0,0.05,0.01,0.1,0.01,0.15c0.01,0.05,0.01,0.08,0.01,0.1c0.01,0.07,0.03,0.12,0.07,0.16 c0.04,0.03,0.1,0.03,0.18-0.02c0.08-0.05,0.14-0.11,0.17-0.18C185.65,341.65,185.67,341.57,185.67,341.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3984_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3986_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M181.47,329.05l0.05,0.78l0.25,3.61l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53l0.33-0.87 l1.45-3.87l0.32-0.84C185.55,327.66,183.56,327.93,181.47,329.05z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3985_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M181.47,329.05l0.05,0.78l0.25,3.61l0.06,0.81c1.2-0.61,2.35-0.77,3.35-0.53l0.33-0.87 l1.45-3.87l0.32-0.84C185.55,327.66,183.56,327.93,181.47,329.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M191.48,333.78c-0.08-0.25-0.17-0.5-0.27-0.73c-0.81-1.91-2.09-3.24-3.66-3.87l-1.45,3.86 c1.07,0.45,1.94,1.37,2.51,2.67c0.1,0.23,0.19,0.47,0.27,0.73c0.22,0.69,0.37,1.45,0.43,2.29c0.06,0.85,0.02,1.72-0.1,2.6 c-0.04,0.33-0.09,0.65-0.16,0.98c-0.36,1.83-1.04,3.64-1.97,5.25c-0.17,0.29-0.35,0.58-0.53,0.86 c-0.99,1.49-2.2,2.75-3.53,3.6c-0.12,0.07-0.23,0.16-0.35,0.23c-0.12,0.07-0.23,0.12-0.35,0.18 c-1.34,0.69-2.62,0.87-3.73,0.59c-0.21-0.05-0.41-0.12-0.6-0.2c-1.07-0.45-1.94-1.37-2.51-2.67 c-0.1-0.23-0.19-0.47-0.28-0.73c-0.22-0.69-0.37-1.45-0.43-2.29c-0.06-0.85-0.02-1.72,0.1-2.6 c0.04-0.33,0.09-0.65,0.16-0.98c0.36-1.83,1.04-3.64,1.97-5.25c0.17-0.29,0.35-0.58,0.53-0.86c0.99-1.49,2.2-2.75,3.53-3.6 l-0.25-3.61c-1.94,1.21-3.7,3.05-5.13,5.25c-0.18,0.28-0.36,0.57-0.53,0.86c-1.37,2.33-2.38,4.97-2.87,7.64 c-0.06,0.33-0.11,0.65-0.16,0.98c-0.18,1.28-0.23,2.55-0.15,3.79c0.08,1.23,0.3,2.35,0.63,3.33 c0.08,0.25,0.17,0.5,0.27,0.73c0.81,1.91,2.09,3.24,3.66,3.87c0.2,0.08,0.4,0.15,0.6,0.21c1.61,0.44,3.47,0.19,5.43-0.85 c0.12-0.06,0.23-0.12,0.35-0.19c0.12-0.07,0.23-0.14,0.35-0.21c1.94-1.21,3.7-3.05,5.13-5.25c0.18-0.28,0.36-0.57,0.53-0.86 c1.37-2.33,2.38-4.97,2.88-7.64c0.06-0.33,0.11-0.65,0.16-0.98c0.18-1.28,0.23-2.55,0.15-3.79 C192.03,335.88,191.81,334.77,191.48,333.78z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.01,298.62l-142.73,82.4c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l142.73-82.4c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12C311.62,297.88,311.36,298.41,311.01,298.62z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M311.32,303.18l-142.73,82.4c-0.35,0.2-0.66,0-0.69-0.45l-0.01-0.12 c-0.03-0.45,0.23-0.98,0.58-1.19l142.73-82.4c0.35-0.2,0.66,0,0.69,0.45l0.01,0.12C311.93,302.44,311.67,302.98,311.32,303.18z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M312.92,181.63l-4.06-2.34l-159.31,91.95c-1.17,0.68-2.12,2.08-2.44,3.46 c-0.04,0.17-0.07,0.33-0.09,0.5c-0.02,0.15-0.03,0.31-0.03,0.46c0,0.07,0.01,0.15,0.01,0.23l0.41,5.98l4.07,2.35l162.06-93.56 L312.92,181.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M312.92,181.63l-159.3,91.96c-0.89,0.51-1.66,1.45-2.11,2.47l-4.06-2.35 c-0.15,0.32-0.26,0.66-0.34,0.99c0.32-1.38,1.27-2.78,2.44-3.46l159.31-91.95L312.92,181.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.07,278.23l0.41,5.99l-4.07-2.35l-0.41-5.98c0-0.08-0.01-0.16-0.01-0.23 c0-0.15,0.01-0.31,0.03-0.46c0.02-0.17,0.05-0.33,0.09-0.5c0.08-0.33,0.18-0.68,0.33-1l4.07,2.36 C151.19,276.78,151.02,277.54,151.07,278.23z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Magnifying_glass"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glass_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glass_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Magnifying_glass_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3656_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3662_",
    style: {
      fill: "#BA68C8"
    },
    d: "M283.78,102.8L283.78,102.8L283.78,102.8c-0.47-0.48-0.62-1.27-0.34-2.26 c0.56-1.97,2.62-3.99,4.61-4.49c0.99-0.25,1.78-0.08,2.25,0.4l0,0l0,0l28.15,26.65l0,0c0.73,0.66,0.99,1.8,0.58,3.25 c-0.78,2.76-3.66,5.57-6.44,6.28c-1.46,0.37-2.59,0.08-3.24-0.67l-0.01,0.01L283.78,102.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3660_",
    style: {
      fill: "#BA68C8"
    },
    d: "M288.04,96.05c1.99-0.51,3.15,0.69,2.59,2.66c-0.56,1.98-2.62,3.99-4.61,4.49 c-1.99,0.51-3.15-0.69-2.59-2.66C283.99,98.56,286.06,96.55,288.04,96.05z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3659_",
    d: "M288.04,96.05c1.99-0.51,3.15,0.69,2.59,2.66c-0.56,1.98-2.62,3.99-4.61,4.49 c-1.99,0.51-3.15-0.69-2.59-2.66C283.99,98.56,286.06,96.55,288.04,96.05z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3658_",
    style: {
      fill: "#37474F"
    },
    d: "M275.89,91c0.34-1.19,1.58-2.41,2.79-2.72c0.6-0.15,1.08-0.05,1.36,0.24l0,0 l8.97,9.18l0,0c0.28,0.29,0.38,0.77,0.21,1.37c-0.34,1.19-1.58,2.41-2.79,2.72c-0.6,0.15-1.08,0.05-1.36-0.24l-8.97-9.18l0,0 C275.81,92.08,275.72,91.6,275.89,91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M278.67,88.28c-0.16,0.04-0.31,0.1-0.47,0.16c-0.02,0.01-0.05,0.03-0.07,0.04 c-0.13,0.06-0.26,0.13-0.39,0.21c-0.01,0.01-0.02,0.01-0.03,0.02c-0.85,0.53-1.58,1.41-1.82,2.28 c-0.17,0.6-0.08,1.08,0.21,1.37l2.15,2.2c0.76-0.5,1.48-1.08,2.16-1.75l7.93,7.74c0.41-0.45,0.74-0.97,0.89-1.49 c0.17-0.6,0.08-1.08-0.21-1.37l0,0l-8.97-9.18l0,0C279.75,88.23,279.27,88.13,278.67,88.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3657_",
    style: {
      fill: "#BA68C8"
    },
    d: "M289.74,100.49l28.41,27.77c0.38-0.62,0.69-1.27,0.87-1.92 c0.41-1.45,0.15-2.59-0.59-3.25l0.01,0L290.3,96.45c0.47,0.49,0.62,1.27,0.34,2.26C290.46,99.31,290.15,99.92,289.74,100.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3644_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M289.74,100.49l28.41,27.77c0.38-0.62,0.69-1.27,0.87-1.92 c0.41-1.45,0.15-2.59-0.59-3.25l0.01,0L290.3,96.45c0.47,0.49,0.62,1.27,0.34,2.26C290.46,99.31,290.15,99.92,289.74,100.49z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1409_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3653_",
    style: {
      fill: "#BA68C8"
    },
    d: "M249.26,107.26c4.54,2.62,10.82,2.24,17.76-1.76 c13.87-8.01,25.11-27.48,25.11-43.49c0-8.01-2.81-13.63-7.35-16.26l0,0l-5.1-2.95c-4.54-2.62-10.82-2.24-17.76,1.76 c-13.87,8.01-25.11,27.48-25.11,43.5c0,8.01,2.81,13.63,7.35,16.26L249.26,107.26L249.26,107.26z M288.7,62 c0,7.15-2.45,15.33-6.89,23.03c-4.45,7.7-10.31,13.91-16.5,17.49c-5.6,3.23-10.69,3.86-14.32,1.76 c-3.64-2.1-5.64-6.82-5.64-13.28c0-7.15,2.45-15.33,6.89-23.03c4.45-7.7,10.31-13.91,16.5-17.49c5.6-3.23,10.69-3.86,14.32-1.76 C286.69,50.82,288.7,55.54,288.7,62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3663_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M249.26,107.26c4.54,2.62,10.82,2.24,17.76-1.76 c13.87-8.01,25.11-27.48,25.11-43.49c0-8.01-2.81-13.63-7.35-16.26l0,0l-5.1-2.95c-4.54-2.62-10.82-2.24-17.76,1.76 c-13.87,8.01-25.11,27.48-25.11,43.5c0,8.01,2.81,13.63,7.35,16.26L249.26,107.26L249.26,107.26z M288.7,62 c0,7.15-2.45,15.33-6.89,23.03c-4.45,7.7-10.31,13.91-16.5,17.49c-5.6,3.23-10.69,3.86-14.32,1.76 c-3.64-2.1-5.64-6.82-5.64-13.28c0-7.15,2.45-15.33,6.89-23.03c4.45-7.7,10.31-13.91,16.5-17.49c5.6-3.23,10.69-3.86,14.32-1.76 C286.69,50.82,288.7,55.54,288.7,62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3647_",
    style: {
      fill: "#BA68C8"
    },
    d: "M267.02,47.5c-13.87,8.01-25.11,27.48-25.11,43.49 c0,16.01,11.24,22.51,25.11,14.5c13.87-8.01,25.11-27.48,25.11-43.49C292.13,45.99,280.89,39.5,267.02,47.5z M283.06,48.72 c3.64,2.1,5.64,6.82,5.64,13.28c0,7.15-2.45,15.33-6.89,23.03c-4.45,7.7-10.31,13.91-16.5,17.49c-5.6,3.23-10.69,3.86-14.32,1.76 c-3.64-2.1-5.64-6.82-5.64-13.28c0-7.15,2.45-15.33,6.89-23.03c4.45-7.7,10.31-13.91,16.5-17.49 C274.34,47.25,279.42,46.62,283.06,48.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3728_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M267.02,47.5c-13.87,8.01-25.11,27.48-25.11,43.49 c0,16.01,11.24,22.51,25.11,14.5c13.87-8.01,25.11-27.48,25.11-43.49C292.13,45.99,280.89,39.5,267.02,47.5z M283.06,48.72 c3.64,2.1,5.64,6.82,5.64,13.28c0,7.15-2.45,15.33-6.89,23.03c-4.45,7.7-10.31,13.91-16.5,17.49c-5.6,3.23-10.69,3.86-14.32,1.76 c-3.64-2.1-5.64-6.82-5.64-13.28c0-7.15,2.45-15.33,6.89-23.03c4.45-7.7,10.31-13.91,16.5-17.49 C274.34,47.25,279.42,46.62,283.06,48.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#BA68C8"
    },
    d: "M241.91,91c0-10.51,4.84-22.51,12.09-31.78c-0.02,0.02-0.04,0.05-0.06,0.07 l-5.08-2.95c-7.22,9.25-12.05,21.22-12.05,31.7c0,8.01,2.81,13.63,7.36,16.26l5.09,2.96v-0.01c0.09,0.05,0.18,0.1,0.27,0.15 C244.83,104.85,241.91,99.16,241.91,91z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3643_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3645_",
    style: {
      fill: "#BA68C8"
    },
    d: "M283.06,48.72c-1.43-0.82-3.07-1.22-4.88-1.22c1.41,2.44,2.15,5.73,2.14,9.67 c0,7.15-2.44,15.33-6.89,23.04c-4.44,7.7-10.31,13.91-16.5,17.48c-3.41,1.97-6.63,2.98-9.45,2.98c0.9,1.57,2.07,2.79,3.5,3.61 c3.63,2.1,8.72,1.47,14.33-1.76c6.19-3.57,12.05-9.79,16.49-17.48c4.45-7.7,6.9-15.89,6.9-23.03 C288.7,55.53,286.7,50.82,283.06,48.72z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3642_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M284.91,59.81c0,7.15-2.45,15.33-6.89,23.03 c-4.45,7.7-10.31,13.91-16.5,17.49c-4.62,2.67-8.89,3.55-12.28,2.61c-2.52-2.47-3.89-6.61-3.89-11.94 c0-7.15,2.45-15.33,6.89-23.03c4.45-7.7,10.31-13.91,16.5-17.49c4.62-2.67,8.89-3.55,12.28-2.61 C283.54,50.34,284.91,54.48,284.91,59.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M285.61,46.27c0.1,0.07,0.2,0.14,0.3,0.22c-0.01-0.01-0.02-0.01-0.02-0.01 c-0.16-0.12-0.32-0.23-0.48-0.34c-0.06-0.05-0.13-0.09-0.19-0.13c0.09,0.05,0.17,0.11,0.25,0.16 C285.51,46.2,285.55,46.23,285.61,46.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M286,46.56c0.08,0.05,0.15,0.11,0.21,0.17c-0.1-0.08-0.2-0.16-0.3-0.23 c-0.01-0.01-0.01-0.01-0.01-0.01C285.94,46.51,285.97,46.53,286,46.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M287.31,47.7L287.31,47.7c-0.15-0.14-0.29-0.28-0.44-0.42c0.1,0.09,0.19,0.17,0.27,0.26 C287.19,47.59,287.25,47.64,287.31,47.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Documents"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M431.72,282.64c-0.28,0-0.5,0.22-0.5,0.5v38.93l-32.25,18.62c-0.24,0.14-0.32,0.44-0.18,0.68 c0.09,0.16,0.26,0.25,0.43,0.25c0.09,0,0.17-0.02,0.25-0.07l32.5-18.76c0.15-0.09,0.25-0.25,0.25-0.43v-39.22 C432.22,282.86,432,282.64,431.72,282.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M431.72,282.64c-0.28,0-0.5,0.22-0.5,0.5v38.93l-32.25,18.62 c-0.24,0.14-0.32,0.44-0.18,0.68c0.09,0.16,0.26,0.25,0.43,0.25c0.09,0,0.17-0.02,0.25-0.07l32.5-18.76 c0.15-0.09,0.25-0.25,0.25-0.43v-39.22C432.22,282.86,432,282.64,431.72,282.64z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M429.69,284.31c0-1.3,0.91-2.87,2.03-3.52c1.12-0.65,2.03-0.12,2.03,1.17 c0,1.3-0.91,2.87-2.03,3.52C430.6,286.13,429.69,285.61,429.69,284.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Document_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sheet_7_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "338.34,91.48 336.27,90.29 428.98,36.76 431.05,37.95  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "431.05,37.95 431.05,180.34 338.3,233.89 338.34,91.48  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M430.55,38.81v141.25l-91.76,52.98l0.04-141.27L430.55,38.81 M431.05,37.95l-92.71,53.53 l-0.04,142.41l92.75-53.55V37.95L431.05,37.95z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "338.34,91.48 338.3,233.89 336.29,232.73 336.27,90.29 338.3,91.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Chart_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3980_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4016_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M357.01,130.1c0.04-0.03,0.08-0.03,0.12,0c0.03,0.02,0.05,0.07,0.05,0.13v0.55 c0,0.06-0.01,0.12-0.03,0.19c-0.02,0.07-0.04,0.16-0.07,0.27l-1.45,5.29c-0.02,0.06-0.04,0.12-0.07,0.17 c-0.03,0.06-0.07,0.1-0.12,0.13l-0.52,0.3c-0.05,0.03-0.09,0.03-0.12,0c-0.03-0.03-0.05-0.07-0.05-0.13 c0-0.02,0.01-0.06,0.02-0.11l1.45-5.3l-1.96,1.13c-0.04,0.03-0.08,0.03-0.12,0c-0.03-0.03-0.05-0.07-0.05-0.13V132 c0-0.06,0.02-0.12,0.05-0.19c0.03-0.06,0.07-0.11,0.12-0.13L357.01,130.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M361.07,129.94c0,0.1,0.01,0.22,0.01,0.35c0,0.13,0,0.26,0,0.39c0,0.13,0,0.26,0,0.39 c0,0.13,0,0.25-0.01,0.35c-0.01,0.33-0.05,0.65-0.11,0.96c-0.06,0.31-0.15,0.6-0.29,0.88c-0.13,0.28-0.3,0.54-0.51,0.77 c-0.21,0.24-0.47,0.44-0.77,0.62c-0.31,0.18-0.57,0.27-0.77,0.28c-0.21,0.01-0.38-0.05-0.51-0.18 c-0.13-0.13-0.23-0.31-0.29-0.55c-0.06-0.24-0.1-0.52-0.11-0.83c-0.01-0.21-0.01-0.44-0.01-0.71c0-0.27,0-0.51,0.01-0.73 c0.01-0.33,0.05-0.65,0.11-0.97c0.06-0.31,0.15-0.61,0.29-0.89c0.13-0.28,0.3-0.54,0.51-0.78c0.21-0.24,0.47-0.45,0.77-0.63 c0.3-0.18,0.56-0.27,0.77-0.28c0.21-0.01,0.38,0.05,0.51,0.18c0.13,0.12,0.23,0.31,0.29,0.55 C361.02,129.35,361.05,129.62,361.07,129.94z M358.55,132.83c0.02,0.39,0.09,0.66,0.22,0.8c0.12,0.15,0.33,0.14,0.62-0.03 c0.29-0.17,0.5-0.4,0.62-0.69c0.12-0.29,0.2-0.64,0.22-1.05c0.01-0.22,0.01-0.45,0.01-0.71c0-0.25,0-0.49-0.01-0.69 c-0.02-0.39-0.09-0.66-0.22-0.8c-0.12-0.15-0.33-0.14-0.62,0.03c-0.29,0.17-0.5,0.4-0.62,0.69c-0.12,0.29-0.2,0.64-0.22,1.05 c-0.01,0.22-0.01,0.45-0.01,0.71C358.54,132.39,358.54,132.62,358.55,132.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M362.61,126.83c0.15-0.09,0.29-0.14,0.4-0.14c0.11,0,0.21,0.02,0.28,0.07 c0.08,0.05,0.14,0.13,0.17,0.23c0.04,0.1,0.06,0.21,0.07,0.34c0.01,0.14,0.01,0.29,0.01,0.46c0,0.16,0,0.32-0.01,0.47 c-0.01,0.13-0.03,0.27-0.07,0.42c-0.04,0.15-0.1,0.29-0.17,0.43c-0.08,0.14-0.17,0.27-0.28,0.4 c-0.11,0.12-0.25,0.23-0.4,0.32c-0.15,0.09-0.29,0.14-0.4,0.14c-0.11,0-0.21-0.02-0.28-0.07c-0.08-0.05-0.14-0.13-0.18-0.23 c-0.04-0.1-0.06-0.21-0.07-0.34c-0.01-0.14-0.01-0.29-0.01-0.46c0-0.16,0-0.32,0.01-0.47c0.01-0.13,0.03-0.27,0.07-0.42 c0.04-0.15,0.1-0.29,0.18-0.43c0.08-0.14,0.17-0.28,0.28-0.4C362.33,127.02,362.46,126.92,362.61,126.83z M365.12,125.58 c0.03-0.07,0.06-0.13,0.09-0.17c0.03-0.05,0.08-0.08,0.14-0.12l0.37-0.22c0.05-0.03,0.08-0.03,0.11-0.02 c0.03,0.02,0.04,0.05,0.04,0.1c0,0.01,0,0.03-0.01,0.04c0,0.02-0.01,0.04-0.02,0.06l-3.09,7.19 c-0.03,0.07-0.06,0.12-0.09,0.17c-0.03,0.05-0.08,0.09-0.13,0.12l-0.38,0.22c-0.05,0.03-0.08,0.03-0.11,0.02 c-0.03-0.01-0.04-0.05-0.04-0.1c0-0.01,0-0.03,0.01-0.04c0-0.02,0.01-0.04,0.02-0.06L365.12,125.58z M362.94,128.52 c0-0.04,0.01-0.09,0.01-0.16c0-0.07,0-0.15,0-0.22c0-0.08,0-0.15,0-0.23c0-0.07,0-0.12-0.01-0.15 c-0.01-0.11-0.04-0.19-0.08-0.24c-0.04-0.05-0.13-0.04-0.25,0.03c-0.12,0.07-0.2,0.16-0.25,0.26 c-0.04,0.1-0.07,0.21-0.08,0.33c0,0.03-0.01,0.09-0.01,0.16c0,0.07,0,0.15,0,0.23c0,0.08,0,0.15,0,0.22 c0,0.07,0.01,0.12,0.01,0.15c0.01,0.11,0.04,0.18,0.08,0.24c0.05,0.05,0.13,0.04,0.25-0.03c0.12-0.07,0.2-0.16,0.25-0.26 C362.91,128.74,362.94,128.63,362.94,128.52z M365.32,128.19c0.15-0.09,0.29-0.14,0.4-0.14c0.11,0,0.21,0.02,0.28,0.07 c0.08,0.05,0.14,0.13,0.18,0.23c0.04,0.1,0.06,0.22,0.07,0.34c0.01,0.14,0.01,0.29,0.01,0.46c0,0.16,0,0.32-0.01,0.47 c-0.01,0.13-0.03,0.27-0.07,0.42c-0.04,0.15-0.1,0.29-0.18,0.43c-0.08,0.14-0.17,0.27-0.28,0.4 c-0.11,0.12-0.25,0.23-0.4,0.32c-0.15,0.09-0.29,0.14-0.4,0.14c-0.11,0.01-0.21-0.02-0.28-0.07 c-0.08-0.05-0.14-0.13-0.17-0.23c-0.04-0.1-0.06-0.22-0.07-0.34c-0.01-0.14-0.01-0.29-0.01-0.46c0-0.16,0-0.32,0.01-0.47 c0.01-0.13,0.03-0.27,0.07-0.42c0.04-0.15,0.1-0.29,0.17-0.43c0.08-0.14,0.17-0.28,0.28-0.4 C365.03,128.39,365.16,128.28,365.32,128.19z M365.65,129.88c0-0.03,0.01-0.09,0.01-0.16c0-0.07,0-0.15,0-0.22 c0-0.08,0-0.15,0-0.22c0-0.07,0-0.12-0.01-0.15c-0.01-0.1-0.04-0.18-0.08-0.24c-0.05-0.05-0.13-0.04-0.25,0.03 c-0.12,0.07-0.2,0.16-0.25,0.26c-0.05,0.1-0.07,0.21-0.08,0.33c-0.01,0.04-0.01,0.09-0.01,0.16c0,0.07,0,0.15,0,0.23 s0,0.15,0,0.22c0,0.07,0,0.12,0.01,0.15c0.01,0.11,0.03,0.19,0.08,0.24c0.04,0.05,0.13,0.04,0.25-0.03 c0.12-0.07,0.2-0.16,0.25-0.26C365.61,130.1,365.64,130,365.65,129.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4009_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M352.34,120.66c-2.26,3.5-3.99,7.62-4.87,11.75c-0.42,1.99-0.66,3.98-0.66,5.9 c0,1.93,0.23,3.65,0.66,5.15l3.33-3.37c-0.31-1.11-0.49-2.37-0.49-3.8c0-1.43,0.17-2.9,0.49-4.36 c0.65-3.06,1.93-6.09,3.6-8.68c1.64-2.53,3.64-4.64,5.82-5.89v-4.67C357.27,114.39,354.55,117.23,352.34,120.66z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4010_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M372.97,117.68c-0.88-3.12-2.61-5.23-4.87-6.12c-2.21-0.87-4.93-0.57-7.88,1.13v4.67 c2.18-1.26,4.18-1.47,5.82-0.83c1.67,0.66,2.95,2.21,3.6,4.52c0.31,1.11,0.49,2.37,0.49,3.8c0,1.43-0.17,2.9-0.49,4.36 c-0.65,3.06-1.93,6.09-3.6,8.68c-1.64,2.53-3.64,4.64-5.82,5.89c-2.18,1.26-4.18,1.47-5.82,0.83 c-1.67-0.66-2.95-2.21-3.6-4.52l-3.33,3.37c0.88,3.12,2.61,5.23,4.87,6.12c2.21,0.87,4.93,0.57,7.88-1.13 c2.95-1.7,5.67-4.54,7.88-7.97c2.26-3.5,3.99-7.62,4.87-11.75c0.42-1.99,0.66-3.98,0.66-5.9 C373.63,120.9,373.4,119.18,372.97,117.68z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Chart_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M356.86,178.76c-0.15,0.24-0.33,0.46-0.54,0.67c-0.21,0.2-0.43,0.37-0.67,0.51 c-0.29,0.17-0.55,0.27-0.76,0.3c-0.21,0.03-0.39,0.02-0.54-0.04c-0.14-0.06-0.25-0.16-0.33-0.3c-0.07-0.14-0.12-0.29-0.13-0.46 c0-0.07,0.01-0.13,0.05-0.19c0.04-0.06,0.08-0.11,0.12-0.13l0.49-0.28c0.04-0.02,0.08-0.03,0.1-0.01 c0.03,0.02,0.05,0.06,0.08,0.11c0.03,0.05,0.06,0.09,0.1,0.13c0.04,0.04,0.1,0.05,0.17,0.06c0.07,0.01,0.15,0,0.26-0.04 c0.1-0.03,0.23-0.09,0.38-0.18c0.25-0.15,0.46-0.33,0.62-0.56c0.16-0.23,0.24-0.46,0.24-0.71c0-0.25-0.08-0.38-0.24-0.4 c-0.16-0.02-0.36,0.05-0.62,0.19l-0.52,0.3c-0.05,0.03-0.09,0.03-0.12,0c-0.03-0.03-0.05-0.07-0.05-0.13V177 c0-0.06,0.01-0.13,0.05-0.2c0.03-0.07,0.06-0.13,0.09-0.19l0.87-1.73l-1.72,0.99c-0.05,0.03-0.08,0.03-0.12,0 c-0.03-0.03-0.05-0.07-0.05-0.13v-0.59c0-0.06,0.02-0.12,0.05-0.19c0.03-0.06,0.07-0.11,0.12-0.13l2.74-1.58 c0.04-0.03,0.08-0.03,0.12,0c0.03,0.03,0.05,0.07,0.05,0.13v0.59c0,0.06-0.01,0.13-0.05,0.2c-0.03,0.07-0.06,0.13-0.09,0.19 l-0.91,1.81c0.19-0.07,0.36-0.11,0.51-0.11c0.15,0,0.28,0.04,0.39,0.12c0.11,0.08,0.19,0.2,0.25,0.36 c0.06,0.16,0.09,0.36,0.09,0.6c0,0.29-0.04,0.57-0.13,0.84C357.13,178.26,357.01,178.52,356.86,178.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M358.88,177.91c-0.21,0.01-0.38-0.05-0.51-0.18c-0.13-0.13-0.23-0.31-0.29-0.55 c-0.06-0.24-0.1-0.52-0.11-0.83c-0.01-0.21-0.01-0.44-0.01-0.71c0-0.27,0-0.51,0.01-0.73c0.01-0.33,0.05-0.65,0.11-0.97 c0.06-0.31,0.16-0.61,0.29-0.89c0.13-0.28,0.3-0.54,0.51-0.78c0.21-0.24,0.46-0.45,0.77-0.63c0.21-0.12,0.39-0.19,0.55-0.23 v1.21c-0.13-0.09-0.3-0.09-0.55,0.06c-0.29,0.17-0.5,0.4-0.62,0.69c-0.12,0.29-0.2,0.64-0.22,1.05 c-0.01,0.21-0.01,0.45-0.01,0.71c0,0.26,0,0.49,0.01,0.69c0.02,0.39,0.09,0.66,0.22,0.8c0.12,0.15,0.33,0.14,0.62-0.03 c0.25-0.14,0.43-0.33,0.55-0.56v1.19c-0.16,0.15-0.34,0.29-0.55,0.41C359.35,177.81,359.09,177.9,358.88,177.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M360.28,175.9c0.12-0.29,0.2-0.64,0.21-1.05c0.01-0.22,0.01-0.45,0.01-0.71 c0-0.25,0-0.49-0.01-0.69c-0.02-0.39-0.09-0.66-0.21-0.8c-0.02-0.02-0.05-0.01-0.07-0.03v-1.21c0.07-0.02,0.15-0.04,0.22-0.05 c0.21-0.01,0.38,0.05,0.51,0.18c0.13,0.13,0.23,0.31,0.29,0.55c0.06,0.24,0.1,0.52,0.11,0.83c0,0.1,0.01,0.22,0.01,0.35 c0,0.13,0,0.26,0,0.39c0,0.13,0,0.26,0,0.39c0,0.13,0,0.25-0.01,0.35c-0.01,0.33-0.05,0.65-0.11,0.96 c-0.06,0.31-0.16,0.6-0.29,0.88c-0.13,0.28-0.3,0.53-0.51,0.77c-0.07,0.07-0.14,0.14-0.22,0.21v-1.19 C360.23,175.99,360.26,175.95,360.28,175.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M363.57,169.75c-0.08-0.05-0.17-0.08-0.28-0.07c-0.11,0-0.25,0.05-0.4,0.14 c-0.15,0.09-0.29,0.2-0.4,0.32c-0.11,0.12-0.21,0.26-0.28,0.4c-0.08,0.14-0.14,0.29-0.18,0.43c-0.04,0.15-0.06,0.29-0.07,0.42 c-0.01,0.15-0.01,0.31-0.01,0.47c0,0.16,0,0.32,0.01,0.46c0.01,0.12,0.03,0.23,0.07,0.34c0.04,0.1,0.1,0.18,0.18,0.23 c0.08,0.05,0.17,0.07,0.28,0.07c0.11-0.01,0.25-0.06,0.4-0.14c0.15-0.09,0.29-0.19,0.4-0.32c0.11-0.13,0.21-0.26,0.28-0.4 c0.08-0.14,0.14-0.29,0.17-0.43c0.04-0.15,0.06-0.29,0.07-0.42c0.01-0.15,0.01-0.31,0.01-0.47c0-0.16,0-0.32-0.01-0.46 c-0.01-0.12-0.03-0.23-0.07-0.34C363.7,169.88,363.65,169.8,363.57,169.75z M363.22,171.34c0,0.07,0,0.13-0.01,0.16 c-0.01,0.12-0.04,0.22-0.08,0.33c-0.04,0.1-0.13,0.19-0.25,0.26c-0.12,0.07-0.2,0.08-0.25,0.03c-0.04-0.05-0.07-0.13-0.08-0.24 c0-0.03-0.01-0.08-0.01-0.15c0-0.07,0-0.15,0-0.22c0-0.08,0-0.15,0-0.23c0-0.07,0.01-0.13,0.01-0.16 c0.01-0.12,0.04-0.23,0.08-0.33c0.05-0.11,0.13-0.19,0.25-0.26c0.12-0.07,0.2-0.08,0.25-0.03c0.05,0.05,0.07,0.13,0.08,0.24 c0,0.03,0.01,0.08,0.01,0.15c0,0.07,0,0.15,0,0.22C363.22,171.19,363.22,171.27,363.22,171.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M364.66,172.75c-0.01,0.15-0.01,0.31-0.01,0.47c0,0.16,0,0.32,0.01,0.45 c0.01,0.12,0.03,0.24,0.07,0.34c0.04,0.1,0.1,0.18,0.18,0.23c0.08,0.05,0.17,0.08,0.28,0.07c0.11-0.01,0.25-0.06,0.4-0.14 c0.15-0.09,0.29-0.2,0.4-0.32c0.11-0.12,0.21-0.26,0.28-0.4c0.08-0.14,0.14-0.29,0.18-0.43c0.04-0.15,0.06-0.29,0.07-0.42 c0.01-0.15,0.01-0.31,0.01-0.47c0-0.16,0-0.31-0.01-0.45c-0.01-0.12-0.03-0.24-0.07-0.34c-0.04-0.1-0.1-0.18-0.18-0.23 c-0.08-0.05-0.17-0.08-0.28-0.07c-0.11,0-0.25,0.05-0.4,0.14c-0.15,0.09-0.29,0.2-0.4,0.32c-0.11,0.12-0.21,0.26-0.28,0.4 c-0.08,0.14-0.14,0.29-0.18,0.43C364.69,172.48,364.67,172.62,364.66,172.75z M365.25,172.87c0-0.08,0-0.15,0-0.23 c0-0.07,0.01-0.13,0.01-0.16c0.01-0.11,0.04-0.23,0.08-0.33c0.04-0.1,0.13-0.19,0.25-0.26c0.12-0.07,0.2-0.08,0.25-0.03 c0.04,0.05,0.07,0.13,0.08,0.24c0,0.03,0.01,0.08,0.01,0.15c0,0.07,0,0.15,0,0.22c0,0.08,0,0.15,0,0.22 c0,0.07,0,0.13-0.01,0.16c-0.01,0.12-0.04,0.23-0.08,0.33c-0.05,0.11-0.13,0.19-0.25,0.26c-0.12,0.07-0.2,0.08-0.25,0.03 c-0.05-0.05-0.07-0.13-0.08-0.24c0-0.03-0.01-0.08-0.01-0.15C365.25,173.02,365.25,172.95,365.25,172.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M362.3,175.76l3.09-7.19c0.03-0.07,0.06-0.12,0.09-0.17c0.03-0.04,0.08-0.08,0.13-0.12 l0.38-0.22c0.05-0.03,0.08-0.03,0.11-0.02c0.03,0.02,0.04,0.05,0.04,0.1c0,0.01,0,0.03-0.01,0.04c0,0.02-0.01,0.04-0.02,0.06 l-3.09,7.19c-0.03,0.07-0.06,0.12-0.09,0.17c-0.03,0.05-0.08,0.09-0.13,0.12l-0.38,0.22c-0.04,0.03-0.08,0.03-0.11,0.02 c-0.03-0.01-0.04-0.05-0.04-0.1c0-0.01,0-0.03,0.01-0.05C362.29,175.8,362.3,175.78,362.3,175.76z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "360.22,160.5 360.21,160.51 360.21,155.84 360.22,155.83  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M370.13,167.99c0-1.43-0.17-2.69-0.49-3.8c-0.65-2.3-1.93-3.86-3.6-4.52 c-1.64-0.64-3.64-0.43-5.82,0.83v-4.67c2.95-1.7,5.67-2,7.88-1.13c2.26,0.89,3.99,3.01,4.87,6.12c0.42,1.5,0.66,3.22,0.66,5.15 c0,1.93-0.23,3.92-0.66,5.9l-3.33,0.48C369.95,170.89,370.13,169.42,370.13,167.99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BA68C8"
    },
    points: "360.22,186.92 360.22,191.59 360.21,191.6 360.21,186.93  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M352.34,163.8c-2.26,3.5-3.99,7.62-4.87,11.75c-0.42,1.99-0.66,3.98-0.66,5.9 c0,1.93,0.23,3.65,0.66,5.15c0.88,3.12,2.61,5.23,4.87,6.12c2.21,0.87,4.93,0.57,7.87-1.13v-4.67 c-2.17,1.25-4.18,1.46-5.81,0.82c-1.67-0.66-2.95-2.21-3.6-4.52c-0.31-1.11-0.49-2.37-0.49-3.8c0-1.43,0.17-2.9,0.49-4.36 c0.65-3.06,1.93-6.09,3.6-8.68c1.63-2.53,3.64-4.63,5.81-5.89v-4.67C357.27,157.54,354.55,160.38,352.34,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M369.64,172.35c-0.65,3.06-1.93,6.09-3.6,8.68c-1.64,2.53-3.64,4.64-5.82,5.89v4.67 c2.95-1.7,5.67-4.54,7.88-7.97c2.26-3.5,3.99-7.62,4.87-11.75L369.64,172.35z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Check_List_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.25,106.67c-0.07,0-0.13-0.02-0.19-0.05c-0.12-0.07-0.19-0.2-0.19-0.34v-7.26 c0-0.14,0.07-0.27,0.19-0.34l6.29-3.63c0.12-0.07,0.27-0.07,0.39,0c0.12,0.07,0.19,0.2,0.19,0.33l0,7.26 c0,0.14-0.07,0.27-0.19,0.33l-6.29,3.63C386.38,106.65,386.32,106.67,386.25,106.67z M386.64,99.24v6.37l5.52-3.18l0-6.37 L386.64,99.24z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check_2_",
    style: {
      fill: "#BA68C8"
    },
    d: "M393.28,93.57c-0.39-0.16-0.84,0.02-1,0.41l-2.88,6.86l-0.69-0.67 c-0.3-0.29-0.78-0.29-1.08,0.02c-0.29,0.3-0.29,0.79,0.02,1.08l1.49,1.45c0.14,0.14,0.33,0.22,0.53,0.22 c0.05,0,0.1,0,0.15-0.02c0.25-0.05,0.45-0.22,0.55-0.45l3.32-7.89C393.85,94.18,393.67,93.73,393.28,93.57z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M397.89,94.84l23.15-13.37c0.56-0.32,1.01-0.09,1.01,0.51c0,0.61-0.45,1.36-1.01,1.68 l-23.15,13.37c-0.56,0.32-1.01,0.09-1.01-0.51C396.88,95.91,397.33,95.16,397.89,94.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.25,117.57c-0.07,0-0.13-0.02-0.19-0.05c-0.12-0.07-0.19-0.2-0.19-0.34v-7.26 c0-0.14,0.07-0.27,0.19-0.33l6.29-3.63c0.12-0.07,0.27-0.07,0.39,0c0.12,0.07,0.19,0.2,0.19,0.33v7.26 c0,0.14-0.07,0.27-0.19,0.34l-6.29,3.63C386.38,117.55,386.32,117.57,386.25,117.57z M386.64,110.14v6.37l5.52-3.18v-6.37 L386.64,110.14z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check_1_",
    style: {
      fill: "#BA68C8"
    },
    d: "M393.28,104.46c-0.39-0.16-0.84,0.02-1,0.41l-2.88,6.86l-0.69-0.67 c-0.3-0.29-0.78-0.29-1.08,0.02c-0.29,0.3-0.29,0.79,0.02,1.08l1.49,1.45c0.14,0.14,0.33,0.22,0.53,0.22 c0.05,0,0.1,0,0.15-0.01c0.25-0.05,0.45-0.22,0.55-0.45l3.32-7.89C393.85,105.07,393.67,104.63,393.28,104.46z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M397.89,105.7l23.15-13.37c0.56-0.32,1.01-0.09,1.01,0.51s-0.45,1.36-1.01,1.68l-23.15,13.37 c-0.56,0.32-1.01,0.09-1.01-0.51C396.88,106.77,397.33,106.02,397.89,105.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.25,128.47c-0.07,0-0.13-0.02-0.19-0.05c-0.12-0.07-0.19-0.2-0.19-0.33v-7.26 c0-0.14,0.07-0.27,0.19-0.34l6.29-3.63c0.12-0.07,0.27-0.07,0.39,0c0.12,0.07,0.19,0.2,0.19,0.33v7.26 c0,0.14-0.07,0.27-0.19,0.33l-6.29,3.63C386.38,128.45,386.32,128.47,386.25,128.47z M386.64,121.04v6.37l5.52-3.18v-6.37 L386.64,121.04z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check_3_",
    style: {
      fill: "#BA68C8"
    },
    d: "M393.28,115.36c-0.39-0.16-0.84,0.02-1,0.41l-2.88,6.86l-0.69-0.67 c-0.3-0.29-0.78-0.29-1.08,0.02c-0.29,0.3-0.29,0.79,0.02,1.08l1.49,1.45c0.14,0.14,0.33,0.22,0.53,0.22 c0.05,0,0.1,0,0.15-0.01c0.25-0.05,0.45-0.22,0.55-0.45l3.32-7.89C393.85,115.97,393.67,115.52,393.28,115.36z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M397.89,116.56l23.15-13.37c0.56-0.32,1.01-0.09,1.01,0.51c0,0.6-0.45,1.36-1.01,1.68 l-23.15,13.37c-0.56,0.32-1.01,0.09-1.01-0.51C396.88,117.64,397.33,116.89,397.89,116.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3979_",
    style: {
      fill: "#E0E0E0"
    },
    points: "389.32,174.39 385.58,176.55 385.58,134.73 389.32,132.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3978_",
    style: {
      fill: "#E0E0E0"
    },
    points: "395.92,170.58 392.18,172.74 392.18,130.92 395.92,128.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3977_",
    style: {
      fill: "#E0E0E0"
    },
    points: "402.52,166.77 398.78,168.93 398.78,127.11 402.52,124.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3976_",
    style: {
      fill: "#E0E0E0"
    },
    points: "409.12,162.96 405.38,165.12 405.38,123.3 409.12,121.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3974_",
    style: {
      fill: "#E0E0E0"
    },
    points: "415.72,159.14 411.98,161.3 411.98,119.49 415.72,117.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3973_",
    style: {
      fill: "#E0E0E0"
    },
    points: "422.33,155.33 418.58,157.49 418.58,115.67 422.33,113.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3972_",
    style: {
      fill: "#BA68C8"
    },
    points: "418.58,115.67 422.33,113.52 422.33,132.6 418.58,134.76  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3969_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3971_",
    style: {
      fill: "#BA68C8"
    },
    points: "385.58,143.86 389.32,141.7 389.32,165.05 385.58,167.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3970_",
    style: {
      opacity: 0.15
    },
    points: "385.58,167.21 389.32,165.05 389.32,174.39 385.58,176.55  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3966_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3968_",
    style: {
      fill: "#BA68C8"
    },
    points: "392.18,145.36 395.92,143.2 395.92,151.6 392.18,153.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3967_",
    style: {
      opacity: 0.15
    },
    points: "392.18,153.76 395.92,151.6 395.92,170.58 392.18,172.74  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3963_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3965_",
    style: {
      fill: "#BA68C8"
    },
    points: "398.78,130.61 402.52,128.45 402.52,135.78 398.78,137.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3964_",
    style: {
      opacity: 0.15
    },
    points: "398.78,137.94 402.52,135.78 402.52,166.77 398.78,168.93  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3960_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3962_",
    style: {
      fill: "#BA68C8"
    },
    points: "405.38,132.43 409.12,130.27 409.12,148.75 405.38,150.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3961_",
    style: {
      opacity: 0.15
    },
    points: "405.38,150.91 409.12,148.75 409.12,162.96 405.38,165.12  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3957_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3959_",
    style: {
      fill: "#BA68C8"
    },
    points: "411.98,136.12 415.72,133.96 415.72,141.78 411.98,143.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3958_",
    style: {
      opacity: 0.15
    },
    points: "411.98,143.94 415.72,141.78 415.72,159.14 411.98,161.3  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3955_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3956_",
    style: {
      opacity: 0.15
    },
    points: "418.58,134.76 422.33,132.6 422.33,155.33 418.58,157.49  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3943_",
    style: {
      fill: "#BA68C8"
    },
    points: "385.58,167.21 389.32,165.05 389.32,174.39 385.58,176.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3942_",
    style: {
      opacity: 0.2
    },
    points: "385.58,167.21 389.32,165.05 389.32,174.39 385.58,176.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3861_",
    style: {
      fill: "#BA68C8"
    },
    points: "392.18,153.76 395.92,151.6 395.92,170.58 392.18,172.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3857_",
    style: {
      opacity: 0.2
    },
    points: "392.18,153.76 395.92,151.6 395.92,170.58 392.18,172.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3784_",
    style: {
      fill: "#BA68C8"
    },
    points: "398.78,137.94 402.52,135.78 402.52,166.77 398.78,168.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3780_",
    style: {
      opacity: 0.2
    },
    points: "398.78,137.94 402.52,135.78 402.52,166.77 398.78,168.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3755_",
    style: {
      fill: "#BA68C8"
    },
    points: "405.38,150.91 409.12,148.75 409.12,162.96 405.38,165.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3754_",
    style: {
      opacity: 0.2
    },
    points: "405.38,150.91 409.12,148.75 409.12,162.96 405.38,165.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3753_",
    style: {
      fill: "#BA68C8"
    },
    points: "411.98,143.94 415.72,141.78 415.72,159.14 411.98,161.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3752_",
    style: {
      opacity: 0.2
    },
    points: "411.98,143.94 415.72,141.78 415.72,159.14 411.98,161.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3751_",
    style: {
      fill: "#BA68C8"
    },
    points: "418.58,134.76 422.33,132.6 422.33,155.33 418.58,157.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3749_",
    style: {
      opacity: 0.2
    },
    points: "418.58,134.76 422.33,132.6 422.33,155.33 418.58,157.49  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.09,102.07c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68L345.34,102C345.26,102.05,345.17,102.07,345.09,102.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.09,106.69c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C345.26,106.67,345.17,106.69,345.09,106.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.09,111.32c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C345.26,111.29,345.17,111.32,345.09,111.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.09,208.49c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C345.26,208.47,345.17,208.49,345.09,208.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.09,213.12c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C345.26,213.09,345.17,213.12,345.09,213.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M345.09,217.74c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C345.26,217.72,345.17,217.74,345.09,217.74z"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow",
    style: {
      opacity: 0.1
    },
    points: "431.05,180.34 431.05,118.52 369.14,154.27 369.12,216.09  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sheet_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "379.64,161.44 377.57,160.24 470.28,106.72 472.35,107.91  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "472.35,107.91 472.35,250.3 379.6,303.85 379.64,161.44  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M471.86,108.76v141.25l-91.76,52.98l0.04-141.27L471.86,108.76 M472.35,107.91l-92.71,53.53 l-0.04,142.41l92.75-53.55V107.91L472.35,107.91z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "379.64,161.44 379.6,303.85 377.59,302.69 377.57,160.24 379.6,161.41  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3661_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M392.78,259.55l-4.15,2.4c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.39c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C393.25,259.56,393.04,259.4,392.78,259.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M401.79,254.35l-4.15,2.39c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.4c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C402.26,254.36,402.05,254.2,401.79,254.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M410.8,249.15l-4.15,2.39c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.39c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C411.27,249.16,411.06,249,410.8,249.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M419.8,243.95l-4.15,2.39c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.4c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C420.28,243.96,420.06,243.8,419.8,243.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M428.81,238.75l-4.15,2.39c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.4c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C429.28,238.75,429.07,238.59,428.81,238.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M437.82,233.54l-4.15,2.39c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.4c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C438.29,233.55,438.08,233.39,437.82,233.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M446.82,228.34l-4.15,2.39c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.39c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C447.3,228.35,447.09,228.19,446.82,228.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M455.83,223.14l-4.15,2.4c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.4c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C456.3,223.15,456.09,222.99,455.83,223.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M464.84,217.94l-4.15,2.39c-0.26,0.15-0.47,0.56-0.47,0.9v0.09c0,0.35,0.21,0.51,0.47,0.36 l4.15-2.39c0.26-0.15,0.47-0.56,0.47-0.9v-0.09C465.31,217.95,465.1,217.79,464.84,217.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3954_",
    style: {
      fill: "#BA68C8"
    },
    points: "388.01,247.3 393.11,244.35 393.11,252.74 388.01,255.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3953_",
    style: {
      fill: "#BA68C8"
    },
    points: "397.01,233.45 402.11,230.51 402.11,247.54 397.01,250.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3731_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "397.01,233.45 402.11,230.51 402.11,247.54  397.01,250.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3952_",
    style: {
      fill: "#BA68C8"
    },
    points: "406.01,217.48 411.12,214.53 411.12,242.34 406.01,245.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3732_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: "406.01,217.48 411.12,214.53 411.12,242.34  406.01,245.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3951_",
    style: {
      fill: "#BA68C8"
    },
    points: "415.02,227.33 420.12,224.39 420.12,237.14 415.02,240.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3734_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    points: "415.02,227.33 420.12,224.39 420.12,237.14  415.02,240.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3950_",
    style: {
      fill: "#BA68C8"
    },
    points: "424.02,219.3 429.12,216.36 429.12,231.94 424.02,234.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3745_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "424.02,219.3 429.12,216.36 429.12,231.94  424.02,234.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3949_",
    style: {
      fill: "#BA68C8"
    },
    points: "433.03,209.29 438.13,206.34 438.13,226.74 433.03,229.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3948_",
    style: {
      fill: "#BA68C8"
    },
    points: "442.03,215.06 447.13,212.11 447.13,221.55 442.03,224.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3746_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: "442.03,215.06 447.13,212.11 447.13,221.55  442.03,224.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3947_",
    style: {
      fill: "#BA68C8"
    },
    points: "451.03,206.85 456.14,203.91 456.14,216.35 451.03,219.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3747_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "451.03,206.85 456.14,203.91 456.14,216.35  451.03,219.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3944_",
    style: {
      fill: "#BA68C8"
    },
    points: "460.04,199.66 465.14,196.71 465.14,211.15 460.04,214.09  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA68C8"
    },
    d: "M465.05,185.75c-5.64,11.94-13.09,15.42-17.76,14.78c-1.71-0.24-2.97-0.75-4.08-1.2 c-2.21-0.9-3.96-1.61-7.63,0.51c-2.36,1.36-4.31,3.87-6.2,6.3c-2.45,3.15-4.77,6.12-7.59,5.85c-1.98-0.19-3.38-1.63-4.72-3.03 c-2.08-2.16-4.23-4.38-8.5-1.92c-7.13,4.12-15.3,19.74-20.82,31.14l0.52,0.53c5.43-11.2,13.44-26.55,20.3-30.51 c3.95-2.28,5.9-0.26,7.96,1.87c1.4,1.45,2.84,2.95,4.96,3.15c3.13,0.3,5.6-2.86,8.2-6.21c1.82-2.33,3.7-4.75,5.89-6.01 c3.45-1.99,5.04-1.35,7.23-0.46c1.13,0.46,2.41,0.98,4.17,1.23c4.89,0.68,12.69-2.98,18.6-15.5L465.05,185.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M465.05,185.75c-5.64,11.94-13.09,15.42-17.76,14.78c-1.71-0.24-2.97-0.75-4.08-1.2 c-2.21-0.9-3.96-1.61-7.63,0.51c-2.36,1.36-4.31,3.87-6.2,6.3c-2.45,3.15-4.77,6.12-7.59,5.85c-1.98-0.19-3.38-1.63-4.72-3.03 c-2.08-2.16-4.23-4.38-8.5-1.92c-7.13,4.12-15.3,19.74-20.82,31.14l0.52,0.53c5.43-11.2,13.44-26.55,20.3-30.51 c3.95-2.28,5.9-0.26,7.96,1.87c1.4,1.45,2.84,2.95,4.96,3.15c3.13,0.3,5.6-2.86,8.2-6.21c1.82-2.33,3.7-4.75,5.89-6.01 c3.45-1.99,5.04-1.35,7.23-0.46c1.13,0.46,2.41,0.98,4.17,1.23c4.89,0.68,12.69-2.98,18.6-15.5L465.05,185.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.14,274.35c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C386.32,274.33,386.23,274.35,386.14,274.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.14,278.97c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C386.32,278.95,386.23,278.97,386.14,278.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.14,283.6c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l79.17-45.83 c0.23-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-79.17,45.83C386.32,283.58,386.23,283.6,386.14,283.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M386.04,171.1c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l40.62-23.45 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-40.62,23.45C386.21,171.08,386.13,171.1,386.04,171.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M386.04,175.79c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l60.93-35.18 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-60.93,35.18C386.21,175.77,386.12,175.79,386.04,175.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,185.17c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C386.21,185.15,386.12,185.17,386.04,185.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,189.86c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C386.21,189.84,386.12,189.86,386.04,189.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,194.55c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C386.21,194.53,386.12,194.55,386.04,194.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,199.24c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C386.21,199.22,386.12,199.24,386.04,199.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,203.93c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C386.21,203.91,386.12,203.93,386.04,203.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,208.62c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C386.21,208.6,386.12,208.62,386.04,208.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M386.04,213.31c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C386.21,213.29,386.12,213.31,386.04,213.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.4,160.73c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C428.57,160.71,428.49,160.73,428.4,160.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.4,165.42c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C428.57,165.4,428.49,165.42,428.4,165.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.4,170.11c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C428.57,170.09,428.49,170.11,428.4,170.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.4,174.8c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C428.57,174.78,428.49,174.8,428.4,174.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.4,179.49c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C428.57,179.47,428.49,179.49,428.4,179.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.4,184.18c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C428.57,184.16,428.49,184.18,428.4,184.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M428.4,188.87c-0.17,0-0.34-0.09-0.43-0.25c-0.14-0.24-0.06-0.54,0.18-0.68l36.56-21.11 c0.24-0.14,0.54-0.06,0.68,0.18c0.14,0.24,0.06,0.54-0.18,0.68l-36.56,21.11C428.57,188.85,428.49,188.87,428.4,188.87z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacenter);
export default __webpack_public_path__ + "static/media/datacenter.0519b8250a8b38fe5c1b7c3dd4501b38.svg";
export { ForwardRef as ReactComponent };